import { setToken, hdrAuth } from "./lib/auth"
import React, { useState, useEffect } from "react"
import { supabase } from "./supabase"
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"
import { GOAL_WEIGHTS, pilarPerspectiva, scorePremium, BTC_ETFS } from "./lib/constantes"
import { scoreConfluence, scoreExhaustion, scoreAvancado, scoreOversold, scoreDca } from "./lib/score"
import { numBR, resultadoRealizado } from "./lib/realizado"
import { correlacaoResumo } from "./lib/contexto"
import { SYS_P3, SYS_BASICO, SEM_METRICAS, REGRAS_ESTRESSE, PREAMBULO_ANALISTA } from "./lib/prosa"
import { APP_VERSION } from "./version"
import { s } from "./estilos"
import { REGUAS, reguaAtual } from "./lib/regua"
import { Logo, ChartLine, MCCone } from "./componentes"
import { recoveryTime } from "./lib/recovery"
import { scoreConfianca } from "./lib/confianca"

import TabPremium2 from "./TabPremium2"
import TabPremium4 from "./TabPremium4"
import TabPremium3 from "./TabPremium3"
import TabPremium from "./TabPremium"

import { rankingLocal } from "./lib/ranking"

import { vereditoScoresRegime, vereditoPorRegime, vereditoExaustao, vereditoContraBase, vereditoSeparacao, vereditoPremio }
  from "./lib/veredito"
import { API_URL, CLAUDE_MODEL, CG_KEY, PRICE_USD, PRICE_BRL, PRICE2_USD, PRICE2_BRL, media, PRICE3_USD, PRICE3_BRL, PRICE4_USD, PRICE4_BRL, PRICE5_USD, PRICE5_BRL, ETF_LIST, PERIODS, INDEX_PERIODS, INDEX_SIMPLE_KEYS, INDEX_SIMPLE_NAMES, INDEX_SIMPLE_TICKERS, INDEX_SIMPLE_CURRENCIES, INDEX_SIMPLE_API_KEYS, FUTURES_KEYS, FUTURES_NAMES, FUTURES_TICKERS, FUTURES_CURRENCIES, FUTURES_API_KEYS, MARKET_OPEN_MINUTES_ET, MARKET_CLOSE_MINUTES_ET, ACTIVE_TAB_STORAGE_KEY, APP_TABS, MENU_ABAS, URL_POLITICA, regimeDe } from "./lib/config"
import { contextoChat } from "./contextoChat"

// corretagem fixa por operacao: em aporte pequeno ela pesa mais que qualquer
// ganho de metrica. Taxa configuravel — se for 0, a linha nao aparece.

export default function App() {
  const [user, setUser] = useState(null)
  // ao recarregar, a tela ficava zerada ate os dados voltarem. Comeca com a
  // ultima copia conhecida e substitui quando a busca real chega
  const [positions, setPositions] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('claw_pos') || '[]') } catch (e) { return [] }
  })
  const [transactions, setTransactions] = useState([])
  const positionsRef = React.useRef([])
  const [userSymbols, setUserSymbols] = useState([])
  const [prices, setPrices] = useState({})
  const [indices, setIndices] = useState({})
  const [marketStatus, setMarketStatus] = useState({status:"closed", label:"Mercado fechado"})
  const [usdBrl, setUsdBrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [cryptoPrices, setCryptoPrices] = useState({})
  const [loadingCrypto, setLoadingCrypto] = useState(false)
  const [ocultarValores, setOcultarValores] = useState(() => localStorage.getItem("ocultar_valores") === "1")
  const mask = (txt) => ocultarValores ? "\u2022\u2022\u2022\u2022\u2022" : txt
  // o input espelhava techTicker/symbol e se apagava quando o texto batia com
  // um ticker da carteira: digitar MCD virava CD porque o "M" (Macy's) sumia
  const [txtTech, setTxtTech] = useState("")
  const [txtSym, setTxtSym] = useState("")
  const [tab, setTab] = useState(() => {
    try {
      const savedTab = localStorage.getItem(ACTIVE_TAB_STORAGE_KEY)
      return APP_TABS.has(savedTab) ? savedTab : "portfolio"
    } catch (_e) {
      console.warn("Unable to restore active tab from localStorage")
      return "portfolio"
    }
  })
  const [symbol, setSymbol] = useState("")
  const [exchange, setExchange] = useState("")
  const [spotAnalysis, setSpotAnalysis] = useState("")
  const [analyzingSpot, setAnalyzingSpot] = useState(false)
  const [posType, setPosType] = useState("etf")
  const [selectedPosition, setSelectedPosition] = useState(null)
  const [positionEntries, setPositionEntries] = useState([])
  const [loadingEntries, setLoadingEntries] = useState(false)
  const [qty, setQty] = useState("")
  const [avgPrice, setAvgPrice] = useState("")
  const [date, setDate] = useState("")
  const [analysis, setAnalysis] = useState("")
  const [analyzing, setAnalyzing] = useState(false)
  const [analysisCount, setAnalysisCount] = useState(() => {
    const saved = localStorage.getItem("analysisDate")
    const today = new Date().toDateString()
    if (saved === today) return parseInt(localStorage.getItem("analysisCount") || "0")
    return 0
  })
  const [chartData, setChartData] = useState([])
  const [chartPeriod, setChartPeriod] = useState("1mo")
  const [chartMoeda, setChartMoeda] = useState("USD")
  const [chartTicker] = useState("PORTFOLIO")
  const [loadingChart, setLoadingChart] = useState(false)
  const [marketChartTicker, setMarketChartTicker] = useState("")
  const [marketChartName, setMarketChartName] = useState("")
  const [marketChartPeriod, setMarketChartPeriod] = useState("1mo")
  const [marketChartData, setMarketChartData] = useState([])
  const [loadingMarketChart, setLoadingMarketChart] = useState(false)
  const [cryptoChartTicker, setCryptoChartTicker] = useState("")
  const [cryptoChartName, setCryptoChartName] = useState("")
  const [cryptoChartPeriod, setCryptoChartPeriod] = useState("1mo")
  const [cryptoChartData, setCryptoChartData] = useState([])
  const [loadingCryptoChart, setLoadingCryptoChart] = useState(false)
  const [indexChartTicker, setIndexChartTicker] = useState("")
  const [indexChartName, setIndexChartName] = useState("")
  const [indexChartCurrency, setIndexChartCurrency] = useState("$")
  const [indexChartPeriod, setIndexChartPeriod] = useState("1mo")
  const [indexChartData, setIndexChartData] = useState([])
  const [loadingIndexChart, setLoadingIndexChart] = useState(false)
  const [isPremium, setIsPremium] = useState(false)
  const [promoCode, setPromoCode] = useState("")
  const [promoError, setPromoError] = useState("")
  const [isPremium2, setIsPremium2] = useState(false)
  const [historico, setHistorico] = useState([])
  const [sparks, setSparks] = useState({})
  const [isPremium3, setIsPremium3] = useState(false)
  const [isPremium4, setIsPremium4] = useState(false)
  const [isPremium5, setIsPremium5] = useState(false)
  const [mcSnapshot, setMcSnapshot] = useState(() => JSON.parse(localStorage.getItem("mc_snapshot") || "null"))
  const [optimMode, setOptimMode] = useState("add")
  const [optimTicker, setOptimTicker] = useState("")
  const [optimAmount, setOptimAmount] = useState("")
  const [optimSellTicker, setOptimSellTicker] = useState("")
  const [optimSellPct, setOptimSellPct] = useState("")
  const [optimResult, setOptimResult] = useState(null)
  const [optimLoading, setOptimLoading] = useState(false)
  const [optimGoal, setOptimGoal] = useState("return")
  const [advTicker, setAdvTicker] = useState("")
  const [activeTooltip, setActiveTooltip] = useState(null)

  const INDICATOR_TIPS = {
    vwap: {name:"VWAP", tip:"Preço médio ponderado por volume — usado por institucionais como referência de preço justo."},
    anchored_vwap: {name:"Anchored VWAP", tip:"Preço médio desde um ponto de referência (90 dias). Abaixo = entrada cara."},
    adx: {name:"ADX", tip:"Força da tendência — não indica direção. Acima de 25 = tendência forte."},
    keltner: {name:"Keltner Channel", tip:"Canal de volatilidade. Preço fora do canal = movimento extremo."},
    obv: {name:"OBV", tip:"Acumulação de volume comprador vs vendedor. O selo mede o tamanho do saldo de dez pregões, não só o sinal dele: comprador ou vendedor quando entrou ou saiu mais de um dia de volume normal, equilibrado quando o saldo é menor que isso."},
    mfi: {name:"MFI", tip:"RSI que considera volume. Abaixo de 20 = sobrevendido com confirmação de volume."},
    ulcer: {name:"Ulcer Index", tip:"Nível de estresse do ativo baseado em drawdowns recentes. Quanto menor, melhor."},
    meiavida: {name:"Meia-vida do afastamento", tip:"Quando o preço se afasta da média de 50 dias, quantos dias costuma levar para desfazer METADE desse afastamento. Sai de uma regressão sobre um ano de pregões, e não é constante do ativo: alargar ou encurtar a janela muda o número — o FBTC deu 36 dias com seis meses de dados e 28 dias com um ano. ATENÇÃO para a leitura: o afastamento pode fechar sem o preço cair, porque a média de 50 dias vem subindo atrás dele. Devolver metade do esticão NÃO é previsão de queda, é a distância encurtando, e ela encurta pelos dois lados. Quando a regressão não encontra reversão, o campo diz sem reversão medida em vez de inventar prazo."},
  ker: {name:"Eficiência de Kaufman (KER)", tip:"Mede se o movimento dos últimos 10 pregões foi em linha reta ou andou e voltou: é a variação líquida dividida pela soma das variações diárias. Perto de 1 o preço foi direto; perto de 0 subiu e desceu sem sair do lugar. A partir de 0,60 é movimento limpo, até 0,30 é serrote, e o meio fica de fora da medição. Ele não diz direção, diz persistência. A regra que vai julgar se ele acrescenta foi escrita e datada em 16/10/2026, antes do primeiro número."},
  hurst: {name:"Hurst Exponent", tip:"Abaixo de 0.40, uma alta costuma ser seguida de queda, e uma queda de alta. Acima de 0.40, o próximo movimento não depende do anterior: não há padrão. Este cálculo raramente passa de 0.60, então 0.55 já é alto aqui. A nota do Advanced Score compara o número deste ativo com os dois últimos anos dele mesmo, não com a escala acima."},
    garch: {name:"GARCH", tip:"Volatilidade esperada para os próximos 5 dias. Quanto maior, mais oscilação esperada."},
    calmar: {name:"Calmar Ratio", tip:"Retorno anualizado dividido pelo pior drawdown. Quanto maior, melhor risco/retorno."},
    rsi: {name:"RSI", tip:"Índice de força relativa. Abaixo de 30 = sobrevendido; acima de 70 = sobrecomprado."},
    macd: {name:"MACD", tip:"Diferença entre médias móveis. Indica momentum e mudanças de tendência."},
    bollinger: {name:"Bollinger Bands", tip:"Canais de volatilidade. Preço fora das bandas = movimento extremo."},
    sharpe: {name:"Sharpe Ratio", tip:"Retorno ajustado pelo risco. Acima de 1 = bom; negativo = retorno não compensa o risco."},
    var: {name:"VaR", tip:"Perda máxima esperada em 95% dos dias. Ex: -2.5% significa que em 95% dos dias a perda não passa disso."},
    hhi: {name:"HHI", tip:"Índice de concentração. <0.15 = diversificado; 0.15-0.35 = moderado; >0.35 = muito concentrado."},
    beta: {name:"Beta", tip:"Sensibilidade ao mercado. Beta 1.5 = carteira oscila 50% mais que o S&P 500."},
    ichimoku: {name:"Ichimoku Cloud", tip:"Sistema japonês completo de tendência. Preço acima da nuvem = bullish; abaixo = bearish."},
    supertrend: {name:"Supertrend", tip:"Indicador de tendência baseado em ATR. Bullish = preço acima da linha; bearish = abaixo."},
    sma: {name:"SMA", tip:"Média móvel simples — todos os preços têm peso igual. SMA200 é a grande referência institucional."},
    atr: {name:"ATR", tip:"Amplitude média de variação diária. Alto ATR = ativo muito volátil."},
    calmar_port: {name:"Calmar Ratio", tip:"Retorno anual dividido pelo maior drawdown. Quanto maior, melhor eficiência ajustada ao risco."},
    sortino: {name:"Sortino Ratio", tip:"Como o Sharpe mas penaliza só a volatilidade negativa. Mais relevante para proteção de capital."},
    max_drawdown: {name:"Max Drawdown", tip:"Maior queda do pico ao vale. Ex: -12% significa que em algum momento a carteira caiu 12% do topo."},
    monte_carlo: {name:"Monte Carlo", tip:"Simula 20000 cenários de um ano com a volatilidade do seu histórico e deriva ZERO: mostra dispersão, não direção. O percentual no topo é a fração dos cenários que termina acima de hoje — descrição da simulação, não probabilidade do seu futuro. Fica abaixo de 50% mesmo sem viés nenhum, por arrasto de variância."},
    fibonacci: {name:"Fibonacci", tip:"Níveis de retração 0%-100% do range de 90 dias. 61.8% e 78.6% são os suportes mais fortes. 100% = mínimo do range."},
    ema: {name:"Médias Móveis", tip:"EMA9/21/50/200: médias exponenciais. Quando EMA9 > EMA21 > EMA50 = tendência de alta confirmada. EMA200 é referência institucional."},
  }
  const [advData, setAdvData] = useState(null)
  const [mtData, setMtData] = useState(null)
  const [mtLoading, setMtLoading] = useState(false)
  const [mtPrazo, setMtPrazo] = useState("diario")
  const [ewData, setEwData] = useState(null)
  const [ewLoading, setEwLoading] = useState(false)
  const [ewPrazo, setEwPrazo] = useState("diario")
  const [ewTicker, setEwTicker] = useState("")
  const [ewCart, setEwCart] = useState(null)
  const [ewCartLoading, setEwCartLoading] = useState(false)
  async function rodarCarteiraEw(prazo) {
                  const alvos = etfEnriched.filter(x => x.value > 0)
                  if (!alvos.length) { setEwCart({erro:"sem posição"}); return }
                  setEwCartLoading(true); setEwCart(null)
                  const linhas = []
                  for (const pos of alvos) {
                    try {
                      const res = await fetch(API_URL + "/technical-multi/" + pos.symbol + "?prazos=" + prazo, { headers: hdrAuth() })
                      const d = await res.json()
                      const pz = (d && d.prazos) ? d.prazos[prazo] : null
                      const v = (pz && !pz.erro) ? pz.veredito_ew : null
                      linhas.push({symbol: pos.symbol, value: pos.value, saldo: (v && typeof v.saldo === "number") ? v.saldo : null, veredito: v ? v.veredito : "sem dados"})
                    } catch (err) {
                      linhas.push({symbol: pos.symbol, value: pos.value, saldo: null, veredito: "falhou"})
                    }
                  }
                  const medidos = linhas.filter(x => x.saldo !== null)
                  const pesoMed = medidos.reduce((a, x) => a + x.value, 0)
                  const pesoTot = linhas.reduce((a, x) => a + x.value, 0)
                  setEwCart({
                    linhas: linhas,
                    saldo: pesoMed > 0 ? medidos.reduce((a, x) => a + x.saldo * x.value, 0) / pesoMed : null,
                    cobertura: pesoTot > 0 ? pesoMed / pesoTot * 100 : 0,
                  })
                  setEwCartLoading(false)}
  // Trocar o prazo do oscilador recalcula o veredito da carteira sozinho,
  // para a tela nunca mostrar o resultado de um prazo sob o titulo de outro.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (isPremium4 && ewData && etfEnriched.length > 0) rodarCarteiraEw(ewPrazo) }, [ewPrazo])
  const [acertosEw, setAcertosEw] = useState(null)
  const [resumoLoading, setResumoLoading] = useState(false)
  const [intData, setIntData] = useState(null)
  const [intLoading, setIntLoading] = useState(false)
  const [medAberta, setMedAberta] = useState({})
  // Uma frase, um lugar. O denominador das medicoes conta registros diarios cujas
  // janelas de resultado se sobrepoem — 30 registros seguidos do mesmo ativo
  // compartilham 29 dos 30 dias de medicao. O calculo trata todos como
  // independentes, entao o desvio padrao sai menor que o verdadeiro e o portao
  // de 2 sigma abre antes do que deveria. Decidido em 05/10/2026 manter o
  // registro diario e declarar o otimismo em vez de reduzir a gravacao.
  const AVISO_DENOM = "— janelas sobrepostas, denominador otimista."
  // As medicoes abrem sozinhas quando ja existe registro; sem registro ficam
  // recolhidas, porque ali o que ocupa a tela e o paragrafo do metodo e nao o
  // numero. Nada e removido: tocar abre o card inteiro, igual ao de antes.
  const medAbre = (k, obj) => medAberta[k] !== undefined ? medAberta[k] : !!(obj && obj.total > 0)

  // Card recolhido: ocupa uma linha no PROPRIO lugar do card, e abre ali mesmo.
  // Tira no topo abrindo conteudo tres telas abaixo confunde: o toque e o que
  // aparece tem que ficar juntos.
  const medStub = (k, obj, rot) => {
    // Sem dado ainda, a linha aparece cinza e nao clicavel, em vez de nao
    // aparecer: assim as cinco medicoes ficam visiveis desde o primeiro
    // instante, e uma consulta que falha fica a vista em vez de sumir.
    if (!obj) return (
      <div style={{...s.card, display:"flex", justifyContent:"space-between", alignItems:"center"}}>
        <span style={{color:"#6b7280", fontSize:13}}>{rot}</span>
        <span style={{color:"#4b5563", fontSize:10}}>carregando…</span>
      </div>
    )
    if (medAbre(k, obj)) return (
      <button onClick={() => setMedAberta(x => ({...x, [k]: false}))} style={{display:"block", width:"100%", textAlign:"right", background:"transparent", border:"none", color:"#4b5563", fontSize:10, padding:"2px 2px 0 0", cursor:"pointer"}}>▲ recolher</button>
    )
    return (
      <button onClick={() => setMedAberta(x => ({...x, [k]: true}))} style={{...s.card, display:"flex", justifyContent:"space-between", alignItems:"center", width:"100%", textAlign:"left", cursor:"pointer"}}>
        <span style={{color:"#e5e7eb", fontSize:13}}>{rot}</span>
        <span style={{color:"#6b7280", fontSize:10}}>{typeof obj.total === "number" ? (obj.total === 0 ? "ainda sem registro de 30 dias" : obj.total + (obj.total === 1 ? " registro" : " registros")) : "sem medição"}  ▼</span>
      </button>
    )
  }
  const [advLoading, setAdvLoading] = useState(false)
  const [optimAlts, setOptimAlts] = useState(null)
  const [optimAltsLoading, setOptimAltsLoading] = useState(false)

  const OPTIMIZER_UNIVERSE = {
    return: ["VOO","QQQ","MSFT","NVDA","META","V","MA","GOOGL","AMZN","AAPL","AMD","TSLA","PLTR","AVGO","CRM","SPGI","MCO","LIN","APH","CDNS","SNPS","ADBE","NOW","INTU","PANW"],
    defensive: ["BRK-B","JNJ","PG","KO","PEP","XLU","VZ","SO","MMM","MCD","WMT","COST","HD","LOW","TGT","CL","EL","CLX","K","GIS","SJM","HSY","MKC","CPB","CAG"],
    concentration: ["VT","VXUS","VEA","BND","AGG","SCHD","VIG","DGRO","SCHY","GLD","SLV","VNQ","O","MAIN","STAG","JEPI","JEPQ","DIVO","NUSI","QYLD","RYLD","XYLD","PDI","PTY","UTF"],
    dca: ["FBTC","FETH","BSOL","IBIT","ETHA","VOO","QQQ","VTI","SCHD","VIG","BRK-B","MSFT","AAPL","GOOGL","AMZN","V","MA","NVDA","META","SPGI"],
    oversold: ["GOOGL","ORCL","META","AMZN","MSFT","NVDA","AMD","PLTR","CRM","SNOW","NET","DDOG","MDB","ZS","CRWD","OKTA","GTLB","BILL","DOCN","AFRM","UPST","SOFI","HOOD","COIN","MSTR"]
  }
  const [p5Amount, setP5Amount] = useState("")
  const [p5Ticker, setP5Ticker] = useState("")
  const [p5Result, setP5Result] = useState(null)
  const [p5Loading, setP5Loading] = useState(false)
  const [p5BestAlt, setP5BestAlt] = useState(null)
  const [p5Goal, setP5Goal] = useState("")
  const [editModal, setEditModal] = useState(null)
  const [editModalEntries, setEditModalEntries] = useState([])
  const [editModalLoading, setEditModalLoading] = useState(false)
  const [p5GoalResult, setP5GoalResult] = useState(null)
  const [p5GoalLoading, setP5GoalLoading] = useState(false)
  const [dcaEtf, setDcaEtf] = useState("")
  const [dcaBestTarget, setDcaBestTarget] = useState([])
  const [dcaAmount, setDcaAmount] = useState("")
  const [whatifSell, setWhatifSell] = useState("")
  const [whatifBuy, setWhatifBuy] = useState("")
  const [whatifPct, setWhatifPct] = useState(50)
  const [whatifResult, setWhatifResult] = useState(null)
  const [translatedWhatif, setTranslatedWhatif] = useState("")
  const [translatingWhatif, setTranslatingWhatif] = useState(false)
  const [etfFlows, setEtfFlows] = useState(null)
  const [, setEtfFlowsHistory] = useState([])
  const [newsSentiment, setNewsSentiment] = useState(null)
  const [alertSettings, setAlertSettings] = useState({drop5:true, rise5:true, regime:true, news_alert:false, daily:true, smart_alert:false})
  const [btnPos, setBtnPos] = useState({x: window.innerWidth - 72, y: window.innerHeight - 132})
  const btnDragging = React.useRef(false)
  const btnOffset = React.useRef({x:0, y:0})
  const [savingAlerts, setSavingAlerts] = useState(false)
  const [alertsSaved, setAlertsSaved] = useState(false)
  const [premium3Analysis, setPremium3Analysis] = useState("")
  const [stress, setStress] = useState(null)
  const [amostraVer, setAmostraVer] = useState(null)
  const [regimeVer, setRegimeVer] = useState(null)
  const [premioQ, setPremioQ] = useState(null)
  const [sinalVer, setSinalVer] = useState(null)
  const [insights, setInsights] = useState({})
  const [menuAberto, setMenuAberto] = useState(false)
  const nomeDaAba = (MENU_ABAS.find(x => x[0] === tab) || [0, 0, "ClawETF"])[2]
  useEffect(() => {
    if (!menuAberto) return
    const antes = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => { document.body.style.overflow = antes }
  }, [menuAberto])
  const [linkCopiado, setLinkCopiado] = useState(false)
  // Insights por ativo: uma busca quando a aba abre, e o servidor guarda 3 horas.
  // A aba e gratuita e cada geracao la e paga, entao sem esse cache cada visita
  // viraria uma chamada. Nada disto e medicao do app, e o rodape do card diz isso.
  useEffect(() => {
    if (tab !== "crypto") return
    const ativos = ["bitcoin", "ethereum"]
    ativos.forEach(a => {
      if (insights[a]) return
      fetch(API_URL + "/insights?ativo=" + a).then(r => r.json())
        .then(d => setInsights(x => ({...x, [a]: d}))).catch(() => {})
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])
  // Veredito do CLAW Signal: e global, nao depende de ativo nem de prazo,
  // entao uma busca ao abrir basta. A mesma funcao do servidor alimenta o
  // card da aba e a linha do resumo, para as duas nunca discordarem.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetch(API_URL + "/veredito-sinais").then(r => r.json()).then(setSinalVer).catch(() => {}) }, [])
  useEffect(() => { fetch(API_URL + "/quesito-premio").then(r => r.json()).then(d => setPremioQ(d && !d.erro ? d : null)).catch(() => {}) }, [])

  async function carregarAmostraVer() {
    try {
      const r = await fetch(API_URL + "/amostra-veredito", { headers: hdrAuth() })
      setAmostraVer(await r.json())
    } catch (_e) { setAmostraVer(null) }
    try {
      const r2 = await fetch(API_URL + "/regime-veredito", { headers: hdrAuth() })
      setRegimeVer(await r2.json())
    } catch (_e) { setRegimeVer(null) }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if ((tab === "premium" || tab === "premium4") && user) carregarAmostraVer() }, [tab, user])
  const [loadingPremium3, setLoadingPremium3] = useState(false)
  const [translatedAnalysis, setTranslatedAnalysis] = useState("")
  const [translatingAnalysis, setTranslatingAnalysis] = useState(false)
  const [translatedPremium3, setTranslatedPremium3] = useState("")
  const [translatingPremium3, setTranslatingPremium3] = useState(false)
  const [technical, setTechnical] = useState({})
  const [loadingTech, setLoadingTech] = useState(false)
  const [techTicker, setTechTicker] = useState("")
  // a analise da 💎 se perdia no reload e todos os cards voltavam a "sem dados".
  // Comeca com a ultima conhecida e substitui quando a busca real chega.
  // a 💎 comeca sempre vazia: aba ja rodada confunde, nao da para saber se e de agora
  const [portfolioStats, setPortfolioStats] = useState(null)

  // ao voltar de outro app, descarta a analise se ja passou de 30 minutos
  useEffect(() => {
    const aoVoltar = () => {
      if (document.visibilityState !== "visible") return
      try {
        const ts = parseInt(sessionStorage.getItem('claw_stats_ts') || "0")
        if (ts && Date.now() - ts > 30 * 60 * 1000) setPortfolioStats(null)
      } catch (e) {}
    }
    document.addEventListener("visibilitychange", aoVoltar)
    return () => document.removeEventListener("visibilitychange", aoVoltar)
  }, [])
  const [loadingStats, setLoadingStats] = useState(false)
  const [portfolioTechnical, setPortfolioTechnical] = useState({})
  const [loadingPortfolioTech, setLoadingPortfolioTech] = useState(false)
  const [telegramId, setTelegramId] = useState("")
  const [lastSmartAlert, setLastSmartAlert] = useState(null)
  const [, setWhatsappNum] = useState("")
  const [, setOpenclawToken] = useState("")
  const [lastReport, setLastReport] = useState(null)
  const [savingConnection, setSavingConnection] = useState("")
  const [connectionSaved, setConnectionSaved] = useState({})
  const [showEmailAuth, setShowEmailAuth] = useState(false)
  const [authMode, setAuthMode] = useState("login")
  const [authEmail, setAuthEmail] = useState("")
  const [authPassword, setAuthPassword] = useState("")
  const [authLoading, setAuthLoading] = useState(false)
  const [authMessage, setAuthMessage] = useState("")
  const [nowTs, setNowTs] = useState(Date.now())
  const [news, setNews] = useState([])
  const [newsCarteira, setNewsCarteira] = useState([])
  const [newsMacro, setNewsMacro] = useState([])
  const [fgData, setFgData] = useState(null)
  const [macroFonte, setMacroFonte] = useState('')
  const [loadingNews, setLoadingNews] = useState(false)
  const [chatOpen, setChatOpen] = useState(false)
  const [chatMessages, setChatMessages] = useState([])
  const [chatInput, setChatInput] = useState("")
  const [chatLoading, setChatLoading] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setToken(session?.access_token ?? null)
      setUser(session?.user ?? null)
      setLoading(false)
    })
    supabase.auth.onAuthStateChange((_e, session) => { setToken(session?.access_token ?? null); setUser(session?.user ?? null) })
  }, [])

  useEffect(() => {
    fetchPrices()
    fetchIndices()
    const pricesInterval = setInterval(() => { fetchPrices(); fetchIndices() }, 30000)
    return () => {
      clearInterval(pricesInterval)
    }
  // fetchPrices le as posicoes por positionsRef.current, que
  // esta sempre atual, e userSymbols ja esta abaixo: o
  // intervalo de 30s nao congela nada.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSymbols])

  useEffect(() => {
    try {
      localStorage.setItem(ACTIVE_TAB_STORAGE_KEY, tab)
    } catch (_e) {
      console.warn("Unable to persist active tab to localStorage")
    }
  }, [tab])

  // Carregadores de montagem: rodam quando o usuario
  // muda, que e o gatilho pretendido.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (user) { loadPositions(); checkSubscription(user.id); loadConnections(); loadAlertSettings() } }, [user])

  useEffect(() => {
    if (positions.length > 0) {
      const tickers = [...new Set([...userSymbols, ...positions.map(p=>p.symbol).filter(Boolean)])].join(",")
      if (tickers) fetch(API_URL + "/prices?extra=" + tickers, { headers: hdrAuth() }).then(r=>r.json()).then(d=>{ if(d.prices) setPrices(prev=>({...prev,...d.prices})) }).catch(()=>{})
    }
  }, [positions, userSymbols])

  useEffect(() => {
    if (!isPremium4) return
    const fetchFlows = () => {
      fetch(`${API_URL}/etf-flows`)
        .then(r => r.json())
        .then(data => setEtfFlows(data))
        .catch(e => console.error("ETF flows error:", e))
      fetch(`${API_URL}/etf-flows-history`)
        .then(r => r.json())
        .then(data => setEtfFlowsHistory(data.history || []))
        .catch(e => console.error("ETF flows history error:", e))
    }
    fetchFlows()
    const interval = setInterval(fetchFlows, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [isPremium4])

  // disparava so na montagem, quando positions ainda estava vazio, e o grafico
  // ficava zerado ate trocar de periodo. Agora refaz ao abrir a aba e ao carregar as posicoes
  // transactions.length entrou na lista por medicao, nao por suspeita: o loadPositions
  // faz setPositions ANTES de as transacoes chegarem, entao o grafico disparava com
  // lista vazia e o backend caia no caminho que usa a quantidade de HOJE em todas as
  // datas passadas. Serie errada que so sumia ao trocar de aba. Em 06/10/2026 a mesma
  // janela de 1 mes dava +6,77% sem transacoes e +16,74% com elas.
  // positions.length nao servia de gatilho: a carteira nasce do sessionStorage
  // com 2 linhas e a carteira viva tambem tem 2, entao o conteudo trocava sem o
  // efeito refazer a chamada e o grafico ficava com a lista velha para sempre.
  // Em 07/10/2026 isso prendia o MAX em 29/08/2025, o purchase_date da FBTC: o
  // backend recebia a carteira guardada, o teste de completude recusava e a rota
  // caia no caminho que so enxerga ativo que ainda existe. A assinatura tambem
  // pega mudanca de quantidade que nao muda o numero de linhas.
  const _assinCarteira = positions.map(x => (x.symbol || "") + ":" + x.quantity).join("|")
  // fetchChart le apenas o que ja esta nas dependencias
  // abaixo (ticker, periodo, aba).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchChart() }, [chartTicker, chartPeriod, tab, _assinCarteira, transactions.length])

  useEffect(() => {
    if (!cryptoChartTicker) return
    setLoadingCryptoChart(true)
    const COINGECKO_IDS = {
      'PEPE-USD':'pepe','MORPHO-USD':'morpho','ONDO-USD':'ondo-finance','JUP-USD':'jupiter','AERO-USD':'aerodrome-finance',
      'POL-USD':'polygon-ecosystem-token','ARB-USD':'arbitrum','APT-USD':'aptos',
      'KAS-USD':'kaspa','ALGO-USD':'algorand','DOT-USD':'polkadot','ENA-USD':'ethena',
      'RENDER-USD':'render-token','MNT-USD':'mantle','WLD-USD':'worldcoin-org',
      'TAO-USD':'bittensor','NEAR-USD':'near','AVAX-USD':'avalanche-2',
      'FIL-USD':'filecoin','ATOM-USD':'cosmos','QNT-USD':'quant-network',
      'ETC-USD':'ethereum-classic','AAVE-USD':'aave','SUI-USD':'sui',
      'SHIB-USD':'shiba-inu','ICP-USD':'internet-computer','PI-USD':'pi-network',
      'WLFI-USD':'world-liberty-financial','HYPE-USD':'hyperliquid'
    }
    const cgId = COINGECKO_IDS[cryptoChartTicker]
    const periodMap = {'1d':'1','1wk':'7','1mo':'30','3mo':'90','1y':'365','max':'max'}
    const days = periodMap[cryptoChartPeriod] || '30'
    fetch(API_URL + "/history/" + encodeURIComponent(cryptoChartTicker) + "?period=" + cryptoChartPeriod, { headers: hdrAuth() })
      .then(r => r.json())
      .then(data => {
        if (data.data && data.data.length > 0) {
          setCryptoChartData(data.data.map(d => ({
            t: typeof d.t === "number"
              ? new Date(d.t).toLocaleDateString("en-US", {month:"short", day:"numeric"})
              : cryptoChartPeriod === "1d" ? d.t?.slice(11,16) : d.t?.slice(5,10),
            v: (() => { const n = d.v ?? d.c ?? 0; if (n < 0.0001) return parseFloat(n.toFixed(10)); if (n < 0.01) return parseFloat(n.toFixed(8)); if (n < 1) return parseFloat(n.toFixed(6)); return parseFloat(n.toFixed(4)); })()
          })))
          setLoadingCryptoChart(false)
        } else if (cgId) {
          fetch(`https://api.coingecko.com/api/v3/coins/${cgId}/market_chart?vs_currency=usd&days=${days}&x_cg_demo_api_key=${CG_KEY}`)
            .then(r => r.json())
            .then(d => {
              if (d.prices) {
                setCryptoChartData(d.prices.map(p => ({
                  t: new Date(p[0]).toLocaleDateString("en-US", {month:"short", day:"numeric"}),
                  v: (() => { const n = p[1]; if (n < 0.0001) return parseFloat(n.toFixed(10)); if (n < 0.01) return parseFloat(n.toFixed(8)); if (n < 1) return parseFloat(n.toFixed(6)); return parseFloat(n.toFixed(4)); })()
                })))
              }
              setLoadingCryptoChart(false)
            }).catch(() => setLoadingCryptoChart(false))
        } else {
          setLoadingCryptoChart(false)
        }
      }).catch(() => {
        if (cgId) {
          fetch(`https://api.coingecko.com/api/v3/coins/${cgId}/market_chart?vs_currency=usd&days=${days}&x_cg_demo_api_key=${CG_KEY}`)
            .then(r => r.json())
            .then(d => {
              if (d.prices) {
                setCryptoChartData(d.prices.map(p => ({
                  t: new Date(p[0]).toLocaleDateString("en-US", {month:"short", day:"numeric"}),
                  v: (() => { const n = p[1]; if (n < 0.0001) return parseFloat(n.toFixed(10)); if (n < 0.01) return parseFloat(n.toFixed(8)); if (n < 1) return parseFloat(n.toFixed(6)); return parseFloat(n.toFixed(4)); })()
                })))
              }
              setLoadingCryptoChart(false)
            }).catch(() => setLoadingCryptoChart(false))
        } else {
          setLoadingCryptoChart(false)
        }
      })
  }, [cryptoChartTicker, cryptoChartPeriod])

  useEffect(() => {
    if (!marketChartTicker) return
    setLoadingMarketChart(true)
    fetch(API_URL + "/history/" + encodeURIComponent(marketChartTicker) + "?period=" + marketChartPeriod, { headers: hdrAuth() })
      .then(r => r.json())
      .then(data => {
        if (data.data) {
          setMarketChartData(data.data.map(d => ({
            t: typeof d.t === "number"
              ? new Date(d.t).toLocaleDateString("en-US", {month:"short", day:"numeric"})
              : marketChartPeriod === "1d" ? d.t?.slice(11,16) : d.t?.slice(5,10),
            v: parseFloat((d.v ?? d.c ?? 0).toFixed(2))
          })))
        }
        setLoadingMarketChart(false)
      }).catch(() => setLoadingMarketChart(false))
  }, [marketChartTicker, marketChartPeriod])

  useEffect(() => {
    const clockInterval = setInterval(() => setNowTs(Date.now()), 30000)
    return () => clearInterval(clockInterval)
  }, [])

  const alertSentRef = React.useRef(false)
  // O intervalo de alerta e criado uma vez e congelava
  // alertSettings e etfEnriched do render da criacao. Esta
  // referencia os mantem atuais SEM recriar o intervalo —
  // recriar zeraria o cronometro de 30 min a cada preco
  // novo, e o alerta nunca mais dispararia.
  const alertaDadosRef = React.useRef(
    { alertSettings: {}, etfEnriched: [] })
  useEffect(() => {
    if (!user || !telegramId || !isPremium4) return
    const checkAlerts = async () => {
      try {
        const { alertSettings, etfEnriched } = alertaDadosRef.current
        const currentValue = etfEnriched.reduce((s,p) => s+p.value, 0)
        const prevValue = currentValue - etfEnriched.reduce((s,p) => s+p.dailyPnl, 0)
        if (currentValue <= 0 || prevValue <= 0) return
        if (alertSentRef.current) return
        const today = new Date().toISOString().slice(0,10)
        const alertKey = "claw_alert_" + today
        const sentToday = JSON.parse(localStorage.getItem(alertKey) || "{}")
        const changePct = (currentValue - prevValue) / prevValue * 100
        const needsDrop = alertSettings.drop5 && changePct <= -5 && !sentToday.drop5
        const needsRise = alertSettings.rise5 && changePct >= 5 && !sentToday.rise5
        if (!needsDrop && !needsRise && !alertSettings.regime) return
        localStorage.setItem(alertKey, JSON.stringify({...sentToday, drop5: sentToday.drop5 || needsDrop, rise5: sentToday.rise5 || needsRise}))
        alertSentRef.current = true
        const regime = (() => { const _a = etfEnriched.map(x => x.dailyChange || 0).sort((m,n) => m-n); const _k = _a.length; return _k === 0 ? 0 : (_k % 2 ? _a[(_k-1)/2] : (_a[_k/2-1] + _a[_k/2]) / 2) })() > 0 ? "RISK-ON" : "RISK-OFF"
        const prevRegime = localStorage.getItem("claw_prev_regime") || ""
        await fetch(API_URL + "/check-alerts", {
          method: "POST",
          headers: {"Content-Type": "application/json", ...hdrAuth()},
          body: JSON.stringify({
            user_id: user.id,
            telegram_chat_id: telegramId,
            portfolio_value: currentValue,
            prev_value: prevValue,
            regime: regime,
            prev_regime: prevRegime,
            alerts: alertSettings
          })
        })
        // so marca como avisado DEPOIS de enviar: antes, uma falha de rede
        // apagava a virada e o alerta nunca mais acontecia
        localStorage.setItem("claw_prev_regime", regime)
      } catch(e) {}
    }
    const alertInterval = setInterval(checkAlerts, 30 * 60 * 1000)
    setTimeout(checkAlerts, 10000)
    return () => clearInterval(alertInterval)
  }, [user, telegramId, isPremium4])

  // Amostragem diaria de uma lista fixa (rota /amostra-lista). O
  // objetivo e acumular leitura ALTA e BAIXA do MESMO ativo em
  // regimes diferentes: sem isso qualquer comparacao entre ativos
  // mede setor, nao score — foi o que a medicao de 08/10/2026
  // mostrou. Os scores sao calculados AQUI porque a regua vive em
  // lib/score.js e nao pode ter copia em Python. O banco tem
  // unique(dia, symbol), entao duplicata e impossivel.
  useEffect(() => {
    if (!user) return
    let cancelado = false
    const amostrar = async () => {
      try {
        const hoje = new Date().toISOString().slice(0, 10)
        const lr = await fetch(API_URL + "/amostra-lista", { headers: hdrAuth() })
        const lista = (await lr.json()).lista || []
        if (!lista.length || cancelado) return
        // o dia e a sessao do preco, nao a data da rodada
        const _p = await fetch(API_URL + "/technical/" + lista[0], { headers: hdrAuth() })
        const _t0 = await _p.json()
        const dia = (_t0 && _t0.session_date) || hoje
        const { data } = await supabase.from("amostra_scores")
          .select("symbol").eq("dia", dia)
        const feitos = new Set((data || []).map(x => x.symbol))
        const faltam = lista.filter(x => !feitos.has(x))
        if (!faltam.length || cancelado) return
        const linhas = []
        for (const sym of faltam) {
          if (cancelado) return
          try {
            const tr = await fetch(API_URL + "/technical/" + sym, { headers: hdrAuth() })
            const t = await tr.json()
            if (!t || t.error) continue
            const c = scoreConfluence(t)
            const e = scoreExhaustion(t)
            linhas.push({
              dia: dia, symbol: sym,
              preco: t.current_price ?? null,
              rsi: t.rsi ?? null,
              confluence_score: c.score, confluence_dir: c.dir,
              exhaustion_score: e.score, exhaustion_label: e.label
            })
          } catch (_e) {}
        }
        if (linhas.length && !cancelado) {
          await fetch(API_URL + "/amostra-gravar", {
            method: "POST",
            headers: { "Content-Type": "application/json", ...hdrAuth() },
            body: JSON.stringify({ linhas })
          })
        }
      } catch (_e) {}
    }
    const tmr = setTimeout(amostrar, 20000)
    return () => { cancelado = true; clearTimeout(tmr) }
  }, [user])

  useEffect(() => {
    if ((tab === "crypto" || (tab === "adicionar" && posType === "crypto")) && Object.keys(cryptoPrices).length === 0) {
      if (!fgData) fetch(API_URL + "/fear-greed", { headers: hdrAuth() }).then(r => r.json()).then(d => { if (d && !d.error) setFgData(d) }).catch(() => {})
      setLoadingCrypto(true)
      fetch('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false&price_change_percentage=24h&x_cg_demo_api_key=' + CG_KEY)
        .then(r => r.json())
        .then(d => {
          const result = {}
          d.forEach(c => {
            const sym = c.symbol.toUpperCase()
            result[sym] = { price: c.current_price, change_24h: c.price_change_percentage_24h, name: c.name, rank: c.market_cap_rank }
          })
          setCryptoPrices(result)
          setLoadingCrypto(false)
        })
        .catch(() => setLoadingCrypto(false))
    }
    if (tab !== "mercado" && tab !== "premium4") return
    if (news.length > 0) return
    setLoadingNews(true)
    fetch(`${API_URL}/news`)
      .then(r => r.json())
      .then(data => {
        const articles = Array.isArray(data) ? data : (data.articles || data.news || [])
        const top = articles.slice(0, 10)
        setNews(top)
        // noticias dos tickers da carteira: filtra o que nao cita nenhum deles,
        // porque a busca por texto traz muito artigo sem relacao
        const _tk = data.tickers || []
        const _nomes = ['Alphabet','Google','Oracle','Costco','Kroger','Chipotle','Yum','Moody']
        const _cart = (data.carteira || []).filter(a => {
          const txt = ((a.title||'') + ' ' + (a.description||'')).toLowerCase()
          return _tk.some(t => txt.includes(t.toLowerCase())) || _nomes.some(n => txt.includes(n.toLowerCase()))
        })
        setNewsCarteira(_cart.slice(0, 6))
        setNewsMacro(data.macro || [])
        // o Contexto Macro passa a ler a busca macro (Fed, inflacao, juros,
        // petroleo) em vez do noticiario de cripto, que enviesava a nota
        const _fonteSent = (data.macro && data.macro.length > 0) ? data.macro : top
        setMacroFonte((data.macro && data.macro.length > 0) ? 'macro' : 'cripto')
        if (isPremium4 && _fonteSent.length > 0 ) {
          const headlines = _fonteSent.map((n,i) => `${i+1}. ${n.title||n.headline||''}`).join('\n')
          fetch(API_URL + "/claude", {
            method: "POST",
            headers: {"Content-Type":"application/json", ...hdrAuth()},
            body: JSON.stringify({model:CLAUDE_MODEL,max_tokens:50,messages:[{role:"user",content:`Analyze these financial news headlines and respond with ONLY one word: POSITIVE, NEGATIVE, or NEUTRAL.\n\n${headlines}`}]})
          }).then(r=>r.json()).then(d=>{
            const txt = d.content?.[0]?.text?.trim().toUpperCase()||"NEUTRAL"
            setNewsSentiment(txt.includes("POSITIVE")?1:txt.includes("NEGATIVE")?-1:0)
          }).catch(()=>setNewsSentiment(0))
        }
      })
      .catch(err => { console.error("Failed to fetch news:", err); setNews([]) })
      .finally(() => setLoadingNews(false))
    // cryptoPrices fica FORA desta lista de proposito: a
    // guarda acima e "length === 0", e se a CoinGecko
    // devolver lista vazia o estado viraria objeto novo, o
    // efeito rodaria outra vez e a guarda seguiria
    // verdadeira — laco de requisicao na velocidade da rede.
    // O lint vai continuar pedindo, e esta certo em pedir;
    // nao atender e decisao nossa.
    // news.length e NUMERO por motivo igual: com o array, o
    // setNews([]) do erro daria referencia nova e laco.
  // cryptoPrices fora de proposito, ver o comentario
  // acima: lista vazia da CoinGecko criaria laco
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, posType, isPremium4, news.length])


  const WHITELIST = ["eduardofigueiredo63@gmail.com"]

  async function loadConnections() {
    if (!user) return
    try {
      const { data } = await supabase.from("user_connections").select("*").eq("user_id", user.id).limit(1)
      if (data && data.length > 0) {
        if (data[0].telegram_chat_id) setTelegramId(data[0].telegram_chat_id)
        if (data[0].whatsapp_number) setWhatsappNum(data[0].whatsapp_number)
        if (data[0].openclaw_token) setOpenclawToken(data[0].openclaw_token)
        setConnectionSaved({telegram: !!data[0].telegram_chat_id, whatsapp: !!data[0].whatsapp_number, openclaw: !!data[0].openclaw_token})
      }
    } catch(e) {}
  }

  async function saveConnection(type, value) {
    if (!value.trim()) return
    setSavingConnection(type)
    try {
      const field = type === "telegram" ? "telegram_chat_id" : type === "whatsapp" ? "whatsapp_number" : "openclaw_token"
      const { data: existing } = await supabase.from("user_connections").select("id").eq("user_id", user.id).limit(1)
      if (existing && existing.length > 0) {
        await supabase.from("user_connections").update({[field]: value}).eq("user_id", user.id)
      } else {
        await supabase.from("user_connections").insert({user_id: user.id, [field]: value})
      }
      setConnectionSaved(prev => ({...prev, [type]: true}))

      if (type === "telegram") {
        await fetch(`https://api.telegram.org/bot8563726069:AAGz9DNfUAADb7wcfX19D9FAqgZHkRGfkrs/sendMessage`, {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({chat_id: value, text: "✅ ClawETF conectado com sucesso! Voce receberá análises automáticas do seu portfólio aqui."})
        })
      }
    } catch(e) {}
    setSavingConnection("")
  }

  async function checkSubscription(userId) {
    if (user && WHITELIST.includes(user.email)) {
      setIsPremium(true)
      setIsPremium2(true)
      setIsPremium3(true)
      setIsPremium4(true)
      setIsPremium5(true)
      return
    }
    try {
      const { data } = await supabase.from("subscriptions").select("plan, status").eq("user_id", userId).eq("status", "active").order("created_at", { ascending: false }).limit(1)
      if (data && data.length > 0) {
        const plan = data[0].plan
        if (plan === "premium4") { setIsPremium(true); setIsPremium2(true); setIsPremium3(true); setIsPremium4(true) }
        if (plan === "premium5") { setIsPremium(true); setIsPremium2(true); setIsPremium3(true); setIsPremium4(true); setIsPremium5(true) }
        else if (plan === "premium3") { setIsPremium(true); setIsPremium2(true); setIsPremium3(true) }
        else if (plan === "premium2") { setIsPremium(true); setIsPremium2(true) }
        else if (plan === "premium") { setIsPremium(true) }
      }
    } catch(e) {}
  }

  // A gravacao da assinatura pelo navegador foi REMOVIDA em
  // 08/10/2026. Ela comecava com if (!user) return, e o
  // efeito que a chamava tem dependencias [] — roda na
  // montagem, quando user ainda e nulo. Nunca gravou nada.
  // Quem grava e o webhook da Stripe (/stripe-webhook no
  // backend), o unico escritor dessa tabela. Fazer o
  // navegador gravar tambem criaria linha SEM
  // stripe_subscription_id, que e o campo pelo qual o
  // webhook localiza a linha para atualizar depois.

  async function fetchPrices() {
    try {
      const userTickers = [...new Set([...userSymbols, ...positionsRef.current.map(p => p.symbol).filter(Boolean)])].join(","); const res = await fetch(API_URL + "/prices" + (userTickers ? "?extra=" + userTickers : ""), { headers: hdrAuth() })
      const data = await res.json()
      const adjustedPrices = {}
      Object.entries(data.prices || {}).forEach(([ticker, p]) => {
        adjustedPrices[ticker] = {
          ...p,
          price: (p.price && p.price > 0) ? p.price : (p.previous_close || 0),
          change_pct: (p.price && p.price > 0) ? p.change_pct : 0
        }
      })
      setPrices(prev=>({...prev,...adjustedPrices}))
      setMarketStatus({status: data.market_status, label: data.market_label})
      if (data.usd_brl) setUsdBrl(data.usd_brl)
    } catch(e) {}
  }

  async function fetchIndices() {
    try {
      const res = await fetch(API_URL + "/indices", { headers: hdrAuth() })
      const text = await res.text()
      const data = JSON.parse(text.replace(/:\s*NaN/g, ":0").replace(/:\s*Infinity/g, ":0"))
      if (data && typeof data === "object" && Object.keys(data).length > 0) {
        setIndices(data)
      }
    } catch(e) {}
  }

  function isUsMarketOpen(date) {
    const NYSE_HOLIDAYS = {
      2026: ["2026-01-01","2026-01-19","2026-02-16","2026-04-03","2026-05-25","2026-06-19","2026-07-03","2026-09-07","2026-11-26","2026-12-25"],
      2027: ["2027-01-01","2027-01-18","2027-02-15","2027-04-26","2027-05-31","2027-06-18","2027-07-05","2027-09-06","2027-11-25","2027-12-24"],
    }
    const dtf = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York",
      hour12: false,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    })
    const parts = {}
    for (const part of dtf.formatToParts(date)) {
      parts[part.type] = part.value
    }
    const weekday = parts.weekday
    const hour = Number(parts.hour)
    const minute = Number(parts.minute)
    const year = Number(parts.year)
    const dateStr = parts.year + "-" + parts.month + "-" + parts.day
    if (!["Mon", "Tue", "Wed", "Thu", "Fri"].includes(weekday)) return false
    const holidays = NYSE_HOLIDAYS[year] || []
    if (holidays.includes(dateStr)) return false
    const totalMinutes = hour * 60 + minute
    return totalMinutes >= MARKET_OPEN_MINUTES_ET && totalMinutes < MARKET_CLOSE_MINUTES_ET
  }

  async function fetchChart() {
    setLoadingChart(true)
    try {
      if (chartTicker === "PORTFOLIO" && positions.length > 0) {
        const res = await fetch(API_URL + "/portfolio-history", {
          method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
          body: JSON.stringify({positions: positions.map(p => ({symbol: p.symbol, quantity: p.quantity, purchase_date: p.purchase_date, avg_price: p.avg_price})), transactions: transactions /* sem filtro: o filtro por etfEnriched descartava todo ativo ja encerrado antes de sair do navegador (BITB, ETHW, FETH, ETH e as acoes), o backend recebia so FBTC e ETHA, e o inicio da serie virava a primeira compra de FBTC em 29/08/2025 em vez de 12/02/2024. O filtro existia para barrar simbolo de teste que o Yahoo nao resolve; a tabela agora tem 901 linhas conferidas contra extrato, e os 19 simbolos todos tem cotacao. */, period: chartPeriod})
        })
        const data = await res.json()
        if (data.data) setChartData(data.data.map(d => ({t: chartPeriod === "1d" ? new Date(d.t).toLocaleTimeString("pt-BR", {hour:"2-digit", minute:"2-digit"}) : new Date(d.t).toLocaleDateString("pt-BR", ["1y","5y","max"].includes(chartPeriod) ? {month:"short", day:"numeric", year:"2-digit"} : {month:"short", day:"numeric"}), iso: d.t, v: d.v, i: d.i, brl: d.brl})))
      } else if (chartTicker !== "PORTFOLIO") {
        const res = await fetch(API_URL + "/history/" + encodeURIComponent(chartTicker) + "?period=" + chartPeriod, { headers: hdrAuth() })
        const data = await res.json()
        if (data.data) setChartData(data.data.map(d => ({t: chartPeriod === "1d" ? new Date(d.t).toLocaleTimeString("pt-BR", {hour:"2-digit", minute:"2-digit"}) : new Date(d.t).toLocaleDateString("pt-BR", ["1y","5y","max"].includes(chartPeriod) ? {month:"short", day:"numeric", year:"2-digit"} : {month:"short", day:"numeric"}), iso: d.t, v: d.v, i: d.i, brl: d.brl})))
      }
    } catch(e) {}
    setLoadingChart(false)
  }

  useEffect(() => {
    if (!indexChartTicker) return
    async function run() {
      setLoadingIndexChart(true)
      try {
        const res = await fetch(API_URL + "/history/" + encodeURIComponent(indexChartTicker) + "?period=" + indexChartPeriod, { headers: hdrAuth() })
        const data = await res.json()
        if (data.data) {
          setIndexChartData(data.data.map(d => ({
            t: indexChartPeriod === "1d"
              ? new Date(d.t).toLocaleTimeString("pt-BR", {hour:"2-digit", minute:"2-digit"})
              : new Date(d.t).toLocaleDateString("pt-BR", {month:"short", day:"numeric"}),
            v: d.v
          })))
        } else {
          setIndexChartData([])
        }
      } catch (e) {
        setIndexChartData([])
      }
      setLoadingIndexChart(false)
    }
    run()
  }, [indexChartTicker, indexChartPeriod])

  async function loadPositions() {
    const { data } = await supabase.from("positions").select("*").eq("user_id", user.id)
    const loadedPositions = (data || []).map(p => ({...p, symbol: p.symbol?.trim()}))
    setPositions(loadedPositions)
    try { sessionStorage.setItem('claw_pos', JSON.stringify(loadedPositions)) } catch (e) {}
    positionsRef.current = loadedPositions
    supabase.from("transactions").select("symbol, side, quantity, price, traded_at")
      .eq("user_id", user.id).order("traded_at").order("id").range(0, 999)
      .then(async ({data: tx}) => {
        // O Supabase corta no SERVIDOR (max-rows, mil linhas) e o .range do cliente
        // nao passa disso. Com 1547 operacoes chegavam so as mil mais antigas e o
        // realizado dava +$6.301 em vez de +$3.312; o grafico perdia o teste de
        // completude e voltava a comecar na data de compra da FBTC. A ordem inclui
        // o id para a pagina seguinte nao repetir nem pular linha de data empatada.
        let todas = tx || []
        while (todas.length > 0 && todas.length % 1000 === 0) {
          const { data: mais } = await supabase.from("transactions")
            .select("symbol, side, quantity, price, traded_at")
            .eq("user_id", user.id).order("traded_at").order("id")
            .range(todas.length, todas.length + 999)
          if (!mais || !mais.length) break
          todas = todas.concat(mais)
        }
        setTransactions(todas)
      })
    const syms = loadedPositions.map(p=>p.symbol?.trim()).filter(Boolean)
    setUserSymbols(syms)
    try { localStorage.setItem("userSymbols", JSON.stringify(syms)) } catch(e) {}
    if (syms.length > 0) {
      fetch(API_URL + "/prices?extra=" + syms.join(","), { headers: hdrAuth() }).then(r=>r.json()).then(d=>{ if(d.prices) setPrices(prev=>({...prev,...d.prices})) }).catch(()=>{})
    }
    const tickers = loadedPositions.map(p => p.symbol).filter(Boolean).join(",")
    if (tickers) {
      try {
        const res = await fetch(API_URL + "/prices?extra=" + tickers, { headers: hdrAuth() })
        const d = await res.json()
        if (d.prices) setPrices(prev=>({...prev,...d.prices}))
      } catch(e) {}
    }
  }

  async function loginGoogle() {
    await supabase.auth.signInWithOAuth({ provider: "google", options: { redirectTo: window.location.origin } })
  }

  async function loginWithEmail(e) {
    e.preventDefault()
    if (!authEmail) {
      setAuthMessage("Informe seu e-mail.")
      return
    }
    if (!authPassword) {
      setAuthMessage("Informe sua senha.")
      return
    }
    setAuthLoading(true)
    setAuthMessage("")
    try {
      const { error } = authMode === "signup"
        ? await supabase.auth.signUp({ email: authEmail, password: authPassword })
        : await supabase.auth.signInWithPassword({ email: authEmail, password: authPassword })
      if (error) {
        setAuthMessage(error.message)
      } else if (authMode === "signup") {
        setAuthMessage("Conta criada. Verifique seu e-mail para confirmar seu cadastro.")
      }
    } catch (e) {
      setAuthMessage("Não foi possível autenticar. Tente novamente.")
    }
    setAuthLoading(false)
  }

  async function logout() { await supabase.auth.signOut() }

  async function addPosition() {
    if (!symbol || !qty || !avgPrice) return
    if (!(numBR(qty) > 0) || !(numBR(avgPrice) > 0)) { alert("Quantidade e pre\u00e7o precisam ser maiores que zero. Pre\u00e7o zero entra no app e deixa todo o c\u00e1lculo de resultado errado, sem avisar."); return }
    const sym = symbol.trim().toUpperCase()
    // a aba mais e so para ticker novo: se ja existe, abre o lapis, que e onde
    // a compra adicional tem campo de preco e mensagem contextual. Isso tambem
    // impede a linha duplicada de quem marca o tipo errado.
    const _ja = positions.find(x => (x.symbol || "").toUpperCase() === sym)
    if (_ja) { openEditModal(sym, _ja.asset_type || posType); return }
    const purchaseDate = date || new Date().toISOString().split("T")[0]
    
    // Save entry to position_entries
    await supabase.from("position_entries").insert({
      user_id: user.id, symbol: sym,
      quantity: numBR(qty), price: numBR(avgPrice),
      purchase_date: purchaseDate,
      exchange: posType === "etf" ? (exchange || null) : null,
      asset_type: posType
    })

    // Record decision history with indicators snapshot
    try {
      const techRes = await fetch(API_URL + "/technical/" + sym + "-USD", { headers: hdrAuth() }).then(r => r.json()).catch(() => null)
      const userTickers2 = [...new Set([...userSymbols, ...positions.map(p => p.symbol).filter(Boolean)])].join(","); const pricesRes = await fetch(API_URL + "/prices" + (userTickers2 ? "?extra=" + userTickers2 : ""), { headers: hdrAuth() }).then(r => r.json()).catch(() => null)
      const regime = pricesRes?.market_label || null
      const tech = techRes || {}
      const { error: dhError } = await supabase.from("decision_history").insert({
        user_id: user.id,
        symbol: sym,
        quantity: numBR(qty),
        price_at_decision: numBR(avgPrice),
        amount_invested: numBR(qty) * numBR(avgPrice),
        rsi: tech.rsi || null,
        macd_signal: tech.macd?.signal_label || null,
        regime: regime
      })
      if (dhError) console.error("decision_history error:", dhError)
      else console.log("decision_history saved:", sym)
    } catch(e) { console.log("decision_history skip:", e) }
    
    // Get all entries for this symbol to recalculate avg
    const { data: entries } = await supabase
      .from("position_entries")
      .select("quantity, price")
      .eq("user_id", user.id)
      .eq("symbol", sym)
    
    if (entries && entries.length > 0) {
      const totalQty = entries.reduce((a, e) => a + numBR(e.quantity), 0)
      const totalCost = entries.reduce((a, e) => a + numBR(e.quantity) * numBR(e.price), 0)
      const avgPriceCalc = totalCost / totalQty
      
      // Check if position exists
      const { data: existing } = await supabase
        .from("positions")
        .select("id, quantity")
        .eq("user_id", user.id)
        .eq("symbol", sym)
        .eq("asset_type", posType)
        .maybeSingle()
      
      if (existing) {
        await supabase.from("positions").update({
          quantity: totalQty,
          avg_price: parseFloat(avgPriceCalc.toFixed(4)),
          asset_type: posType
        }).eq("id", existing.id)
        // positions guarda so o estado atual; transactions guarda o historico,
        // sem o qual o grafico de periodos longos ignora vendas
        const delta = totalQty - (existing.quantity || 0)
        if (Math.abs(delta) > 0.00001) {
          await supabase.from("transactions").insert({
            user_id: user.id, symbol: sym,
            side: delta > 0 ? "buy" : "sell",
            quantity: Math.abs(delta),
            // o preco da TRANSACAO e o da operacao, nao a media recalculada:
            // gravar a media punha no livro um preco que nunca existiu, e o
            // resultado realizado sai desses precos.
            price: numBR(avgPrice),
            traded_at: purchaseDate
          })
        }
      } else {
        await supabase.from("positions").insert({
          user_id: user.id, symbol: sym,
          quantity: totalQty, avg_price: parseFloat(avgPriceCalc.toFixed(4)),
          purchase_date: purchaseDate,
          asset_type: posType
        })
        await supabase.from("transactions").insert({
          user_id: user.id, symbol: sym, side: "buy",
          quantity: totalQty,
          price: parseFloat(avgPriceCalc.toFixed(4)),
          traded_at: purchaseDate
        })
      }
    }
    
    setSymbol(""); setQty(""); setAvgPrice(""); setDate(""); setExchange("")
    loadPositions()
  }

  async function loadPositionEntries(symbol, assetType) {
    setLoadingEntries(true)
    let query = supabase
      .from("position_entries")
      .select("*")
      .eq("user_id", user.id)
      .eq("symbol", symbol)
    if (assetType) {
      query = query.eq("asset_type", assetType)
    }
    const { data } = await query.order("purchase_date", { ascending: true })
    setPositionEntries(data || [])
    setLoadingEntries(false)
  }

  async function deletePosition(id) {
    // Get symbol before deleting
    const pos = positions.find(p => p.id === id)
    // sem preco a venda entrava a zero e contaminava o resultado realizado
    if (pos && (pos.currentPrice || pos.avg_price || 0) > 0) {
      await supabase.from("transactions").insert({
        user_id: user.id, symbol: pos.symbol, side: "sell",
        quantity: pos.quantity,
        price: pos.currentPrice || pos.avg_price || 0,
        traded_at: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10)
      })
    }
    await supabase.from("positions").delete().eq("id", id)
    // Also delete all entries for this symbol
    if (pos) {
      await supabase.from("position_entries").delete()
        .eq("user_id", user.id)
        .eq("symbol", pos.symbol)
    }
    if (selectedPosition === pos?.symbol) {
      setSelectedPosition(null)
      setPositionEntries([])
    }
    loadPositions()
  }

  async function openEditModal(symbol, assetType) {
    setEditModalLoading(true)
    setEditModal({symbol, assetType})
    const { data } = await supabase.from("position_entries").select("*").eq("user_id", user.id).eq("symbol", symbol).order("purchase_date", {ascending: true})
    setEditModalEntries((data || []).map(e => ({...e, editQty: String(e.quantity), editPrice: String(e.price), editDate: e.purchase_date||"", editExchange: e.exchange||""})))
    setEditModalLoading(false)
  }

  async function deleteEntry(entryId) {
    if (!editModal) return
    const alvo = editModalEntries.find(x => x.id === entryId)
    if (!alvo) return
    setEditModalLoading(true)
    await supabase.from("position_entries").delete().eq("id", entryId)
    // casar pela quantidade e data GRAVADAS, nao pelas do formulario: quem
    // edita o campo e aperta o lixo em vez de salvar deixava compra orfa.
    const _q = parseFloat(alvo.quantity)
    if (!isNaN(_q) && alvo.purchase_date) {
      const { data: _tx } = await supabase.from("transactions").select("id, quantity")
        .eq("user_id", user.id).eq("symbol", editModal.symbol)
        .eq("side", "buy").eq("traded_at", alvo.purchase_date)
      const _match = (_tx || []).find(t => Math.abs(parseFloat(t.quantity) - _q) < 0.00001)
      if (_match) await supabase.from("transactions").delete().eq("id", _match.id)
    }
    const { data: rest } = await supabase.from("position_entries").select("quantity, price")
      .eq("user_id", user.id).eq("symbol", editModal.symbol)
    if (rest && rest.length > 0) {
      const tq = rest.reduce((a, e) => a + parseFloat(e.quantity), 0)
      const tc = rest.reduce((a, e) => a + parseFloat(e.quantity) * parseFloat(e.price), 0)
      await supabase.from("positions").update({
        quantity: tq, avg_price: parseFloat((tc/tq).toFixed(4))
      }).eq("user_id", user.id).eq("symbol", editModal.symbol)
      setEditModalEntries(prev => prev.filter(x => x.id !== entryId))
      setEditModalLoading(false)
    } else {
      await supabase.from("positions").delete().eq("user_id", user.id).eq("symbol", editModal.symbol)
      setEditModalLoading(false)
      setEditModal(null)
      setEditModalEntries([])
    }
    loadPositions()
  }

  async function saveEditModal() {
    if (!editModal) return
    const _semPreco = editModalEntries.find(e => Math.abs(numBR(e.editQty) - numBR(e.quantity)) > 0.00001 && !(numBR(e.editSellPrice) > 0))
    if (_semPreco) { alert("Você mudou a quantidade. Informe o preço da operação — sem ele ela entra pelo preço médio e o resultado realizado fica errado.") ; return }
    const _mkt = editModal.assetType === "crypto" ? numBR((cryptoPrices[editModal.symbol] || {}).price) : numBR((prices[editModal.symbol] || {}).price)
    const _fora = editModalEntries.find(e => { const _dd = Math.abs(numBR(e.editQty) - numBR(e.quantity)); const _vv = numBR(e.editSellPrice); if (_dd <= 0.00001 || e.avisoVisto || !(_vv > 0) || !(_mkt > 0)) return false; const _uu = _vv / _dd; return _uu > _mkt * 1.3 || _uu < _mkt * 0.7 })
    if (_fora) { const _u = (numBR(_fora.editSellPrice) / Math.abs(numBR(_fora.editQty) - numBR(_fora.quantity))).toFixed(4); setEditModalEntries(prev => prev.map(x => x.id === _fora.id ? {...x, avisoVisto: true} : x)); alert("Confira: esse valor dá um preço de $" + _u + " por cota, e o ativo está a $" + _mkt.toFixed(4) + " hoje. Se estiver certo, toque em Salvar de novo."); return }
    setEditModalLoading(true)
    for (const e of editModalEntries) {
      const qty = numBR(e.editQty)
      const _qAnt = numBR(e.quantity), _pAnt = numBR(e.price)
      const _vOp = numBR(e.editSellPrice)
      const _d = qty - _qAnt
      const _pOp = Math.abs(_d) > 0.00001 && _vOp > 0 ? _vOp / Math.abs(_d) : 0
      // o preco medio NAO e para ser digitado: com a quantidade nova e o preco da
      // operacao o app recalcula sozinho. compra soma custo; venda tira ao custo
      // medio, o que deixa a media intacta. digitar a media a mao foi o que trouxe
      // os $75,07 da Nomad para ca — e aquele campo deles e a media de tudo que ja
      // foi comprado, sem descontar o que foi vendido. Outra conta, outra pergunta.
      let price = numBR(e.editPrice)
      if (Math.abs(_d) > 0.00001 && _pOp > 0 && _pAnt > 0 && qty > 0) {
        price = parseFloat(((_qAnt * _pAnt + _d * (_d > 0 ? _pOp : _pAnt)) / qty).toFixed(4))
      }
      if (isNaN(qty) || isNaN(price) || qty <= 0 || price <= 0) continue
      const { error: _err } = await supabase.from("position_entries").update({
        quantity: qty, price, purchase_date: e.editDate || null, exchange: e.editExchange || null
      }).eq("id", e.id)
      if (_err) { setEditModalLoading(false); alert("Não foi possível salvar: " + _err.message); return }
    }
    // Recalculate position avg
    const { data: entries } = await supabase.from("position_entries").select("quantity, price").eq("user_id", user.id).eq("symbol", editModal.symbol)
    if (entries && entries.length > 0) {
      const totalQty = entries.reduce((a, e) => a + numBR(e.quantity), 0)
      const totalCost = entries.reduce((a, e) => a + numBR(e.quantity) * numBR(e.price), 0)
      // editar a posicao nao gravava em transactions (a aba ➕ grava), entao o
      // grafico de retorno do capital nao via o aporte e igualava as duas medidas
      await supabase.from("positions").update({
        quantity: totalQty, avg_price: parseFloat((totalCost/totalQty).toFixed(4))
      }).eq("user_id", user.id).eq("symbol", editModal.symbol)
      // cada linha editada E uma operacao, e o preco e a data sao os que o usuario
      // digitou nela. Antes daqui toda compra e venda entrava no livro ao PRECO
      // MEDIO recalculado e com a data de HOJE em UTC. Foi isso que gravou as
      // compras de FBTC de setembro a $75-77 com o mercado a $66-68, e o que jogou
      // a venda do grupamento para o dia seguinte por ser depois das 21h aqui.
      const _hoje = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10)
      for (const e of editModalEntries) {
        const _d = numBR(e.editQty) - numBR(e.quantity)
        if (Math.abs(_d) <= 0.00001) continue
        await supabase.from("transactions").insert({
          user_id: user.id, symbol: editModal.symbol,
          side: _d > 0 ? "buy" : "sell",
          quantity: Math.abs(_d),
          price: numBR(e.editSellPrice) > 0 ? parseFloat((numBR(e.editSellPrice) / Math.abs(_d)).toFixed(4)) : numBR(e.editPrice),
          // a data e a DESTA operacao, nao a da entrada. Em 09/10/2026
          // uma compra feita no dia entrou no livro com 2026-09-17, que
          // era a data da entrada, e o resultado realizado ordena por
          // traded_at. O modal agora tem campo proprio para a data da
          // operacao, ao lado do preco; vazio significa hoje.
          traded_at: e.editOpDate || _hoje
        })
      }
    }
    setEditModal(null)
    setEditModalEntries([])
    setEditModalLoading(false)
    loadPositions()
  }

  async function fetchTechnical(ticker) {
    setLoadingTech(true)
    try {
      const res = await fetch(API_URL + "/technical/" + ticker, { headers: hdrAuth() })
      const data = await res.json()
      setTechnical(data)
      registrarAnalise(ticker, data)
    } catch(e) {}
    setLoadingTech(false)
  }

  // Grava cada analise da ⭐ para conferir DEPOIS se o score acertou.
  // Um registro por ticker por dia: abrir a mesma analise varias vezes
  // inflava a base com observacoes que nao sao independentes.
  async function jaRegistradoHoje(ticker, coluna) {
    try {
      const hoje = new Date(); hoje.setHours(0,0,0,0)
      let q = supabase.from("analises").select("id")
        .eq("user_id", user.id).eq("symbol", ticker.trim().toUpperCase())
        .gte("criado_em", hoje.toISOString()).limit(1)
      if (coluna) q = q.not(coluna, "is", null)
      const { data } = await q
      return Array.isArray(data) && data.length > 0
    } catch(e) { return false }
  }

  async function registrarAvancado(ticker, adv) {
    try {
      if (!user?.id || !adv || adv.error) return
      const av = scoreAvancado(adv)
      if (!av) return
      const preco = adv.current_price
      if (!preco) return
      if (await jaRegistradoHoje(ticker, "advanced_score")) return
      await supabase.from("analises").insert({
        user_id: user.id,
        reguas: REGUAS,
        symbol: ticker.trim().toUpperCase(),
        preco: preco,
        advanced_score: av.fsAj,
        regime_ativo: regimeDoAtivo(adv)
      })
    } catch(e) {}
  }

  // Resumo tecnico por tempo grafico: guarda o SALDO do veredito geral de cada
  // prazo, de -1 a +1. O sinal diz o lado em que aquele prazo apostou e o modulo
  // diz a conviccao, entao a mesma coluna mede direcao e forca. Nulo quando o
  // prazo veio "sem dados suficientes": ausencia de medicao nao e zero.
  // regime_ativo fica nulo de proposito. Ele e definido por EMA9, EMA21 e EMA50 e
  // esta rota devolve medias de 5, 10, 20 e 50. Usar periodos diferentes com o
  // mesmo nome quebraria a comparacao com os registros que ja existem.
  async function registrarMultiTf(ticker, mt) {
    try {
      if (!user?.id || !mt || mt.error || !mt.prazos) return
      const dia = mt.prazos.diario
      if (!dia || dia.erro || !dia.resumo || !dia.fechamento) return
      const sal = k => {
        const pz = mt.prazos[k]
        if (!pz || pz.erro || !pz.resumo) return null
        const v = pz.resumo.geral.saldo
        return (v === null || v === undefined) ? null : v
      }
      if (sal("diario") === null) return
      if (await jaRegistradoHoje(ticker, "mtf_dia")) return
      await supabase.from("analises").insert({
        user_id: user.id,
        reguas: REGUAS,
        symbol: ticker.trim().toUpperCase(),
        preco: dia.fechamento,
        mtf_30min: sal("30min"),
        mtf_1h: sal("1h"),
        mtf_dia: sal("diario"),
        mtf_semana: sal("semanal"),
        mtf_mes: sal("mensal")
      })
    } catch(e) {}
  }

  // Mesma mecanica do registrarMultiTf: uma linha por ativo por dia, com o
  // saldo do veredito do oscilador em cada prazo. O preco_30d e preenchido
  // depois pela rotina /conferir-analises, que varre qualquer linha vencida
  // sem filtrar por coluna — conferido no backend antes de criar estas colunas.
  async function registrarEw(ticker, mt) {
    try {
      if (!user?.id || !mt || mt.error || !mt.prazos) return
      const dia = mt.prazos.diario
      if (!dia || dia.erro || !dia.fechamento) return
      const sal = k => {
        const pz = mt.prazos[k]
        if (!pz || pz.erro || !pz.veredito_ew) return null
        const v = pz.veredito_ew.saldo
        return (v === null || v === undefined) ? null : v
      }
      if (sal("diario") === null) return
      if (await jaRegistradoHoje(ticker, "ew_dia")) return
      await supabase.from("analises").insert({
        user_id: user.id,
        reguas: REGUAS,
        symbol: ticker.trim().toUpperCase(),
        preco: dia.fechamento,
        ew_30min: sal("30min"),
        ew_1h: sal("1h"),
        ew_dia: sal("diario"),
        ew_semana: sal("semanal"),
        ew_mes: sal("mensal")
      })
    } catch(e) {}
  }

  // Regime do ATIVO analisado, para depois medir se os scores funcionam
  // igual em alta, baixa e lateral. ADX classico: 25 separa tendencia de
  // lateral; acima disso, a EMA50 diz o lado.
  function regimeDoAtivo(tech) {
    const cp = parseFloat(tech?.current_price)
    const e9 = parseFloat(tech?.ema?.ema9), e21 = parseFloat(tech?.ema?.ema21), e50 = parseFloat(tech?.ema?.ema50)
    if ([cp, e9, e21, e50].some(isNaN)) return null
    if (e9 > e21 && e21 > e50 && cp >= e9) return "alta"
    if (e9 < e21 && e21 < e50 && cp <= e9) return "baixa"
    return "lateral"
  }

  async function registrarDca(ticker, tech) {
    try {
      if (!user?.id || !tech?.current_price) return
      const pos = etfEnriched.find(x => x.symbol === ticker)
      if (!pos) return
      const avg = parseFloat(pos.avg_price) || 0
      const cur = parseFloat(tech.current_price) || 0
      if (avg <= 0 || cur <= 0) return
      const pctAbaixo = (avg - cur) / avg * 100
      const sc = scoreDca(pctAbaixo, tech.rsi)
      if (sc === null) return
      if (await jaRegistradoHoje(ticker, "dca_score")) return
      await supabase.from("analises").insert({
        user_id: user.id,
        reguas: REGUAS,
        symbol: ticker.trim().toUpperCase(),
        preco: cur,
        dca_score: sc,
        regime_ativo: regimeDoAtivo(tech)
      })
    } catch(e) {}
  }

  async function registrarOversold(ticker, tech) {
    try {
      if (!user?.id || !tech) return
      const sc = scoreOversold(tech.rsi, tech.macd?.signal_label)
      if (sc === null || !tech.current_price) return
      if (await jaRegistradoHoje(ticker, "oversold_score")) return
      await supabase.from("analises").insert({
        user_id: user.id,
        reguas: REGUAS,
        symbol: ticker.trim().toUpperCase(),
        preco: tech.current_price,
        oversold_score: sc,
        regime_ativo: regimeDoAtivo(tech)
      })
    } catch(e) {}
  }

  // Nao altera nada na tela: se falhar, a analise continua funcionando.
  async function registrarAnalise(ticker, data) {
    try {
      if (!user?.id || !data?.rsi || !data?.current_price) return
      if (await jaRegistradoHoje(ticker, "confluence_score")) return
      const cf = scoreConfluence(data)
      const ex = scoreExhaustion(data)
      await supabase.from("analises").insert({
        user_id: user.id,
        reguas: REGUAS,
        symbol: ticker.trim().toUpperCase(),
        preco: data.current_price,
        confluence_score: cf.abs,
        confluence_dir: cf.dir,
        exhaustion_score: ex.score,
        exhaustion_label: ex.label,
        rsi: data.rsi,
        regime_ativo: regimeDoAtivo(data)
      })
    } catch(e) {}
  }

  async function fetchPortfolioTechnical() {
    if (positions.length === 0) return
    // sem preco de mercado o backend cai no avg_price e TODAS as metricas
    // saem calculadas sobre o custo — melhor nao calcular do que calcular errado
    if (etfEnriched.some(p => !p.currentPrice || p.currentPrice <= 0)) {
      alert("Aguarde os preços carregarem antes de analisar.")
      return
    }
    setLoadingPortfolioTech(true)
    const results = {}
    const tickers = [...new Set(positions.map(p => p.symbol))]
    for (const ticker of tickers) {
      try {
        const res = await fetch(API_URL + "/technical/" + ticker, { headers: hdrAuth() })
        const data = await res.json()
        if (!data.error) results[ticker] = data
      } catch(e) {}
    }
    setPortfolioTechnical(results)
    setLoadingPortfolioTech(false)
    for (const [tk, d] of Object.entries(results)) { registrarOversold(tk, d); registrarDca(tk, d) }
  }

  // NOTA dos 11 carregadores de aba abaixo: cada um dispara
  // uma busca quando a aba abre. Incluir a funcao nas
  // dependencias, como o lint pede, a recriaria a cada
  // render e a busca passaria a repetir sem parar, a menos
  // que cada carregador fosse embrulhado em useCallback.
  // Decisao de 08/10/2026: suprimir COM razao, para a saida
  // do lint ficar vazia e qualquer aviso NOVO ficar visivel.
  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === 'grafico' && isPremium2) carregarHistorico() }, [tab, isPremium2])

  // Confere as analises vencidas: uma vez por dia, ao abrir a estrela.
  // Dispara e esquece — se falhar, a aba nao pode nem piscar.
  useEffect(() => {
    if (tab !== "premium") return
    try {
      const hoje = new Date().toISOString().slice(0, 10)
      if (localStorage.getItem("ultima_conferencia") === hoje) return
      localStorage.setItem("ultima_conferencia", hoje)
      fetch(API_URL + "/conferir-analises", { headers: hdrAuth() }).catch(() => {})
    } catch (e) {}
  }, [tab])

  // Mesmo ativo no mesmo dia e UMA observacao: antes da trava diaria (27/09)
  // uma analise repetida gerava linha nova, e contar todas infla a base.
  function semRepetir(linhas) {
    // guarda a PRIMEIRA do dia, entao a ordem da consulta decide qual
    // sobrevive. As nove leitoras ordenam criado_em asc para casar com
    // a rota /acertos-agregados, que ordena igual.
    const vistos = new Set()
    return (linhas || []).filter(r => {
      const k = r.symbol + "|" + String(r.criado_em || "").slice(0, 10)
      if (vistos.has(k)) return false
      vistos.add(k); return true
    })
  }

  const [acertos, setAcertos] = useState(null)

  // Ao abrir a 🧬 o resumo carrega sozinho: sem base passa a significar
  // so uma coisa, falta de dado, e nunca falta de consulta.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (tab === "premium5" && isPremium5) { setResumoLoading(true); Promise.all([carregarAcertos(), carregarAcertosMtf(), carregarExDir(), carregarPorRegime(), carregarScoresRegime(), carregarCalibMc(), carregarAcertosAv(), carregarAcertosEw(), carregarAcertosDca(), carregarAcertosOv()]).catch(() => {}).finally(() => setResumoLoading(false)) } }, [tab, isPremium5])

  // Le as analises ja vencidas e conta quantas o Confluence acertou.
  async function carregarAcertos() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, reguas, confluence_dir, exhaustion_score, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("confluence_dir", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setAcertos({ total: 0 }); return }
      let altaOk = 0, altaTot = 0, baixaOk = 0, baixaTot = 0
      // Exaustao nao aponta lado: em vez de acerto, mede-se se os retornos
      // dos scores altos se separam dos baixos.
      const retAlto = [], retBaixo = []
      // Linha de base: quantas subiram, independente do que o Confluence disse.
      // Sem isso, 65% de acerto pode ser so o mercado tendo subido 65% das vezes.
      let subiu = 0, comparadas = 0
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1) return
        const ret = (p1 - p0) / p0 * 100
        // Cada acumulador confere a SUA regua. Hoje confluence e exaustao
        // estao na mesma versao, mas sao duas medidas no mesmo laco: se uma
        // mudar sozinha, a outra nao pode ser arrastada junto.
        if (reguaAtual(r, "confluence")) {
          if (r.confluence_dir === "bullish") { altaTot++; if (p1 > p0) altaOk++ }
          if (r.confluence_dir === "bearish") { baixaTot++; if (p1 < p0) baixaOk++ }
          comparadas++
          if (p1 > p0) subiu++
        }
        if (reguaAtual(r, "exaustao")) {
          const ex = parseFloat(r.exhaustion_score)
          if (ex >= 60) retAlto.push(ret)
          else if (ex <= 40) retBaixo.push(ret)
        }
      })
      setAcertos({ total: comparadas, altaOk, altaTot, baixaOk, baixaTot,
        subiu, comparadas,
        exAltoN: retAlto.length, exAltoMed: media(retAlto),
        exBaixoN: retBaixo.length, exBaixoMed: media(retBaixo) })
    } catch (e) { setAcertos(null) }
  }

  const [acertosAv, setAcertosAv] = useState(null)

  // O Advanced Score nao aponta direcao: mede-se se os scores altos se
  // separam dos baixos no retorno de 30 dias, com a linha de base ao lado.
  async function carregarAcertosAv() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, reguas, advanced_score, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("advanced_score", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setAcertosAv({ total: 0 }); return }
      const retAlto = [], retBaixo = [], todos = []
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1 || !reguaAtual(r, "advanced")) return
        const ret = (p1 - p0) / p0 * 100
        todos.push(ret)
        const sc = parseFloat(r.advanced_score)
        if (sc >= 65) retAlto.push(ret)
        else if (sc <= 40) retBaixo.push(ret)
      })
      setAcertosAv({ total: todos.length,
        altoN: retAlto.length, altoMed: media(retAlto),
        baixoN: retBaixo.length, baixoMed: media(retBaixo),
        baseMed: media(todos) })
    } catch (e) { setAcertosAv(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium" && user) carregarAcertos() }, [tab, user])
  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium4" && user) carregarAcertosAv() }, [tab, user])

  const [, setCalibMc] = useState(null)

  // Calibracao do Prob+: quando o app disse 70%, aconteceu 70% das vezes?
  // Compara a probabilidade declarada com a frequencia observada em 12 meses.
  async function carregarCalibMc() {
    if (!user) return
    try {
      const { data } = await supabase.from("snapshots")
        .select("mc_prob_positive, retorno_12m")
        .eq("user_id", user.id)
        .not("retorno_12m", "is", null)
      if (!data || data.length === 0) { setCalibMc({ total: 0 }); return }
      let altoN = 0, altoOk = 0, baixoN = 0, baixoOk = 0, ok = 0
      const pares = []
      data.forEach(r => {
        const pb = parseFloat(r.mc_prob_positive), rt = parseFloat(r.retorno_12m)
        if (isNaN(pb) || isNaN(rt)) return
        pares.push([pb / 100, rt > 0 ? 1 : 0])
        if (rt > 0) ok++
        if (pb >= 60) { altoN++; if (rt > 0) altoOk++ }
        else if (pb <= 40) { baixoN++; if (rt > 0) baixoOk++ }
      })
      // Brier: erro quadratico medio entre a probabilidade declarada e o que
      // aconteceu. Usa cada previsao isolada, sem agrupar em faixas — aproveita
      // melhor amostra pequena. A base de comparacao e sempre chutar a
      // frequencia observada, que e o melhor palpite sem modelo nenhum.
      const brier = pares.length ? pares.reduce((a, [q, y]) => a + (q - y) ** 2, 0) / pares.length : null
      const freq = pares.length ? pares.reduce((a, [, y]) => a + y, 0) / pares.length : null
      const brierBase = pares.length ? pares.reduce((a, [, y]) => a + (freq - y) ** 2, 0) / pares.length : null
      setCalibMc({ total: data.length, altoN, altoOk, baixoN, baixoOk, ok, brier, brierBase, nBrier: pares.length })
    } catch (e) { setCalibMc(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium2" && user) carregarCalibMc() }, [tab, user])

  const [acertosOv, setAcertosOv] = useState(null)

  // Sobrevenda afirma que o ativo esticou para baixo e tende a voltar:
  // mede-se se as notas altas renderam mais que as baixas em 30 dias.
  async function carregarAcertosOv() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, oversold_score, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("oversold_score", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setAcertosOv({ total: 0 }); return }
      const retAlto = [], retBaixo = [], todos = []
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1) return
        const ret = (p1 - p0) / p0 * 100
        todos.push(ret)
        const sc = parseFloat(r.oversold_score)
        if (sc >= 60) retAlto.push(ret)
        else if (sc <= 40) retBaixo.push(ret)
      })
      setAcertosOv({ total: todos.length,
        altoN: retAlto.length, altoMed: media(retAlto),
        baixoN: retBaixo.length, baixoMed: media(retBaixo),
        baseMed: media(todos) })
    } catch (e) { setAcertosOv(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium5" && user) carregarAcertosOv() }, [tab, user])

  const [acertosMtf, setAcertosMtf] = useState(null)

  // O resumo por tempo grafico APONTA LADO: saldo positivo e aposta em alta,
  // negativo em baixa. Logo mede-se acerto de direcao, como no Confluence, e nao
  // separacao de retorno medio como na exaustao, que nao aponta lado.
  // Cada prazo e medido sozinho porque a pergunta e qual prazo serve.
  async function carregarAcertosMtf() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, mtf_30min, mtf_1h, mtf_dia, mtf_semana, mtf_mes, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("mtf_dia", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setAcertosMtf({ total: 0 }); return }
      const chaves = ["mtf_30min", "mtf_1h", "mtf_dia", "mtf_semana", "mtf_mes"]
      const por = {}
      chaves.forEach(k => { por[k] = { alta: 0, altaOk: 0, baixa: 0, baixaOk: 0 } })
      let subiu = 0, comparadas = 0
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1) return
        comparadas++
        if (p1 > p0) subiu++
        chaves.forEach(k => {
          if (r[k] === null || r[k] === undefined) return
          const v = parseFloat(r[k])
          if (v > 0) { por[k].alta++; if (p1 > p0) por[k].altaOk++ }
          else if (v < 0) { por[k].baixa++; if (p1 < p0) por[k].baixaOk++ }
        })
      })
      setAcertosMtf({ total: comparadas, subiu, comparadas, por })
    } catch (e) { setAcertosMtf(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium" && user) carregarAcertosMtf() }, [tab, user])







  async function carregarAcertosEw() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, ew_30min, ew_1h, ew_dia, ew_semana, ew_mes, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("ew_dia", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setAcertosEw({ total: 0 }); return }
      const chaves = ["ew_30min", "ew_1h", "ew_dia", "ew_semana", "ew_mes"]
      const por = {}
      chaves.forEach(k => { por[k] = { alta: 0, altaOk: 0, baixa: 0, baixaOk: 0 } })
      let subiu = 0, comparadas = 0
      const ativos = new Set()
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1) return
        comparadas++
        ativos.add(r.symbol)
        if (p1 > p0) subiu++
        chaves.forEach(k => {
          if (r[k] === null || r[k] === undefined) return
          const v = parseFloat(r[k])
          if (v > 0) { por[k].alta++; if (p1 > p0) por[k].altaOk++ }
          else if (v < 0) { por[k].baixa++; if (p1 < p0) por[k].baixaOk++ }
        })
      })
      setAcertosEw({ total: comparadas, subiu, comparadas, por, ativos: ativos.size })
    } catch (e) { setAcertosEw(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium4" && user) carregarAcertosEw() }, [tab, user])

  // O bloco dos cinco prazos segue o ticker do topo da aba. Trocar de ativo
  // limpa o resultado anterior, para a tela nunca mostrar numero de um ativo
  // com o nome de outro.
  useEffect(() => { setMtData(null); setIntData(null) }, [techTicker])

  const [acertosDca, setAcertosDca] = useState(null)

  // A nota do DCA mede a posicao do investidor no ativo, nao o ativo.
  // A pergunta: estar abaixo do preco medio antecipa recuperacao?
  async function carregarAcertosDca() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, dca_score, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("dca_score", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setAcertosDca({ total: 0 }); return }
      const retAlto = [], retBaixo = [], todos = []
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1) return
        const ret = (p1 - p0) / p0 * 100
        todos.push(ret)
        const sc = parseFloat(r.dca_score)
        if (sc >= 60) retAlto.push(ret)
        else if (sc <= 40) retBaixo.push(ret)
      })
      setAcertosDca({ total: todos.length,
        altoN: retAlto.length, altoMed: media(retAlto),
        baixoN: retBaixo.length, baixoMed: media(retBaixo),
        baseMed: media(todos) })
    } catch (e) { setAcertosDca(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium3" && user) carregarAcertosDca() }, [tab, user])

  const [exDir, setExDir] = useState(null)

  // Exaustao alta diz "esticado, pode virar" sem dizer para que lado.
  // Medir por retorno medio junta reversao de alta com reversao de baixa,
  // que sao opostas. Aqui o RSI separa o lado do movimento esticado.
  async function carregarExDir() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, reguas, exhaustion_score, rsi, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("exhaustion_score", "is", null)
        .not("rsi", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setExDir({ total: 0 }); return }
      const cima = [], baixo = [], todos = []
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        const ex = parseFloat(r.exhaustion_score), rs = parseFloat(r.rsi)
        if (!p0 || !p1 || isNaN(ex) || isNaN(rs)) return
        if (!reguaAtual(r, "exaustao")) return
        const ret = (p1 - p0) / p0 * 100
        todos.push(ret)
        if (ex < 50) return
        if (rs >= 55) cima.push(ret)
        else if (rs <= 45) baixo.push(ret)
      })
      setExDir({ total: todos.length,
        cimaN: cima.length, cimaMed: media(cima),
        baixoN: baixo.length, baixoMed: media(baixo),
        baseMed: media(todos) })
    } catch (e) { setExDir(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium" && user) carregarExDir() }, [tab, user])

  const [porRegime, setPorRegime] = useState(null)
  const [delArm, setDelArm] = useState(null)

  // O mesmo indicador pode acertar em mercado de tendencia e falhar em lateral.
  // Aqui o acerto do Confluence e a linha de base saem separados por regime.
  async function carregarPorRegime() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, reguas, confluence_dir, regime_ativo, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("regime_ativo", "is", null)
        .not("confluence_dir", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setPorRegime({ total: 0 }); return }
      const R = { alta:{ok:0,tot:0,subiu:0}, baixa:{ok:0,tot:0,subiu:0}, lateral:{ok:0,tot:0,subiu:0} }
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        const g = R[r.regime_ativo]
        if (!p0 || !p1 || !g || !reguaAtual(r, "confluence")) return
        const d = r.confluence_dir
        if (d !== "bullish" && d !== "bearish") return
        g.tot++
        const subiu = p1 > p0
        if (p1 > p0) g.subiu++
        if ((d === "bullish") === subiu) g.ok++
        // empate p1 == p0 conta como acerto de baixa, igual a regua principal
      })
      setPorRegime({ total: R.alta.tot + R.baixa.tot + R.lateral.tot, R })
    } catch (e) { setPorRegime(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium" && user) carregarPorRegime() }, [tab, user])

  const [scoresRegime, setScoresRegime] = useState(null)

  // Os tres scores de faixa, separados por regime do ativo. Cada celula
  // compara a faixa alta com a baixa dentro do mesmo tipo de mercado.
  async function carregarScoresRegime() {
    if (!user) return
    try {
      const { data } = await supabase.from("analises")
        .select("symbol, criado_em, reguas, advanced_score, oversold_score, dca_score, regime_ativo, preco, preco_30d")
        .eq("user_id", user.id)
        .not("preco_30d", "is", null)
        .order("criado_em", { ascending: true })
        .not("regime_ativo", "is", null)
      const linhas = semRepetir(data)
      if (!linhas || linhas.length === 0) { setScoresRegime({ total: 0 }); return }
      const cols = { advanced_score: "Advanced", oversold_score: "Sobrevenda", dca_score: "DCA" }
      const out = {}
      Object.keys(cols).forEach(c => {
        out[c] = { alta:{a:[],b:[]}, baixa:{a:[],b:[]}, lateral:{a:[],b:[]} }
      })
      linhas.forEach(r => {
        const p0 = parseFloat(r.preco), p1 = parseFloat(r.preco_30d)
        if (!p0 || !p1) return
        const ret = (p1 - p0) / p0 * 100
        Object.keys(cols).forEach(c => {
          // A consulta traz as tres notas juntas, entao o corte e por linha
          // e por score. O nome da coluna sem "_score" e a chave em REGUAS,
          // entao os tres conferem a sua propria versao: hoje so o advanced
          // exclui alguma coisa, e quando oversold ou dca mudarem isto ja
          // esta pronto.
          if (!reguaAtual(r, c.replace("_score", ""))) return
          const sc = parseFloat(r[c])
          if (isNaN(sc)) return
          const g = out[c][r.regime_ativo]
          if (!g) return
          const lim = c === "advanced_score" ? [65, 40] : [60, 40]
          if (sc >= lim[0]) g.a.push(ret)
          else if (sc <= lim[1]) g.b.push(ret)
        })
      })
      setScoresRegime({ total: linhas.length, out, nomes: cols })
    } catch (e) { setScoresRegime(null) }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- carregador de aba: roda uma vez, de proposito
  useEffect(() => { if (tab === "premium" && user) carregarScoresRegime() }, [tab, user])

  async function carregarHistorico() {
    if (!user?.id) return
    try {
      const { data } = await supabase.from('snapshots')
        .select('criado_em,valor_atual,sharpe,max_drawdown,beta,mc_prob_positive')
        .eq('user_id', user.id).order('criado_em', { ascending: false }).limit(800)
      // ascending:true com limit pegava as 60 MAIS ANTIGAS e o card parava de
      // avancar conforme o uso; pega as 60 recentes e reinverte para plotar
      // A tabela grava a cada carregamento, nao uma vez por dia: em 11/10/2026
      // eram 712 linhas em 52 dias, 22 num dia so. As 60 vagas enchiam com os
      // recarregamentos, e o grafico dizia ao longo do tempo mostrando a semana.
      // Agora: uma linha por dia, a ultima, e sessenta dias de verdade.
      const _rev = (data || []).slice().reverse()
      const _pd = new Map()
      _rev.forEach(x => _pd.set(String(x.criado_em).slice(0, 10), x))
      setHistorico(Array.from(_pd.values()).slice(-60))
    } catch (e) {}
  }

  async function fetchPortfolioStats() {
    if (positions.length === 0) return
    setLoadingStats(true)
    try {
      const res = await fetch(API_URL + "/portfolio-stats2", {
        method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
        body: JSON.stringify({positions: [...new Map(etfEnriched.map(p => [p.symbol, p])).values()].map(p => ({symbol: p.symbol, quantity: p.quantity, avg_price: p.avg_price, current_price: p.currentPrice || p.avg_price})), period: "1y"})
      })
      const data = await res.json()
      setPortfolioStats(data)
      // o timestamp so era gravado quando nao havia erro, mas os dados eram
      // gravados sempre: uma analise com erro deixava ts velho + dados novos,
      // e o aoVoltar apagava metricas recem-calculadas ao voltar pro app
      try {
        if (data.error) sessionStorage.removeItem('claw_stats_ts')
        else sessionStorage.setItem('claw_stats_ts', String(Date.now()))
      } catch (e) {}
      // guarda o retrato de cada analise: permite responder depois "o que eu
      // estava vendo quando decidi?" e detectar numero que muda sem motivo
      try {
        const _hoje = new Date().toISOString().slice(0, 10)
          const _hj = user?.id ? (await supabase.from("snapshots").select("id").eq("user_id", user.id).gte("criado_em", _hoje).limit(1)).data : null
          // uma linha por dia. Gravava a cada carregamento: em 11/10/2026 eram
          // 712 linhas em 52 dias, 22 num dia so, e o grafico de evolucao das
          // metricas encolhia para um dia, parecendo risco constante.
          if (user?.id && !data.error && !(_hj && _hj.length > 0)) {
          const _tv = etfEnriched.reduce((a, x) => a + (x.value || 0), 0)
          await supabase.from('snapshots').insert({
            user_id: user.id,
            valor_atual: _tv,
            investido: etfEnriched.reduce((a, x) => a + (x.quantity || 0) * parseFloat(x.avg_price || 0), 0),
            sharpe: parseFloat(data.sharpe_ratio) || null,
            sortino: parseFloat(data.sortino_ratio) || null,
            var_95: parseFloat(data.var_95) || null,
            max_drawdown: parseFloat(data.max_drawdown) || null,
            beta: parseFloat(data.beta) || null,
            volatilidade: parseFloat(data.volatility) || null,
            hhi: parseFloat(data.hhi) || null,
            mc_prob_positive: parseFloat(data.monte_carlo?.prob_positive) || null,
            mc_median: parseFloat(data.monte_carlo?.median) || null,
            n_pregoes: data.n_pregoes || null,
            posicoes: etfEnriched.map(x => ({
              t: x.symbol,
              peso: _tv > 0 ? Math.round((x.value || 0) / _tv * 10000) / 100 : 0,
              pnl_pct: x.pnlPct ?? null,
              preco: x.currentPrice ?? null
            }))
          })
        }
      } catch (e) {}
    } catch(e) {}
    setLoadingStats(false)
  }

  function applyPromoCode() {
    if (promoCode.trim().toUpperCase() === "CLAWETF2026") {
      setIsPremium(true)
      setIsPremium2(true)
      setIsPremium3(true)
      setPromoError("")
      alert("Codigo valido! Acesso Premium completo liberado!")
    } else {
      setPromoError("Código inválido. Tente novamente.")
    }
  }

  async function handleSubscribe(currency) {
    try {
      const priceId = currency === "BRL" ? PRICE_BRL : PRICE_USD
      const res = await fetch(API_URL + "/create-checkout", {
        method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
        body: JSON.stringify({priceId, userId: user?.id, email: user?.email, successUrl: window.location.origin + "?premium=true", cancelUrl: window.location.origin})
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert("Erro: " + (data.error || "Tente novamente"))
    } catch(e) { alert("Erro ao processar pagamento") }
  }

  async function handleSubscribe2(currency) {
    try {
      const priceId = currency === "BRL" ? PRICE2_BRL : PRICE2_USD
      const res = await fetch(API_URL + "/create-checkout", {
        method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
        body: JSON.stringify({priceId, userId: user?.id, email: user?.email, successUrl: window.location.origin + "?premium2=true", cancelUrl: window.location.origin})
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert("Erro: " + (data.error || "Tente novamente"))
    } catch(e) { alert("Erro ao processar pagamento") }
  }

  async function handleSubscribe3(currency) {
    try {
      const priceId = currency === "BRL" ? PRICE3_BRL : PRICE3_USD
      const res = await fetch(API_URL + "/create-checkout", {
        method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
        body: JSON.stringify({priceId, userId: user?.id, email: user?.email, successUrl: window.location.origin + "?premium3=true", cancelUrl: window.location.origin})
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert("Erro: " + (data.error || "Tente novamente"))
    } catch(e) { alert("Erro ao processar pagamento") }
  }

  async function handleSubscribe4(currency) {
    try {
      const priceId = currency === "BRL" ? PRICE4_BRL : PRICE4_USD
      const res = await fetch(API_URL + "/create-checkout", {
        method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
        body: JSON.stringify({priceId, userId: user?.id, email: user?.email, successUrl: window.location.origin + "?premium4=true", cancelUrl: window.location.origin})
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert("Erro: " + (data.error || "Tente novamente"))
    } catch(e) { alert("Erro ao processar pagamento: " + e.message) }
  }

  async function handleSubscribe5(currency) {
    try {
      const priceId = currency === "BRL" ? PRICE5_BRL : PRICE5_USD
      const res = await fetch(API_URL + "/create-checkout", {
        method: "POST", headers: {"Content-Type": "application/json", ...hdrAuth()},
        body: JSON.stringify({priceId, userId: user?.id, email: user?.email, successUrl: window.location.origin + "?premium5=true", cancelUrl: window.location.origin})
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert("Erro: " + (data.error || "Tente novamente"))
    } catch(e) { alert("Erro ao processar pagamento: " + e.message) }
  }

  async function generatePremium3Analysis() {
    // Sharpe 0 e falsy em JS: com a carteira em Sharpe ~0.00 a 🧠 dizia que a
    // 💎 nao tinha rodado mesmo com todas as metricas carregadas
    if (!portfolioStats || portfolioStats?.sharpe_ratio === undefined || portfolioStats?.sharpe_ratio === null) {
      alert("Execute primeiro a análise do Premium 2!")
      return
    }
    if (false) {
      setPremium3Analysis("Erro: chave da API Anthropic não configurada.")
      return
    }
    setLoadingPremium3(true)
    setPremium3Analysis("")
    try {
      const tvP3 = etfEnriched.reduce((s,p)=>s+(p.value||0),0)
      const btcDP3 = etfEnriched.filter(p=>BTC_ETFS.includes(p.symbol)).length>1
      const ethDP3 = etfEnriched.filter(p=>["ETHA","FETH","ETHW","ETHE","ETH"].includes(p.symbol)).length>1
      const estP3 = Math.max(0, 100 - (etfEnriched.reduce((m,x)=>Math.max(m, tvP3>0?(x.value||0)/tvP3*100:0),0) > 25 ? 20 : 0) - (etfEnriched.filter(x=>["IBIT","FBTC","BITB","ARKB","GBTC","ETHA","FETH","ETHW","ETHE","ETH","BSOL"].includes(x.symbol)).reduce((a,x)=>a+(tvP3>0?(x.value||0)/tvP3*100:0),0) > 40 ? 20 : 0) - (btcDP3 || ethDP3 ? 15 : 0) - (etfEnriched.length < 3 ? 15 : 0))
      const shP3 = parseFloat(portfolioStats?.sharpe_ratio)||0
      const risP3 = Math.max(0,Math.min(100,shP3>=1?90:shP3>=0?60:shP3>=-1?35:shP3>=-2?15:5))
      const hhP3 = portfolioStats?.hhi||0.5
      const divP3 = (() => { const _h = Math.max(0, Math.min(100, (0.40 - (hhP3)) / 0.30 * 100)); const _c = portfolioStats?.correlation; let _v = []; if (_c) Object.entries(_c).forEach(([t,r]) => Object.entries(r).forEach(([t2,x]) => { if (t < t2) _v.push(Math.abs(x)) })); const _cm = _v.length ? _v.reduce((a,b)=>a+b,0)/_v.length : null; const _s = _cm === null ? _h : Math.max(0, Math.min(100, (0.60 - _cm) / 0.45 * 100)); return Math.round(_cm === null ? _h : _h*0.5 + _s*0.5) })()
      const wtP3 = etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)
      const wpP3 = tvP3>0?wtP3/tvP3*100:0
      const momP3 = Math.min(100,Math.max(0,50+wpP3*5))  // era *3 e divergia do card da 🧠 (*5): o prompt dizia 75 e a tela 74
      const mcP3 = parseFloat(portfolioStats?.monte_carlo?.prob_positive)||0
      // a regua antiga zerava tudo abaixo de 30% de prob+: uma carteira com 5% e outra
      // com 29% recebiam a mesma nota. Agora comeca em zero e mede movimento.
      const perP3 = pilarPerspectiva(mcP3)
      const _scP3 = scorePremium(estP3, risP3, divP3, momP3, perP3)
      const _brutoP3 = _scP3.bruto
      const _piorP3 = [_scP3.pior.n, _scP3.pior.v]
      const totP3 = _scP3.total
      const _limP3 = totP3 < _brutoP3 ? ` (LIMITADO: a media daria ${_brutoP3}, mas o pilar ${_piorP3[0]} esta fraco)` : ""
      const toGP3 = s=>s>=90?"A+":s>=83?"A":s>=76?"A-":s>=70?"B+":s>=63?"B":s>=56?"B-":s>=50?"C+":s>=43?"C":s>=36?"C-":s>=30?"D+":s>=23?"D":"F"
      const premiumScoreStr = `ClawETF Premium Score (aba 🧠 Premium 3): ${totP3}/100${_limP3} | Estrutura: ${toGP3(estP3)} | Risco: ${toGP3(risP3)} | Diversificação: ${toGP3(divP3)} | Momentum: ${toGP3(momP3)} | Cenários positivos: ${toGP3(perP3)}`
      // este bloco tinha a copia Ctx do score: faltava o
      // "10 +" no ramo de Sharpe positivo e sobrava um +5 de
      // Fibonacci perto de suporte que o card nao tem.
      // Agora sai da lib, testada contra a tela.
      const _cfCtx = scoreConfianca({
        etfEnriched,
        totalValue: etfEnriched
          .reduce((x, q) => x + (q.value || 0), 0),
        portfolioStats,
        news,
        newsSentiment,
        portfolioTechnical,
      })
      const diversificationCtx = _cfCtx.diversificacao
      const sharpeScoreCtx = _cfCtx.sharpe
      const regimeScoreCtx = _cfCtx.regime
      const newsScoreCtx = _cfCtx.macro
      const technicalScoreCtx = _cfCtx.tecnico
      // sem dados tecnicos o score fica no default 15 — o prompt precisa dizer
      // isso, senao o modelo trata o placeholder como medicao real
      const tecMedido = Object.keys(portfolioTechnical).length > 0
      const tecNota = tecMedido ? "" : " (VALOR PADRAO — analise tecnica nao foi executada; NAO tire conclusoes deste numero)"
      // mesma regra do card da aba ⚡ (1.25 / 1.0 / 0.85): antes o bot usava
      // 1.15 e citava um VaR ajustado diferente do que a tela mostra
      const _medDC = (() => { const a = etfEnriched.map(x => x.dailyChange || 0).sort((m,n)=>m-n); const k = a.length; return k === 0 ? 0 : (k % 2 ? a[(k-1)/2] : (a[k/2-1]+a[k/2])/2) })()
      const varAjustado = portfolioStats?.var_95 ? (portfolioStats?.var_95 * (Math.abs(_medDC) < 0.5 ? 1 : _medDC < 0 ? 1.25 : 0.85)).toFixed(2) : null
      const totalDailyAbsCtx = etfEnriched.reduce((s,p)=>s+Math.abs(p.dailyPnl||0),0)
      const sortedDrivers = [...etfEnriched].sort((a,b)=>Math.abs(b.dailyPnl||0)-Math.abs(a.dailyPnl||0))
      const driverStr = "Movimento hoje (quem puxou o portfólio): " + sortedDrivers.map(p => p.symbol+" "+((p.dailyPnl||0)>=0?"+":"")+("$"+(p.dailyPnl||0).toFixed(2))+" ("+(totalDailyAbsCtx>0?(Math.abs(p.dailyPnl||0)/totalDailyAbsCtx*100).toFixed(1):0)+"% do movimento total)").join(", ")
      const totalValCtx = etfEnriched.reduce((s,p)=>s+(p.value||0),0)
      // mesmo calculo da tela: risco = peso x volatilidade, e sem volatilidade
      // nao existe eficiencia — o valor antigo dava numeros absurdos para o SPCX
      const riskStr = "Risk Contribution (peso x volatilidade) & Movimento ajustado ao risco (hoje): " + (() => {
        const _st = portfolioStats?.position_stats || {}
        const _vol = x => parseFloat(_st[x.symbol]?.volatility) || 0
        const _tot = etfEnriched.reduce((a,x) => a + (totalValCtx>0?(x.value||0)/totalValCtx*100:0) * _vol(x), 0)
        return etfEnriched.map(p => {
          const peso = totalValCtx>0?((p.value||0)/totalValCtx*100):0
          const v = _vol(p)
          if (v <= 0) return p.symbol+"=risco:sem dados,peso"+peso.toFixed(1)+"%"
          const risco = _tot>0 ? peso*v/_tot*100 : 0
          const drvPct = totalDailyAbsCtx>0?(Math.abs(p.dailyPnl||0)/totalDailyAbsCtx*100):0
          const eff = risco>0?(drvPct/risco):0
          return p.symbol+"=risco"+risco.toFixed(1)+"%,peso"+peso.toFixed(1)+"%,mov"+eff.toFixed(2)
        }).join(", ")
      })()
      const regimeCtx = regimeDe(etfEnriched.map(x => x.dailyChange || 0))
      const weeklyTotalPnl = etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)
      const weeklyStr3 = "Performance semanal: " + etfEnriched.map(p => p.symbol + "=" + (prices[p.symbol]?.weekly_change_pct >= 0 ? "+" : "") + (prices[p.symbol]?.weekly_change_pct ?? 0).toFixed(2) + "%").join(", ") + " | Total: $" + weeklyTotalPnl.toFixed(2)
      let flowsStr = ""
      try {
        const flowsResp = await fetch(`${API_URL}/etf-flows`)
        const flowsData = await flowsResp.json()
        if (flowsData && flowsData.bitcoin) {
          flowsStr = "Volume NEGOCIADO (nao e captacao nem entrada de dinheiro: toda negociacao tem comprador e vendedor; volume alto em dia de queda indica pressao vendedora) no pregao FECHADO de " + (flowsData.session_date || "ultimo dia util") + " (NAO e o volume de hoje se o mercado ainda nao abriu): BTC=" + (flowsData.bitcoin||[]).map(e=>e.ticker+"$"+e.volume_usd_m+"M").join(",") + " | ETH=" + (flowsData.ethereum||[]).map(e=>e.ticker+"$"+e.volume_usd_m+"M").join(",")
        }
      } catch(e) { flowsStr = "" }
      const statsText = `Portfolio Stats:
Sharpe: ${portfolioStats?.sharpe_ratio} | Sortino: ${portfolioStats?.sortino_ratio} | Calmar: ${portfolioStats?.calmar_ratio}
Max Drawdown: ${portfolioStats?.max_drawdown}% | Beta S&P: ${portfolioStats?.beta} | Volatilidade: ${portfolioStats?.volatility}%
VaR 95%: ${portfolioStats?.var_95}% | VaR 99%: ${portfolioStats?.var_99}% | ATENCAO aos dois horizontes: o VaR 95% acima e DIARIO e sai do historico real. Do Monte Carlo de 1 ANO, com deriva ZERO, saem VaR 95% ano: ${portfolioStats?.monte_carlo_current?.var_95_ano ?? portfolioStats?.monte_carlo?.var_95_ano}% e Expected Shortfall 95% ano: ${portfolioStats?.monte_carlo_current?.es_95_ano ?? portfolioStats?.monte_carlo?.es_95_ano}%. O ES e a MEDIA dos 5% piores cenarios e e sempre pior que o VaR do mesmo nivel. NUNCA compare o VaR diario com o anual nem some os dois | Concentração: ${portfolioStats?.concentration}
TESTE DE ESTRESSE (aba cerebro): ${stress && stress.veredito
  ? "cobertura " + stress.cobertura_pct + "% da carteira"
    + " | " + stress.veredito.peso_pct + "% DO PESO EM DOLAR da carteira responde ao fator "
    + stress.veredito.fator
    + " | pior caso MEDIDO: " + stress.veredito.pior_pct
    + "% em " + stress.veredito.pior_nome
    + " | peso por fator: " + JSON.stringify(stress.por_fator)
    + " | escadas de queda: " + JSON.stringify(stress.escadas)
    + " | cenarios historicos: " + JSON.stringify(stress.cenarios)
    + " | replay: " + JSON.stringify(stress.replay)
    + " | erro do mapa: " + JSON.stringify(stress.acerto)
    + " | sem fator conhecido: " + JSON.stringify(stress.nao_mapeados)
  : "nao carregado nesta sessao"}
${REGRAS_ESTRESSE}
Retorno Anual: ${portfolioStats?.annual_return}% | S&P500: ${portfolioStats?.benchmark_comparison?.sp500}% | Bitcoin ETF: ${portfolioStats?.benchmark_comparison?.bitcoin_etf}%
Monte Carlo (pesos historicos, DERIVA ZERO: a simulacao nao tem opiniao sobre direcao, so dispersao, entao a mediana fica negativa por arrasto de variancia e prob+ fica abaixo de 50% sem que isso seja pessimismo): mediana ${portfolioStats?.monte_carlo?.median}% | prob+ ${portfolioStats?.monte_carlo?.prob_positive}% | Monte Carlo (pesos atuais, mesma deriva zero): mediana ${portfolioStats?.monte_carlo_current?.median || portfolioStats?.monte_carlo?.median}% | prob+ ${portfolioStats?.monte_carlo_current?.prob_positive || portfolioStats?.monte_carlo?.prob_positive}%${mcSnapshot ? " | Monte Carlo Referência ("+mcSnapshot.date+"): mediana "+mcSnapshot.mc.median+"% | prob+ "+mcSnapshot.mc.prob_positive+"%" : ""} 
Posições: ${JSON.stringify(portfolioStats?.position_stats)}
ATENCAO: o campo "weight" acima é renormalizado entre os ativos medidos (exclui ativos sem histórico suficiente). Para o peso real na carteira, use o "peso REAL" informado na lista de POSICOES.`

      // a 🧠 nao recebia o Recovery Time e deduzia com formula propria:
      // em 01/09 escreveu 26/42/81 meses onde o app mostra 12/20/39
      const recoveryStr = (() => {
        const _rt = recoveryTime(portfolioStats?.max_drawdown)
        if (!_rt) return ""
        const _dd = _rt.dd
        const _g = _rt.ganho
        const _m = _rt.meses
        return "Recovery Time (parte de retornos esperados de 20%, 12% e 6% ao ano; NAO usa Monte Carlo nem volatilidade): otimista " + _m(0.20) + " meses, base " + _m(0.12) + " meses, pessimista " + _m(0.06) + " meses. Para recuperar a queda de " + (_dd*100).toFixed(1) + "% a carteira precisa subir " + (_g*100).toFixed(1) + "%. USE ESTES NUMEROS, nao recalcule."
      })()

      // o modelo chamava FBTC de "posicao mais antiga" tendo escrito 796 dias
      // para FETH duas linhas acima: agora recebe o ranking pronto
      const breakevenP3 = (totalValue > 0 && totalInvested > 0)
        ? "Breakeven: para voltar ao valor investido a carteira precisa subir " + ((totalInvested - totalValue) / totalValue * 100).toFixed(2) + "% (P&L atual " + totalPnlPct.toFixed(2) + "%). Este numero e DIFERENTE do Recovery Time acima, que parte do maximo drawdown. Nunca use um no lugar do outro nem misture os dois na mesma frase."
        : ""

      const antiguidadeStr = (() => {
        const _c = etfEnriched.filter(x => x.purchase_date)
          .map(x => [x.symbol, Math.floor((Date.now() - new Date(x.purchase_date).getTime())/86400000)])
          .sort((a,b) => b[1] - a[1])
        if (!_c.length) return ""
        return "Ordem por tempo em carteira (mais antiga primeiro): " + _c.map(x => x[0] + " " + x[1] + "d").join(", ") + ". A posicao MAIS ANTIGA e " + _c[0][0] + "."
      })()

      const portfolioData = etfEnriched.map(p =>
        `${p.symbol}: ${p.quantity} cotas @ $${p.avg_price} DCA, atual $${p.currentPrice?.toFixed(2)}, P&L ${p.pnlPct.toFixed(2)}%, peso REAL ${totalValCtx>0?((p.value||0)/totalValCtx*100).toFixed(2):"0"}% da carteira` +
        (p.purchase_date ? `, ${Math.max(0, Math.floor((Date.now() - new Date(p.purchase_date).getTime())/86400000))} dias em carteira` : "")
      ).join("\n")

      const res = await fetch(API_URL + "/claude", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", ...hdrAuth(),
        },
        body: JSON.stringify({
          model: CLAUDE_MODEL, max_tokens: 8000,
          messages: [{ role: "user", content: `Hoje é ${new Date().toLocaleDateString("pt-BR", {day:"2-digit", month:"long", year:"numeric"})}. Use SEMPRE este ano ao falar de contexto de mercado.

${PREAMBULO_ANALISTA}

DADOS ESTATÍSTICOS:
${statsText}

POSIÇÕES:
${portfolioData}

Regime de mercado hoje: ${regimeCtx}
 Breakdown: Diversificacao=${diversificationCtx}/40 Sharpe=${Math.round(sharpeScoreCtx)}/30 Regime=${regimeScoreCtx}/20 Macro=${newsScoreCtx}/10 Tecnico=${technicalScoreCtx}/30${tecNota}
${premiumScoreStr}${varAjustado ? " | VaR ajustado ao regime: "+varAjustado+"%" : ""}
${recoveryStr}
${breakevenP3}
${antiguidadeStr}
AVISO: os "dias em carteira" contam desde a compra ORIGINAL e NAO mudam apos venda parcial. Uma posicao com muitos dias pode ter sido reduzida recentemente. NAO conclua que o investidor manteve a posicao intocada nesse periodo, nem recomende reducao alegando tempo longo sem recuperacao.
AVISO: volatilidade, Sharpe e retorno anual de cada ativo vem de 252 dias de historico de MERCADO do papel, nao do tempo em carteira. Uma posicao aberta hoje (0 dias) TEM metricas de risco validas e calculadas. Nunca diga que um ativo esta "sem dados de risco" ou "sem historico suficiente" por causa do tempo em carteira; se a volatilidade aparece no Risk Contribution, o dado existe e deve ser usado.
${weeklyStr3}
${driverStr}
${riskStr}
${flowsStr}

Forneça uma análise completa e profissional em português brasileiro com:

REGRAS: a carteira e cotada em DOLAR — nunca converta valores para real \
por conta propria. Ao classificar ativos, use os clusters do \
Diversification Engine (agrupados por correlacao real), nao rotulos \
tematicos deduzidos por voce. NUNCA recomende aportar num ativo que \
esta fora do calculo por historico insuficiente: sem volatilidade nem \
correlacao, o efeito dele na carteira nao pode ser medido. Se ele \
estiver indo bem, diga isso, mas registre que a recomendacao nao tem \
base de risco. Auditoria de 13/08/2026 no Advanced Analytics (aba ⚡): o \
ADX foi corrigido (antes inflava e sinalizava tendencia em mercado \
lateral), o GARCH passou a ser um modelo ajustado aos dados do ativo \
(antes usava parametros fixos e subestimava quando a volatilidade \
subia) e o Hurst deixou de afirmar 'trending' — aquele estimador \
subestima tendencia, entao so diz 'reversao a media' ou 'aleatorio'. \
Ulcer, MFI, OBV, VWAP, Anchored VWAP e Calmar foram verificados e \
estavam corretos. Auditoria de 30/09/2026 no OBV e no Hurst (aba ⚡): o \
OBV deixou de ser binario — o backend devolve 'forca', o saldo de 10 \
pregoes dividido por 10 dias de volume medio, ou seja quantos dias de \
volume normal entraram (+) ou sairam (-). O selo tem tres estados: \
Comprador acima de +0,10, Vendedor abaixo de -0,10 e Equilibrado no \
meio, sendo 0,10 exatamente um dia de volume normal. A nota vai de 15 a \
3 em cinco faixas. O campo 'trend' continua binario por \
compatibilidade, entao um ativo pode ter trend 'bearish' e selo \
'Equilibrado' ao mesmo tempo — isso NAO e contradicao, e o trend \
escolhendo um lado num saldo que e ruido. NUNCA diga 'fluxo comprador' \
so porque o trend e bullish: olhe a forca. O 'trend' le os MESMOS 10 \
pregoes da forca, e o sinal do mesmo saldo — nunca explique a diferenca \
entre eles por horizonte, por MACD ou por medias. A escala absoluta do \
Hurst tem duas faixas e so duas: abaixo de 0.40 reversao a media, acima \
de 0.40 aleatorio; nao invente cortes em 0.45 nem em 0.55 e nunca \
afirme tendencia persistente. \
O KER, Eficiencia de Kaufman, entrou em 16/10/2026 ao lado do Hurst, no \
grupo Risco & Regime do Advanced Analytics. E a variacao liquida de 10 \
pregoes dividida pela soma das 10 variacoes diarias em modulo: perto de 1 \
o preco andou em linha reta, perto de 0 andou e voltou. Ele NAO afirma \
direcao, afirma persistencia. As faixas sao alto a partir de 0.60 e baixo \
ate 0.30, com o miolo descartado — nao invente outro corte e nao o \
converta em sinal de compra ou venda. Ele entrou porque mede o que o \
estimador de Hurst mede mal, e NAO porque substitui o Hurst: os dois \
aparecem na tela. A regra que vai julgar se ele acrescenta foi escrita e \
datada ANTES do primeiro numero, e enquanto nao houver base minima (3 \
leituras de cada faixa em 10 ativos) o app NAO afirma que o KER funciona. \
NAO invente escala para o KER: as unicas faixas sao a partir de 0.60 e ate \
0.30, com o miolo descartado, e nao existe leitura oficial de 'proximo de \
1,0' nem de 'meio a meio'. Perguntado se o KER funciona, se acrescenta ou \
se da sinal, responda a pergunta E diga que a regra ainda nao foi medida. \
Agio e desagio dos ETFs entrou em 31/10/2026 como o DECIMO TERCEIRO \
quesito do app, na aba DNA. Agio e o preco acima do NAV e desagio e o preco \
abaixo dele; o NAV e o valor dos ativos que o fundo guarda por cota. E o \
PRIMEIRO numero do app que nao sai da serie de precos: os outros doze \
quesitos sao todos transformacoes dela, e o NAV vem de outra fonte. O app \
grava NAV, patrimonio e fechamento de 14 fundos de cripto a cada pregao \
desde 30/10/2026, e TREZE deles publicam NAV: o XRPR nao publica e fica fora \
desta medicao, embora entre na tabela. O agio e medido DENTRO de cada fundo, \
contra a media do \
proprio fundo mais meio desvio padrao, e o desagio contra a media menos meio \
desvio, com o miolo descartado: o nivel do premio e caracteristica do FUNDO \
e nao do dia, porque quem cobra taxa de administracao alta negocia com \
desagio cronico, e comparar fundos entre si mediria taxa e nao pressao. NAO \
invente outro corte e NAO converta agio em sinal de compra ou venda. A base \
minima e 20 leituras de cada lado em pelo menos 5 fundos, o horizonte e de \
30 pregoes, e a regra foi escrita e datada ANTES do primeiro numero. \
Limitacao declarada junto com a regra: um agio que so valha para o dia \
seguinte fica invisivel nesse horizonte. Enquanto nao houver base o app NAO \
afirma que o agio funciona; perguntado se ele acrescenta, responda a \
pergunta E diga que faltam cerca de 30 pregoes por fundo so para existir \
media. \
Sobre o resumo por tempo grafico: sao DOZE indicadores na lista, mas o ATR \
NAO vota, entao sao ONZE votos de indicador mais doze de media, vinte e \
tres por prazo. Perguntado quantos votam, a resposta e onze; perguntado \
quantos sao, a resposta e doze. \
No Hurst, a nota passou a sair de 'pct', \
a posicao do valor de hoje na distribuicao dos ultimos 2 anos do \
PROPRIO ativo, porque o valor absoluto desloca com o regime (medido em \
12 anos e 9 ativos: o p90 anda de 0.513 a 0.594, e corte fixo disparava \
em 12% dos dias num ano e em 0.6% noutro). O rotulo da tela continua \
lendo o valor absoluto, entao 'pct 85' junto de rotulo 'Aleatorio' \
tambem NAO e contradicao: e alto para aquele ativo e aleatorio em \
termos absolutos. Continue nunca afirmando 'trending'. As duas reguas \
mudaram em 30/09/2026 — nao compare advanced_score gravado antes dessa \
data com os de depois. O Recovery Time tambem mudou: antes usava \
volatilidade como velocidade de recuperacao e dizia 22 meses; agora \
parte de retorno esperado (20%, 12% e 6% ao ano) e diz 26, 42 e 81 \
meses. Desde 03/10/2026 a aba ⚡ tem tambem o card 'Oscilador 5/34 e \
pernas de Fibonacci', cujos valores NAO chegam no seu contexto: nunca \
cite numero de oscilador, nivel de Fibonacci nem veredito desse card, e \
nunca o confunda com o veredito dos doze indicadores da ⭐. O mesmo vale \
para a 'Meia-vida do afastamento' da aba ⚡, criada em 04/10/2026: o \
valor nao chega no seu contexto, nunca o cite, e nunca o descreva como \
previsao de queda — o afastamento encurta tambem quando a media sobe. \
Ativos sem volatilidade calculada ficam fora das metricas de risco — \
diga "sem dados", nao estime. Na secao DESTAQUES POR ATIVO use UMA \
linha curta por ativo (maximo 20 palavras), e inclua TODOS os ativos da \
carteira — nunca pare no meio da lista.

1. **SITUAÇÃO GERAL** — Avalie o estado atual do portfólio com base nos indicadores estatísticos
2. **ANÁLISE DE RISCO** — Interprete Sharpe, Sortino, Calmar, VaR, Expected Shortfall e Drawdown de forma didática
3. **DIVERSIFICAÇÃO** — Analise a correlação entre ativos e concentração do portfólio
4. **BENCHMARK** — Compare performance com S&P500 e Bitcoin ETF
5. **DISPERSÃO MONTE CARLO** — Interprete a DISPERSÃO dos cenários. A simulação tem deriva ZERO, então NUNCA chame aqueles percentuais de probabilidade nem de chance de lucro: são fração de cenários simulados
6. **DESTAQUES POR ATIVO** — Analise cada posição individualmente
7. **RECOMENDAÇÕES** — Sugestões práticas para melhorar o portfólio
8. **PERSPECTIVA DE MERCADO** — Contexto atual do mercado cripto e ETFs

Seja direto, profissional e honesto. Mínimo 500 palavras, máximo 800 palavras. Use todas as 8 seções obrigatoriamente. Esta é uma análise Premium paga — deve ser visivelmente mais completa e detalhada que uma análise básica.` }]
        })
      })
      const data = await res.json()
      setPremium3Analysis(data.content[0].text)
    } catch(e) { console.error("Premium3 error:", e); setPremium3Analysis("Erro ao gerar análise: " + e.message) }
    setLoadingPremium3(false)
  }

  async function manageSubscription() {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(API_URL + "/customer-portal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", ...hdrAuth(),
          ...(session?.access_token ? {"Authorization": "Bearer " + session.access_token} : {})
        },
        body: JSON.stringify({email: user?.email, return_url: window.location.origin})
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert("Erro: " + (data.error || "Tente novamente"))
    } catch(e) { alert("Erro ao abrir portal") }
  }

  async function runAlternatives(_res) {
    // _res chega como o EVENTO do clique quando o botao passa a funcao direto
    // (onClick={() => runAlternatives()}). O evento e verdadeiro e nao tem simStats, logo
    // o || ficava com ele em vez de cair no optimResult, e a funcao saia no return
    // seguinte sem avisar nada. Ja quebrou o botao duas vezes: agora a checagem e
    // pelo CONTEUDO e nao pela existencia, entao evento nenhum passa por aqui.
    const _r = (_res && _res.simStats) ? _res : optimResult
    if (!etfEnriched.length || !_r?.simStats) return
    setOptimAltsLoading(true)
    setOptimAlts(null)
    try {
      const sellT = optimMode === "rebalance" ? optimSellTicker.trim().toUpperCase() : ""
      // dca e sobrevenda so existem nos ativos que voce ja tem: fora da
      // carteira nao ha preco medio, e o universo externo nao tem RSI.
      if (optimGoal === "dca" || optimGoal === "oversold") {
        const rsiLocal = {}
        for (const ep of etfEnriched) {
          try {
            const _r = await fetch(API_URL + "/technical/" + ep.symbol, { headers: hdrAuth() })
            const _d = await _r.json()
            if (_d && _d.rsi) rsiLocal[ep.symbol] = {rsi: parseFloat(_d.rsi), macd: _d.macd?.signal_label || null}
          } catch(e) {}
        }
        const _loc = rankingLocal(etfEnriched, rsiLocal, optimGoal, portfolioStats)
          .map(r => ({...r, ticker: r.symbol}))   // a lista do Optimizer le "ticker"
        setOptimAlts({
          top: _loc.filter(r => r.score >= 60),
          bottom: _loc.filter(r => r.score <= 40),
          neutros: _loc.filter(r => r.score > 40 && r.score < 60).length,
          // o card procura o ativo simulado aqui: so com top+bottom, um ativo
          // de nota neutra (41-59) nao era encontrado e a nota caia na regua velha
          todos: _loc
        })
        setOptimAltsLoading(false)
        return
      }
      const universe = (OPTIMIZER_UNIVERSE[optimGoal] || OPTIMIZER_UNIVERSE.return).filter(t => t !== sellT)
      const basePositions = etfEnriched.map(p => ({
        symbol: p.symbol, quantity: p.quantity,
        avg_price: p.avg_price, current_price: p.currentPrice || p.avg_price
      }))
      const amount = numBR(optimAmount) || 500

      // Run all in parallel
      const results = await Promise.all(universe.map(async ticker => {
        try {
          const priceRes = await fetch(API_URL + '/technical/' + ticker, { headers: hdrAuth() })
          const priceData = await priceRes.json()
          const price = priceData.current_price || 0
          if (price <= 0) return null
          const qty = amount / price
          let simPos = basePositions.map(p => ({...p}))
          const existing = simPos.find(p => p.symbol === ticker)
          if (existing) { existing.quantity += qty } else { simPos.push({symbol: ticker, quantity: qty, avg_price: price, current_price: price}) }
          const res = await fetch(API_URL + '/portfolio-stats2', {
            method: 'POST', headers: {'Content-Type': 'application/json', ...hdrAuth()},
            body: JSON.stringify({positions: simPos, period: '1y'})
          })
          const stats = await res.json()

          // Calculate score
          const cur = _r?.baseStats || portfolioStats
          const weights = GOAL_WEIGHTS
          const w = weights[optimGoal] || weights.return
          const metricMap = {
            mcProb: {cur: cur.monte_carlo?.prob_positive, sim: stats.monte_carlo?.prob_positive, higher:true},
            mcMedian: {cur: cur.monte_carlo?.median, sim: stats.monte_carlo?.median, higher:true},
            sharpe: {cur: cur.sharpe_ratio, sim: stats.sharpe_ratio, higher:true},
            sortino: {cur: cur.sortino_ratio, sim: stats.sortino_ratio, higher:true},
            var95: {cur: cur.var_95, sim: stats.var_95, higher:true},
            volatility: {cur: cur.volatility, sim: stats.volatility, higher:false},
            beta: {cur: cur.beta, sim: stats.beta, higher:false},
            // faltava aqui: no objetivo concentracao o hhi vale 0.60 e era descartado
            hhi: {cur: cur.hhi, sim: stats.hhi, higher:false}
          }
          let score = 0, totalW = 0
          Object.entries(w).forEach(([key, weight]) => {
            const m = metricMap[key]
            if (!m || m.cur === undefined || m.sim === undefined) return
            const delta = m.sim - m.cur
            const improved = m.higher ? delta > 0 : delta < 0
            const neutral = Math.abs(delta) < 0.01
            const scale = Math.abs(m.cur) > 0.01 ? Math.abs(m.cur) : 1
            const magnitude = Math.max(-1, Math.min(1, delta / scale))
            const contribution = neutral ? 0.5 : 0.5 + (improved ? 1 : -1) * Math.abs(magnitude) * 0.5
            score += contribution * weight
            totalW += weight
          })
          const finalScore = Math.max(0, Math.min(100, Math.round((score / (totalW||1)) * 100)))
          return {ticker, score: finalScore, stats}
        } catch(e) { return null }
      }))

      // Add simulated ticker to ranking
      const simTicker = (optimMode==="add" ? optimTicker : optimMode==="rebalance" ? optimTicker : optimSellTicker).trim().toUpperCase()
      const simScore = _r?.simStats ? (() => {
        const cur = _r?.baseStats || portfolioStats
        const sim = _r.simStats
        const weights = GOAL_WEIGHTS
        const w = weights[optimGoal] || weights.return
        const mm = {mcProb:{cur:cur.monte_carlo?.prob_positive,sim:sim.monte_carlo?.prob_positive,higher:true},mcMedian:{cur:cur.monte_carlo?.median,sim:sim.monte_carlo?.median,higher:true},sharpe:{cur:cur.sharpe_ratio,sim:sim.sharpe_ratio,higher:true},sortino:{cur:cur.sortino_ratio,sim:sim.sortino_ratio,higher:true},var95:{cur:cur.var_95,sim:sim.var_95,higher:true},volatility:{cur:cur.volatility,sim:sim.volatility,higher:false},beta:{cur:cur.beta,sim:sim.beta,higher:false},hhi:{cur:cur.hhi,sim:sim.hhi,higher:false}}
        let s=0,tw=0
        Object.entries(w).forEach(([k,wt])=>{ const m=mm[k]; if(!m||m.cur===undefined||m.sim===undefined)return; const d=m.sim-m.cur; const imp=m.higher?d>0:d<0; const neu=Math.abs(d)<0.01; const sc=Math.abs(m.cur)>0.01?Math.abs(m.cur):1; const mag=Math.max(-1,Math.min(1,d/sc)); s+=(neu?0.5:0.5+(imp?1:-1)*Math.abs(mag)*0.5)*wt; tw+=wt })
        return Math.max(0,Math.min(100,Math.round((s/(tw||1))*100)))
      })() : null
      const allResults = simTicker && simScore !== null ? [...results.filter(Boolean).filter(r => r.ticker !== simTicker), {ticker: simTicker + " ★", score: simScore, isSim: true}] : results.filter(Boolean)
      const valid = allResults.sort((a,b) => b.score - a.score)
      // 50 = impacto nulo (cada metrica neutra vale 0.5 na formula acima).
      // Antes as listas eram fatias posicionais, entao ativos com a MESMA nota
      // caiam em lados opostos. Agora o corte e pelo impacto real.
      const NEUTRO = 3   // margem: abaixo disso a mudanca nao e significativa
      const top15 = valid.filter(r => r.score > 50 + NEUTRO).slice(0, 15)
      const bottom15 = valid.filter(r => r.score < 50 - NEUTRO).slice(-15).reverse()
      const neutros = valid.filter(r => Math.abs(r.score - 50) <= NEUTRO).length
      setOptimAlts({top: top15, bottom: bottom15, neutros})
    } catch(e) { console.error(e) }
    setOptimAltsLoading(false)
  }

  async function runOptimizer() {
    if (!etfEnriched.length) return
    setOptimLoading(true)
    setOptimResult(null)
    // a lista de alternativas foi calculada para o valor anterior:
    // deixa-la na tela faria parecer que vale para o novo
    setOptimAlts(null)
    try {
      // Build simulated positions
      let simPositions = [...new Map(etfEnriched.map(p => [p.symbol, p])).values()].map(p => ({
        symbol: p.symbol,
        quantity: p.quantity,
        avg_price: p.avg_price,
        current_price: p.currentPrice || p.avg_price
      }))
      // copia da carteira ANTES das modificacoes, para servir de linha de base
      const baseOriginal = simPositions.map(p => ({...p}))

      // Validations
      if (optimMode === 'rebalance') {
        const st = optimSellTicker.trim().toUpperCase()
        const bt = optimTicker.trim().toUpperCase()
        if (st === bt) { setOptimResult({error: 'Ticker de venda e compra não podem ser iguais'}); setOptimLoading(false); return }
        const pctVal = numBR(optimSellPct)
        if (isNaN(pctVal) || pctVal <= 0 || pctVal > 100) { setOptimResult({error: 'Percentual deve ser entre 1 e 100'}); setOptimLoading(false); return }
      }
      if (optimMode === 'remove') {
        const ticker = optimSellTicker.trim().toUpperCase()
        const exists = etfEnriched.find(p => p.symbol === ticker)
        if (!exists) { setOptimResult({error: ticker + ' não está na sua carteira'}); setOptimLoading(false); return }
      }

      if (optimMode === 'add') {
        // Add new money to ticker
        const ticker = optimTicker.trim().toUpperCase()
        const amount = numBR(optimAmount) || 0
        if (!ticker) { setOptimResult({error: 'Digite um ticker válido'}); setOptimLoading(false); return }
        if (amount <= 0) { setOptimResult({error: 'Valor deve ser maior que zero'}); setOptimLoading(false); return }
        // Fetch current price
        const priceRes = await fetch(API_URL + '/technical/' + ticker, { headers: hdrAuth() })
        const priceData = await priceRes.json()
        const price = priceData.current_price || 0
        if (price <= 0) { setOptimResult({error: 'Ticker não encontrado'}); setOptimLoading(false); return }
        const qty = amount / price
        const existing = simPositions.find(p => p.symbol === ticker)
        if (existing) {
          existing.quantity += qty
        } else {
          simPositions.push({symbol: ticker, quantity: qty, avg_price: price, current_price: price})
        }
      } else if (optimMode === 'rebalance') {
        const sellTicker = optimSellTicker.trim().toUpperCase()
        const buyTicker = optimTicker.trim().toUpperCase()
        const pct = numBR(optimSellPct) / 100
        if (!sellTicker || !buyTicker) { setOptimLoading(false); return }
        const sellPos = simPositions.find(p => p.symbol === sellTicker)
        if (!sellPos) { setOptimResult({error: sellTicker + ' não encontrado na carteira'}); setOptimLoading(false); return }
        const sellValue = sellPos.quantity * (sellPos.current_price || sellPos.avg_price) * pct
        sellPos.quantity *= (1 - pct)
        const priceRes = await fetch(API_URL + '/technical/' + buyTicker, { headers: hdrAuth() })
        const priceData = await priceRes.json()
        const buyPrice = priceData.current_price || 0
        if (buyPrice <= 0) { setOptimResult({error: buyTicker + ' não encontrado'}); setOptimLoading(false); return }
        const buyQty = sellValue / buyPrice
        const existing = simPositions.find(p => p.symbol === buyTicker)
        if (existing) { existing.quantity += buyQty } else { simPositions.push({symbol: buyTicker, quantity: buyQty, avg_price: buyPrice, current_price: buyPrice}) }
        simPositions = simPositions.filter(p => p.quantity > 0.0001)
      } else if (optimMode === 'remove') {
        const ticker = optimSellTicker.trim().toUpperCase()
        // antes so dava para zerar; vender parte e a decisao mais comum
        const _pv = Math.min(100, Math.max(1, numBR(optimSellPct) || 100)) / 100
        if (_pv >= 0.999) {
          simPositions = simPositions.filter(p => p.symbol !== ticker)
        } else {
          simPositions = simPositions.map(p => p.symbol === ticker
            ? {...p, quantity: p.quantity * (1 - _pv)} : p)
        }
      }

      const baseRes = await fetch(API_URL + '/portfolio-stats2', {
        method: 'POST', headers: {'Content-Type': 'application/json', ...hdrAuth()},
        body: JSON.stringify({positions: baseOriginal, period: '1y'})
      })
      const baseStats = await baseRes.json()

      // Run portfolio-stats2 on simulated positions
      const res = await fetch(API_URL + '/portfolio-stats2', {
        method: 'POST', headers: {'Content-Type': 'application/json', ...hdrAuth()},
        body: JSON.stringify({positions: simPositions, period: '1y'})
      })
      const simStats = await res.json()
      setOptimResult({simStats, simPositions, baseStats})
      // dca e oversold tiram a nota do card do ranking (regua de preco medio +
      // RSI). Sem isso o card so mostrava a nota certa DEPOIS de clicar em
      // "Existe uma alternativa melhor?", e o mesmo aporte dava 45 e depois 62.
      if ((optimGoal === "dca" || optimGoal === "oversold") && optimMode !== "remove") {
        runAlternatives({simStats, simPositions, baseStats})
      }
    } catch(e) { setOptimResult({error: 'Erro: ' + e.message}) }
    setOptimLoading(false)
  }

  async function analyzePortfolio() {
    if (!isPremium && analysisCount >= 1) {
      setAnalysis("⭐ Limite diário atingido! Assine o Premium para análises ilimitadas.")
      return
    }
    if (false) {
      setAnalysis("Erro: chave da API Anthropic não configurada.")
      return
    }
    setAnalyzing(true); setAnalysis("")
    try {
      const portfolioData = etfEnriched.map(p =>
        p.symbol + ": " + p.quantity + " cotas, DCA $" + p.avg_price +
        ", atual $" + p.currentPrice?.toFixed(2) + ", P&L " + p.pnlPct.toFixed(2) + "%" +
        (p.purchase_date ? ", " + Math.max(0, Math.floor((Date.now() - new Date(p.purchase_date).getTime()) / 86400000)) + " dias em carteira" : "")
      ).join("\n")
      // o modelo tratava cripto como posicao intocada desde a data de entrada;
      // a data original permanece apos venda parcial, entao ele lia "796 dias
      // sem recuperacao" numa posicao que ja tinha sido reduzida em 60%
      const _cripto = ["IBIT","FBTC","BITB","ARKB","GBTC","BTCO","HODL","EZBC","MSBT","ETHA","FETH","ETHW","ETHE","ETH","BSOL","XRPR","GXRP","TOXR","GDLC","NCIQ","TDOT","HBR","LTCC","DOJE"]
      const _tot = etfEnriched.reduce((a,x) => a + (x.value || 0), 0)
      const _cri = etfEnriched.filter(x => _cripto.includes(x.symbol)).reduce((a,x) => a + (x.value || 0), 0)
      // a analise misturava dois numeros: dizia que para recuperar o P&L de
      // -4.95% a carteira precisava subir 17.3%, que e a conta do DRAWDOWN.
      // Agora recebe os dois separados e a instrucao de nao trocar um pelo outro.
      const breakevenStr = (totalValue > 0 && totalInvested > 0)
        ? "\nBreakeven: para voltar ao valor investido a carteira precisa subir " + ((totalInvested - totalValue) / totalValue * 100).toFixed(2) + "% (P&L atual " + totalPnlPct.toFixed(2) + "%). ATENCAO: este numero e diferente do Recovery Time, que parte do MAXIMO DRAWDOWN, nao do P&L. Nunca use um no lugar do outro nem misture os dois na mesma frase."
        : ""
      const criptoStr = _tot > 0 ? "\nExposicao cripto ATUAL: " + (_cri/_tot*100).toFixed(1) + "% da carteira. A data de entrada mostrada e a da compra ORIGINAL e nao muda apos venda parcial: NAO conclua que a posicao ficou intocada desde essa data." : ""
      const weeklyStr = Object.keys(prices).length > 0 ? "\nPerformance semanal: " + etfEnriched.map(p => p.symbol + "=" + (prices[p.symbol]?.weekly_change_pct >= 0 ? "+" : "") + (prices[p.symbol]?.weekly_change_pct ?? 0).toFixed(2) + "% ($" + ((prices[p.symbol]?.weekly_change_pct ?? 0) * (p.value||0) / 100).toFixed(2) + ")").join(", ") + " | Total semanal: $" + etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0).toFixed(2) : ""
      const statsStr = (isPremium3 && portfolioStats) ? "\nHHI: " + portfolioStats?.hhi + " | Sharpe: " + portfolioStats?.sharpe_ratio + " | Volatilidade: " + portfolioStats?.volatility + "% | Max Drawdown: " + portfolioStats?.max_drawdown + "% | "
+ "Monte Carlo 1 ano, 20000 cenarios, DERIVA ZERO (NAO e previsao, e dispersao). "
+ "Mediana: " + (portfolioStats?.monte_carlo_current?.median
  ?? portfolioStats?.monte_carlo?.median) + "%. "
+ "Fracao de cenarios acima de hoje: "
+ (portfolioStats?.monte_carlo_current?.prob_positive
  ?? portfolioStats?.monte_carlo?.prob_positive) + "%. "
+ "Esse numero fica abaixo de 50% por ARRASTO DE VARIANCIA, "
+ "nao por pessimismo do modelo, e NAO e probabilidade de lucro. | "
+ "VaR 95% DIARIO, do historico real: " + portfolioStats?.var_95 + "%. "
+ "VaR 95% ANUAL, do Monte Carlo: "
+ (portfolioStats?.monte_carlo_current?.var_95_ano
  ?? portfolioStats?.monte_carlo?.var_95_ano) + "%. "
+ "Expected Shortfall 95% ANUAL: "
+ (portfolioStats?.monte_carlo_current?.es_95_ano
  ?? portfolioStats?.monte_carlo?.es_95_ano) + "%. "
+ "O ES e a MEDIA dos 5% piores cenarios e e SEMPRE pior que o VaR "
+ "do mesmo nivel. NUNCA compare o VaR diario com o anual. | "
+ (stress && stress.veredito
  ? "Teste de estresse (aba cerebro): " + stress.veredito.peso_pct
    + "% DO PESO EM DOLAR responde a um fator so (" + stress.veredito.fator
    + "). Pior caso medido: " + stress.veredito.pior_pct
    + "% em " + stress.veredito.pior_nome
    + ". ATENCAO: esse numero e o RETORNO DO PERIODO "
    + "inteiro, NAO um drawdown. O pico a vale dentro do "
    + "mesmo periodo foi MAIS FUNDO que ele. Nunca o chame "
    + "de max drawdown: esse e outro campo"
    + ". A exposicao de ETF a vista ao subjacente vem do PROSPECTO, "
    + "nao de regressao, entao ali nada e estimado. | "
  : "")
+ (() => {
        // o chat nao recebia o Recovery Time e passou a deduzir formulas erradas
        const _rt = recoveryTime(portfolioStats?.max_drawdown)
        if (!_rt) return ""
        const _g = _rt.ganho
        const _m = _rt.meses
        return "Recovery Time (parte de retornos esperados de 20%, 12% e 6% ao ano; NAO usa Monte Carlo nem volatilidade): otimista " + _m(0.20) + " meses, base " + _m(0.12) + " meses, pessimista " + _m(0.06) + " meses; para recuperar a queda a carteira precisa subir " + (_g*100).toFixed(1) + "%. | "
      })() + (() => {
        // este valor estava FIXO como "alta (>0.90)" no prompt, independente
        // dos dados reais — agora e calculado da matriz de correlacao
        const c = portfolioStats?.correlation
        if (!c) return "Correlacao: indisponivel"
        const _r = correlacaoResumo(c)
        if (!_r.n) return "Correlacao: indisponivel"
        const avg = _r.avg
        const mxV = _r.mx
        const mxPar = _r.par
        // nomear o par evita que o modelo estime a correlacao entre eles
        return "Correlacao MEDIA entre ativos: " + avg.toFixed(2) + " (baixa = boa diversificacao). Par mais correlacionado: " + mxPar + "=" + mxV.toFixed(2) + " — use ESTE valor, nao estime correlacoes entre ativos"
      })() : SEM_METRICAS
      const summary = "Total investido: $" + totalInvested.toFixed(2) +
        "\nValor atual: $" + totalValue.toFixed(2) +
        "\nP&L total: " + totalPnlPct.toFixed(2) + "%" +
        "\nVariacao hoje: $" + totalDailyPnl.toFixed(2) + criptoStr + breakevenStr + weeklyStr + statsStr
      const res = await fetch(API_URL + "/claude", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", ...hdrAuth(),
        },
        body: JSON.stringify({
          model: CLAUDE_MODEL, max_tokens: 8000,
          system: isPremium3 ? SYS_P3 : SYS_BASICO,
                messages: [
                {role: "user", content: "Analise este portfolio de ETFs cripto da NASDAQ em portugues. Insights praticos:\n\n" + summary + "\n\nPosicoes:\n" + portfolioData}
              ]
        })
      })
      const data = await res.json()
      setAnalysis(data.content[0].text)
      if (!isPremium) {
        const newCount = analysisCount + 1
        setAnalysisCount(newCount)
        localStorage.setItem("analysisCount", newCount.toString())
        localStorage.setItem("analysisDate", new Date().toDateString())
      }
    } catch(e) { setAnalysis("Erro ao analisar.") }
    setAnalyzing(false)
  }

  async function loadAlertSettings() {
    if (!user?.id) return
    const { data } = await supabase.from("user_alerts").select("*").eq("user_id", user.id).limit(1)
    if (data && data.length > 0) {
      setAlertSettings({drop5:data[0].drop5, rise5:data[0].rise5, regime:data[0].regime, news_alert:data[0].news_alert, daily:data[0].daily, smart_alert:data[0].smart_alert||false})
    }
  }

  async function saveAlertSettings() {
    if (!user?.id) return
    setSavingAlerts(true)
    const { data: existing } = await supabase.from("user_alerts").select("id").eq("user_id", user.id).limit(1)
    if (existing && existing.length > 0) {
      await supabase.from("user_alerts").update({...alertSettings}).eq("user_id", user.id)
    } else {
      await supabase.from("user_alerts").insert({user_id: user.id, ...alertSettings})
    }
    setSavingAlerts(false)
    setAlertsSaved(true)
    setTimeout(() => setAlertsSaved(false), 2000)
  }

  async function sendChatMessage() {
    const text = chatInput.trim()
    if (!text || chatLoading) return
    const userMsg = { role: "user", content: text }
    setChatMessages(prev => [...prev, userMsg])
    setChatInput("")
    setChatLoading(true)
    // O modelo inventa a formula do Recovery Time mesmo com o valor e a regra
    // no contexto (testado em 18 e 20/08/2026, quatro respostas diferentes,
    // duas delas citando meses que nem estavam na tela). Aqui a pergunta nem
    // chega nele: a resposta sai do MESMO calculo que a tela usa.
    if (/recovery ?time|tempo de recupera|recupera(r|cao|ção) da (queda|carteira)/i.test(text)) {
      const _rt = recoveryTime(portfolioStats?.max_drawdown)
      const _txt = _rt ? (() => {
        const _dd = _rt.dd
        const _g = _rt.ganho
        const _m = _rt.meses
        return "**Recovery Time — como e calculado**\n\n" +
          "1. Parte do Max Drawdown da carteira: **" + (_dd*100).toFixed(1) + "%**.\n" +
          "2. Cair " + (_dd*100).toFixed(1) + "% exige subir **" + (_g*100).toFixed(1) + "%** para voltar ao pico " +
          "(a queda e a alta nao sao simetricas).\n" +
          "3. Divide essa alta por tres retornos ESPERADOS, que sao constantes fixas no codigo: " +
          "20%, 12% e 6% ao ano.\n\n" +
          "| Cenario | Retorno assumido | Tempo |\n|---|---|---|\n" +
          "| Otimista | 20% a.a. | " + _m(0.20) + " meses |\n" +
          "| Base | 12% a.a. | " + _m(0.12) + " meses |\n" +
          "| Pessimista | 6% a.a. | " + _m(0.06) + " meses |\n\n" +
          "NAO usa Monte Carlo, volatilidade, Sharpe nem o retorno historico da carteira. " +
          "Os tres retornos sao premissas fixas, nao derivadas dos seus dados."
      })() : "O Recovery Time precisa do Max Drawdown, que ainda nao foi calculado. Rode a analise na aba 💎 primeiro."
      setChatMessages(prev => [...prev, { role: "assistant", content: _txt }])
      setChatLoading(false)
      return
    }
    // Calculate confidence score for bot context
    // tres copias deste score divergiam em cinco pontos.
    // Esta era a que o chat lia, e dizia 35/100 "Baixa
    // Confianca" onde a tela mostrava 37 "Fraca".
    // Agora sai da lib, testada contra a tela.
    const _cf = scoreConfianca({
      etfEnriched,
      totalValue,
      portfolioStats,
      news,
      newsSentiment,
      portfolioTechnical,
    })
    const div2 = _cf.diversificacao
    const shScore2 = _cf.sharpe
    const regScore2 = _cf.regime
    const newsScore2b = _cf.macro
    const techScore2b = _cf.tecnico
    const confidenceScoreBot = _cf.total
    const confidenceLabelBot = _cf.rotulo

    // Calculate exhaustion score for bot context
    // mesmas funcoes que os cards da ⭐ usam: antes havia copias aqui que
    // ja divergiam (faltava o item 52 semanas e o caso fora da banda)
    const _exIA = (technical && technical.rsi) ? scoreExhaustion(technical) : null
    const exhaustionScore = _exIA ? (_exIA.score + '/100_bounce_' + (_exIA.score >= 70 ? 'HIGH' : _exIA.score >= 40 ? 'MODERATE' : 'LOW')) : null
    const _cfIA = (technical && technical.rsi) ? scoreConfluence(technical) : null
    const confluenceScore = _cfIA ? (_cfIA.abs + '/100_' + _cfIA.dir) : null
    try {
      const history = [...chatMessages, userMsg].map(m => ({ role: m.role, content: m.content }))
      const pnl = (totalValue ?? 0) - (totalInvested ?? 0)
      // Fetch top 20 crypto spot prices from CoinGecko
      let cryptoMarketContext = ''
      try {
        const cgRes = await fetch('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false&price_change_percentage=24h&x_cg_demo_api_key=' + CG_KEY)
        if (cgRes.ok) {
          const cgData = await cgRes.json()
          const cryptoLines = cgData.map(c =>
            `${c.symbol.toUpperCase()}: $${c.current_price.toLocaleString()} (${c.price_change_percentage_24h >= 0 ? '+' : ''}${c.price_change_percentage_24h?.toFixed(2)}% 24h, MCap $${(c.market_cap/1e9).toFixed(1)}B)`
          ).join('\n')
          cryptoMarketContext = `\n\nLive Crypto Spot Market - Top 20 by Market Cap (CoinGecko):\n${cryptoLines}`
        }
      } catch(cgErr) {
        // CoinGecko unavailable - continue without spot data
      }

      const macroContext = isPremium4 && news.length > 0 ? `

Current macro news context (last ${Math.min(news.length, 5)} headlines):
${news.slice(0, 5).map((n, i) => `${i+1}. ${n.title || n.headline || n.description || ''}`).join('\n')}
` : ''

      const portfolioContext = positions.length > 0 ? `

Current user portfolio:
- Total invested: $${(totalInvested ?? 0).toFixed(2)}
- Current value: $${(totalValue ?? 0).toFixed(2)}
- P&L: $${pnl.toFixed(2)} (${totalInvested ? (pnl / totalInvested * 100).toFixed(2) : '0.00'}%)
- Positions: ${etfEnriched.map(p => `${p.symbol}: ${p.quantity} shares @ $${p.avg_price} DCA, current $${p.currentPrice?.toFixed(2)}, P&L ${p.pnlPct?.toFixed(2)}%, today ${p.dailyChange?.toFixed(2)}%, entry date ${p.purchase_date||"unknown"}`).join(', ')}
${portfolioStats ? `- Sharpe: ${portfolioStats?.sharpe_ratio}, Sortino: ${portfolioStats?.sortino_ratio}, VaR 95%: ${portfolioStats?.var_95}%, Max Drawdown: ${portfolioStats?.max_drawdown}%` : ''}
${(totalValue > 0 && totalInvested > 0) ? `- Breakeven: para voltar ao valor investido a carteira precisa subir ${((totalInvested - totalValue) / totalValue * 100).toFixed(2)}% (P&L atual ${totalPnlPct.toFixed(2)}%). Este numero e DIFERENTE do Recovery Time, que parte do maximo drawdown: nunca use um no lugar do outro nem misture os dois na mesma frase. O Recovery Time divide a alta necessaria por tres retornos ESPERADOS fixos (20%, 12% e 6% ao ano) — NAO vem de Monte Carlo, volatilidade nem Sharpe: nunca atribua esses meses a simulacao. O CLAW Optimizer fica na aba 💎, nao na ⚡.` : ''}
${(() => {
  const _c = ["IBIT","FBTC","BITB","ARKB","GBTC","BTCO","HODL","EZBC","MSBT","ETHA","FETH","ETHW","ETHE","ETH","BSOL","XRPR","GXRP","TOXR","GDLC","NCIQ","TDOT","HBR","LTCC","DOJE"]
  const _t = etfEnriched.reduce((a,x) => a + (x.value || 0), 0)
  const _cr = etfEnriched.filter(x => _c.includes(x.symbol)).reduce((a,x) => a + (x.value || 0), 0)
  return _t > 0 ? `- Exposicao cripto ATUAL: ${(_cr/_t*100).toFixed(1)}% da carteira. A data de entrada de cada posicao e a da compra ORIGINAL e nao muda apos venda parcial: NAO conclua que a posicao ficou intocada desde essa data.` : ''
})()}
${(marketStatus.status === 'pre' || marketStatus.status === 'after') && Object.keys(prices).length > 0 ? `\n${marketStatus.status === 'pre' ? 'Pre-market' : 'After-hours'} ETF prices: ${Object.entries(prices).map(([ticker, data]) => `${ticker}: $${data.price} (${data.change_pct > 0 ? '+' : ''}${data.change_pct}% vs last trading session close)`).join(', ')}` : ''}
` : ''
      let flowsCtx = ''
      try {
        const fr = await fetch(`${API_URL}/etf-flows`)
        const fd = await fr.json()
        if (fd?.total_volume_usd_m) {
          setEtfFlows(fd)
          flowsCtx = `\n\nETF volumes for the closed session of ${fd.session_date || "the last trading day"} (NOT today if the market has not opened yet; never call these numbers today\u2019s volume): Total $${fd.total_volume_usd_m?.toFixed(0)}M. BTC ETFs: ${fd.bitcoin?.map(e=>`${e.ticker} $${e.volume_usd_m?.toFixed(0)}M`).join(', ')}. ETH ETFs: ${fd.ethereum?.map(e=>`${e.ticker} $${e.volume_usd_m?.toFixed(0)}M`).join(', ')}. Others: ${fd.others?.map(e=>`${e.ticker} $${e.volume_usd_m?.toFixed(0)}M`).join(', ')}. Higher volume on down days = selling pressure; higher volume on up days = buying demand.`
        }
      } catch(e) {}

      const res = await fetch(API_URL + "/claude", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", ...hdrAuth(),
        },
        body: JSON.stringify({
          model: CLAUDE_MODEL,
          max_tokens: 3000,
          system: contextoChat({
                    acertos, advData, advTicker, analysis, confidenceLabelBot,
                    confidenceScoreBot, confluenceScore, cryptoMarketContext,
                    cryptoPrices, dcaAmount, dcaBestTarget, dcaEtf, div2,
                    enriched, etfEnriched, exhaustionScore, flowsCtx, indices,
                    lastSmartAlert, macroContext, marketStatus, newsScore2b,
                    optimAmount, optimGoal, optimMode, optimResult,
                    optimSellPct, optimSellTicker, optimTicker, p5Goal,
                    p5GoalResult, p5Result, portfolioContext, portfolioStats,
                    portfolioTechnical, premium3Analysis, prices, regScore2,
                    shScore2, stress, techScore2b, techTicker, technical,
                    totalDailyPnl, totalValue, usdBrl, whatifBuy, whatifPct,
                    whatifResult, whatifSell
                  }),
          messages: history
        })
      })
      const data = await res.json()
      const assistantText = data.content && data.content[0] ? data.content[0].text : "Sorry, I could not generate a response."
      setChatMessages(prev => [...prev, { role: "assistant", content: assistantText }])
      
      // Save to behavioral memory if Premium 4
      if (isPremium4 && user?.id) {
        try {
          await supabase.from("user_memory").insert({
            user_id: user.id,
            event_type: "chat_interaction",
            data: {
              question: text,
              answer_preview: assistantText.substring(0, 200),
              active_tab: tab,
              portfolio_value: totalValue,
              positions_count: positions.length,
              hour_of_day: new Date().getHours(),
              day_of_week: new Date().getDay(),
            }
          })
        } catch(e) { console.log("Memory save error:", e) }
      }
    } catch(e) {
      setChatMessages(prev => [...prev, { role: "assistant", content: "Erro no chat: " + (e && e.message ? e.message : String(e)) + " [se isso aparecer, me mande o texto inteiro]" }])
    }
    setChatLoading(false)
  }

  async function translateAnalysis(text, setTranslated, setTranslating) {
    if (false) return
    setTranslating(true)
    try {
      const res = await fetch(API_URL + "/claude", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", ...hdrAuth(),
        },
        body: JSON.stringify({
          model: CLAUDE_MODEL, max_tokens: 1500,
          messages: [{ role: "user", content: "Translate the following Portuguese text to English, keeping all formatting:\n\n" + text }]
        })
      })
      const data = await res.json()
      setTranslated(data.content[0].text)
    } catch(e) { setTranslated("Error translating.") }
    setTranslating(false)
  }

  const enriched = positions.map(p => {
    const isCrypto = p.asset_type === "crypto"
    const priceData = isCrypto
      ? (cryptoPrices[p.symbol] ? { price: cryptoPrices[p.symbol].price, change_pct: cryptoPrices[p.symbol].change_24h } : {})
      : (prices[p.symbol] || {})
    const currentPrice = priceData.price || p.avg_price
    const value = p.quantity * currentPrice
    const invested = p.quantity * p.avg_price
    const pnl = value - invested
    const pnlPct = invested > 0 ? (pnl / invested * 100) : 0
    const dailyChange = priceData.change_pct || 0
    const dailyPnl = value * (dailyChange / 100)
    const postMarketPrice = priceData.post_market_price || 0
    const postMarketChange = priceData.post_market_change || 0
    const preMarketPrice = priceData.pre_market_price || 0
    const preMarketChange = priceData.pre_market_change || 0
    return { ...p, currentPrice, value, invested, pnl, pnlPct, dailyChange, dailyPnl, isCrypto, postMarketPrice, postMarketChange, preMarketPrice, preMarketChange }
  })

  const etfEnriched = enriched.filter(p => !p.isCrypto)
  useEffect(() => {
    alertaDadosRef.current = { alertSettings, etfEnriched }
  }, [alertSettings, etfEnriched])
  // O EFEITO MORA AQUI, logo abaixo da declaracao de etfEnriched, e
  // nao la em cima junto dos outros: em 07/10/2026 eu o pus na linha
  // 1952 e o app quebrou inteiro com "Cannot access before
  // initialization" — etfEnriched e const e so nasce nesta linha.
  // o preco de mercado so existe no enriquecido; positions traz
  // symbol, quantity e avg_price. sem preco o card nao sai, em vez
  // de sair calculado sobre custo.
  const _asStr = etfEnriched.map(x => (x.symbol || "") + ":"
    + x.quantity + ":" + (x.currentPrice || 0)).join("|")
    + "|tx" + transactions.length
  useEffect(() => {
    if (tab !== "premium3" || !etfEnriched.length) return
    const uniq = [...new Map(etfEnriched.map(x => [x.symbol, x])).values()]
    const corpo = uniq.map(x => ({symbol: x.symbol,
      quantity: x.quantity, current_price: x.currentPrice}))
    if (corpo.some(x => !x.current_price)) return
    fetch(API_URL + "/stress", {method: "POST",
      headers: {"Content-Type": "application/json", ...hdrAuth()},
      body: JSON.stringify({positions: corpo,
        transactions: transactions.map(t => ({symbol: t.symbol,
          side: t.side, quantity: t.quantity, price: t.price,
          traded_at: t.traded_at}))})})
      .then(r => r.json())
      .then(d => setStress(d && !d.erro ? d : null))
      .catch(() => setStress(null))
  // _asStr e a impressao digital de etfEnriched: usar o
  // array faria o efeito disparar a cada render
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, _asStr])

  // a lista vem por parametro: etfEnriched so existe a partir daqui, e ler
  // etfEnriched.length numa dependencia acima disso quebra a renderizacao
  async function carregarSparks(lista) {
    if (!lista.length || Object.keys(sparks).length) return
    const out = {}
    for (const p of lista) {
      try {
        const r = await fetch(API_URL + "/history/" + encodeURIComponent(p.symbol) + "?period=1mo", { headers: hdrAuth() })
        const d = await r.json()
        if (d.data && d.data.length > 1) out[p.symbol] = d.data.map(x => x.v)
      } catch (e) {}
    }
    setSparks(out)
  }
  // etfEnriched.length e o gatilho de proposito, pela
  // mesma razao do news.length: o array daria
  // referencia nova a cada render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (tab === 'grafico') carregarSparks(etfEnriched) }, [tab, etfEnriched.length])

  const totalInvested = etfEnriched.reduce((s, p) => s + p.invested, 0)
  const totalValue = etfEnriched.reduce((s, p) => s + p.value, 0)
  const totalPnl = totalValue - totalInvested
  const totalPnlPct = totalInvested > 0 ? (totalPnl / totalInvested * 100) : 0
  const totalDailyPnl = etfEnriched.reduce((s, p) => s + p.dailyPnl, 0)
  const etfPositions = etfEnriched.filter(p => !p.isCrypto)
  const barData = etfPositions.map(p => ({ name: p.symbol, valor: parseFloat(p.value.toFixed(2)) }))
  const mktColor = marketStatus.status === "open" ? "#22c55e" : marketStatus.status === "pre" || marketStatus.status === "after" ? "#f59e0b" : "#6b7280"
  const showEtfPriceTape = isUsMarketOpen(new Date(nowTs))
  const extraTickers = positions.map(p=>p.symbol).filter(s=>!ETF_LIST.includes(s))
  const etfPriceTapeText = [...ETF_LIST, ...extraTickers].map(ticker => {
    const p = prices[ticker]
    if (!p) return `${ticker} --`
    const price = Number(p.price)
    const change = Number(p.change_pct)
    const formattedPrice = Number.isFinite(price) ? price.toFixed(2) : p.price
    const formattedChange = Number.isFinite(change) ? change.toFixed(2) : p.change_pct
    const sign = Number(formattedChange) >= 0 ? "+" : ""
    return `${ticker} $${formattedPrice} ${sign}${formattedChange}%`
  }).join("  |  ")
  if (loading) return <div style={s.center}><p style={{color:"#fff"}}>Carregando...</p></div>

  if (!user) return (
    <div style={s.loginBg}>
      <div style={s.loginCard}>
        <Logo />
        <p style={s.loginSub}>Motor de decisão para investidores globais.</p>
        <p style={{color:"#6b7280", fontSize:11, textAlign:"center", marginTop:4, lineHeight:1.5}}>ETFs · Ações · Cripto · Análise Institucional com IA</p>
        <p style={{color:"#9ca3af", fontSize:11, textAlign:"center", marginTop:10, lineHeight:1.6, padding:"0 6px"}}>Guarda cada análise que faz e volta trinta dias depois conferir se acertou — e publica o resultado quando não acerta.</p>
        <p style={{color:"#4b5563", fontSize:10, textAlign:"center", marginTop:8, lineHeight:1.5}}>CLAW Optimizer™ · CLAW Advanced Analytics™ · CLAW DCA Intelligence™ · ClawETF Premium Score™ · CLAW Diversification Engine™ · CLAW Confluence Score™ · CLAW Exhaustion Score™</p>
        <button onClick={loginGoogle} style={s.googleBtn}>Continuar com Google</button>
        <button onClick={() => setShowEmailAuth(v => !v)} style={s.emailBtn} aria-expanded={showEmailAuth}>Entrar com Email</button>
        {showEmailAuth && (
          <form onSubmit={loginWithEmail} style={s.authForm}>
            <input
              type="email"
              placeholder="Email"
              value={authEmail}
              onChange={e => setAuthEmail(e.target.value)}
              style={s.input}
            />
            <input
              type="password"
              placeholder="Password"
              value={authPassword}
              onChange={e => setAuthPassword(e.target.value)}
              style={s.input}
            />
            <button type="submit" style={s.addBtn} disabled={authLoading}>
              {authLoading ? "Please wait..." : authMode === "signup" ? "Create Account" : "Login"}
            </button>
            <button
              type="button"
              onClick={() => setAuthMode(m => m === "signup" ? "login" : "signup")}
              style={s.authSwitch}
            >
              {authMode === "signup" ? "Already have an account? Login" : "Create new account"}
            </button>
            {!!authMessage && <p style={s.authMessage}>{authMessage}</p>}
          </form>
        )}
        <p style={s.powered}>AI analysis powered by Anthropic Claude.</p>
        <p style={{textAlign:"center", marginTop:10, fontSize:11}}><a href="/sobre.html" style={{color:"#8b93a1", textDecoration:"none"}}>Sobre o ClawETF</a></p>
      </div>
    </div>
  )

  const InfoTip = ({id}) => {
    const tip = INDICATOR_TIPS[id]
    if (!tip) return null
    return (
      <span style={{position:"relative", display:"inline-block"}}>
        <span onClick={e => { e.stopPropagation(); setActiveTooltip(activeTooltip===id ? null : id) }} style={{color:"#6366f1", fontSize:10, cursor:"pointer", marginLeft:4, userSelect:"none"}}>ⓘ</span>
        {activeTooltip===id && (
          <div onClick={e => e.stopPropagation()} style={{position:"fixed", left:"50%", transform:"translateX(-50%)", bottom:80, backgroundColor:"#1f2937", border:"1px solid #6366f1", borderRadius:10, padding:"10px 14px", zIndex:9999, width:"85vw", maxWidth:320, fontSize:11, color:"#e2e8f0", boxShadow:"0 4px 20px rgba(0,0,0,0.7)"}}>
            <p style={{color:"#6366f1", fontWeight:700, margin:"0 0 4px 0"}}>{tip.name}</p>
            <p style={{margin:0, lineHeight:1.4}}>{tip.tip}</p>
          </div>
        )}
      </span>
    )
  }

  return (
    <div style={s.bg}>
      {editModal && (
        <div style={{position:"fixed", top:0, left:0, right:0, bottom:0, backgroundColor:"rgba(0,0,0,0.85)", zIndex:1000, display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"20px 16px", overflowY:"auto"}} onClick={() => setEditModal(null)}>
          <div style={{backgroundColor:"#0a0a0f", border:"1px solid #6366f1", borderRadius:12, padding:20, width:"100%", maxWidth:420}} onClick={ev => ev.stopPropagation()}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16}}>
              <p style={{color:"#6366f1", fontSize:15, fontWeight:700, margin:0}}>✏️ Editar {editModal.symbol}</p>
              <button onClick={() => setEditModal(null)} style={{background:"none", border:"none", color:"#9ca3af", fontSize:18, cursor:"pointer"}}>✕</button>
            </div>
            {editModalLoading ? <p style={{color:"#9ca3af", textAlign:"center"}}>⏳ Carregando...</p> : (
              <>
                {editModalEntries.map((e, i) => (
                  <div key={e.id} style={{marginBottom:12, padding:"10px", backgroundColor:"#1f2937", borderRadius:8}}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}><p style={{color:"#9ca3af", fontSize:10, margin:0}}>Entrada {i+1}{e.editExchange ? " — " + e.editExchange : ""}</p><button onClick={() => deleteEntry(e.id)} style={{background:"none", border:"none", color:"#ef4444", fontSize:14, cursor:"pointer", padding:0}}>🗑️</button></div>
                    <div style={{display:"flex", flexDirection:"column", gap:6}}>
                      <input value={e.editQty} onChange={ev => setEditModalEntries(prev => prev.map((x,j) => j===i ? {...x, editQty: ev.target.value} : x))} placeholder="Cotas" style={{backgroundColor:"#0a0a0f", border:"1px solid #374151", borderRadius:6, padding:"6px 8px", color:"#f0f0f0", fontSize:12, width:"100%", boxSizing:"border-box"}}/>
                      <input value={e.editPrice} onChange={ev => setEditModalEntries(prev => prev.map((x,j) => j===i ? {...x, editPrice: ev.target.value} : x))} placeholder="Preço ($)" style={{backgroundColor:"#0a0a0f", border:"1px solid #374151", borderRadius:6, padding:"6px 8px", color:"#f0f0f0", fontSize:12, width:"100%", boxSizing:"border-box"}}/>
                      <input value={e.editDate} onChange={ev => setEditModalEntries(prev => prev.map((x,j) => j===i ? {...x, editDate: ev.target.value} : x))} placeholder="Data (YYYY-MM-DD)" style={{backgroundColor:"#0a0a0f", border:"1px solid #374151", borderRadius:6, padding:"6px 8px", color:"#f0f0f0", fontSize:12, width:"100%", boxSizing:"border-box"}}/>
                      <input value={e.editExchange} onChange={ev => setEditModalEntries(prev => prev.map((x,j) => j===i ? {...x, editExchange: ev.target.value} : x))} placeholder="Corretora" style={{backgroundColor:"#0a0a0f", border:"1px solid #374151", borderRadius:6, padding:"6px 8px", color:"#f0f0f0", fontSize:12, width:"100%", boxSizing:"border-box"}}/>
                      {Math.abs(numBR(e.editQty) - numBR(e.quantity)) > 0.00001 && (
                        <div style={{borderTop:"1px solid #374151", paddingTop:6, marginTop:2}}>
                          <p style={{color:"#f59e0b", fontSize:10, margin:"0 0 4px 0", lineHeight:1.4}}>{numBR(e.editQty) > numBR(e.quantity) ? "Você aumentou " : "Você reduziu "}{Math.abs(numBR(e.editQty) - numBR(e.quantity)).toFixed(5)} cotas. Quanto você {numBR(e.editQty) > numBR(e.quantity) ? "aplicou" : "recebeu"} nessa operação? Copie o valor total da tela da corretora — o app divide pela quantidade e acha o preço. Sem isso a operação entra pelo preço médio e o resultado realizado sai errado.</p>
                          <input value={e.editSellPrice || ""} onChange={ev => setEditModalEntries(prev => prev.map((x,j) => j===i ? {...x, editSellPrice: ev.target.value} : x))} placeholder={numBR(e.editQty) > numBR(e.quantity) ? "Valor aplicado ($)" : "Valor recebido ($)"} style={{backgroundColor:"#0a0a0f", border:"1px solid #f59e0b", borderRadius:6, padding:"6px 8px", color:"#f0f0f0", fontSize:12, width:"100%", boxSizing:"border-box"}}/>
                          <input value={e.editOpDate || ""} onChange={ev => setEditModalEntries(prev => prev.map((x,j) => j===i ? {...x, editOpDate: ev.target.value} : x))} placeholder="Data desta operação (vazio = hoje)" style={{backgroundColor:"#0a0a0f", border:"1px solid #f59e0b", borderRadius:6, padding:"6px 8px", color:"#f0f0f0", fontSize:12, width:"100%", boxSizing:"border-box", marginTop:6}}/>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <div style={{display:"flex", gap:8, marginTop:8}}>
                  <button onClick={saveEditModal} style={{flex:1, padding:"10px 0", borderRadius:8, border:"none", backgroundColor:"#6366f1", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer"}}>💾 Salvar</button>
                  <button onClick={() => setEditModal(null)} style={{flex:1, padding:"10px 0", borderRadius:8, border:"1px solid #374151", backgroundColor:"#1f2937", color:"#9ca3af", fontSize:13, cursor:"pointer"}}>❌ Fechar</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <style>
        {`@keyframes ticker-scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } } @keyframes claw-blink { 0%, 90%, 100% { transform: scaleY(1); } 95% { transform: scaleY(0.1); } }`}
      </style>
      {showEtfPriceTape && (
        <div style={s.etfTapeWrap}>
          <div style={s.tickerTrack}>
            <span style={s.etfTapeText}>{etfPriceTapeText}</span>
            <span style={s.etfTapeText}>{etfPriceTapeText}</span>
          </div>
        </div>
      )}
      <div style={s.header}>
        <span style={{...s.headerTitle, display:"inline-flex", alignItems:"center", gap:7}}><svg viewBox="0 0 100 100" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"><path d="M72 24 A34 34 0 1 0 72 76"/><path d="M72 76 Q58 66 62 50"/></svg>ClawETF</span>
        <div style={{display:"flex", alignItems:"center", gap:8}}>
          <span style={{fontSize:10, padding:"3px 8px", borderRadius:20, fontWeight:"bold", backgroundColor: mktColor + "22", color: mktColor}}>● {marketStatus.label}</span>
          <button onClick={() => setMenuAberto(true)} style={{...s.logoutBtn, fontSize:15, lineHeight:1, padding:"6px 11px"}} title="Menu">{"\u2630"}</button>
        </div>
      </div>

      {menuAberto && (() => {
        const linha = {display:"flex", alignItems:"center", gap:12, width:"100%",
          background:"transparent", border:"none", padding:"11px 16px",
          cursor:"pointer", textAlign:"left", textDecoration:"none"}
        const ico = {fontSize:15, width:22, flexShrink:0}
        const txt = {color:"#9ca3af", fontSize:13, flex:1}
        const seta = {color:"#4b5563", fontSize:13}
        const compartilhar = () => {
          const dados = {title:"ClawETF", text:"Acompanho minha carteira no ClawETF", url:"https://clawetf.app"}
          if (navigator.share) { navigator.share(dados).catch(() => {}); return }
          if (navigator.clipboard) {
            navigator.clipboard.writeText(dados.url).then(() => {
              setLinkCopiado(true)
              setTimeout(() => setLinkCopiado(false), 2500)
            }).catch(() => {})
          }
        }
        return (
          <div onClick={() => setMenuAberto(false)} style={{position:"fixed", top:0, left:0, right:0, bottom:0, background:"rgba(0,0,0,0.65)", zIndex:3000}}>
            <div onClick={e => e.stopPropagation()} style={{position:"fixed", left:0, top:0, bottom:0, width:"84%", maxWidth:330, background:"#0b1220", borderRight:"1px solid #1f2937", overflowY:"auto", padding:"calc(14px + env(safe-area-inset-top, 0px)) 0 calc(22px + env(safe-area-inset-bottom, 0px)) 0"}}>
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0 16px 12px 16px"}}>
                <span style={{color:"#e5e7eb", fontSize:14, fontWeight:700}}>ClawETF</span>
                <button onClick={() => setMenuAberto(false)} style={{background:"transparent", border:"none", color:"#6b7280", fontSize:17, cursor:"pointer", padding:0}}>{"\u2715"}</button>
              </div>
              {MENU_ABAS.map(([id, emoji, nome]) => (
                <button key={id} onClick={() => { setTab(id); setMenuAberto(false) }} style={{...linha, background: tab === id ? "#111c33" : "transparent"}}>
                  <span style={{...ico, color: id === "crypto" ? "#f7931a" : undefined}}>{emoji}</span>
                  <span style={{...txt, color: tab === id ? "#e5e7eb" : "#9ca3af"}}>{nome}</span>
                  <span style={seta}>{"\u203A"}</span>
                </button>
              ))}
              <div style={{height:1, background:"#1f2937", margin:"10px 16px"}} />
              <a href="/sobre.html" target="_blank" rel="noopener noreferrer" style={linha}>
                <span style={ico}>{"\u{1F4C4}"}</span>
                <span style={txt}>Sobre o ClawETF</span>
                <span style={seta}>{"\u203A"}</span>
              </a>
              <a href={URL_POLITICA} target="_blank" rel="noopener noreferrer" style={linha}>
                <span style={ico}>{"\u{1F6E1}\uFE0F"}</span>
                <span style={txt}>{"Pol\u00edtica de privacidade"}</span>
                <span style={seta}>{"\u203A"}</span>
              </a>
              <a href={"mailto:eduardo@clawetf.app?subject=" + encodeURIComponent("ClawETF " + APP_VERSION + " - problema")} style={linha} target="_blank" rel="noopener noreferrer">
                <span style={ico}>{"\u2709\uFE0F"}</span>
                <span style={txt}>Reportar problema</span>
                <span style={seta}>{"\u203A"}</span>
              </a>
              <button onClick={compartilhar} style={linha}>
                <span style={ico}>{"\u{1F517}"}</span>
                <span style={txt}>{linkCopiado ? "link copiado" : "Compartilhar"}</span>
                <span style={seta}>{"\u203A"}</span>
              </button>
              <div style={{height:1, background:"#1f2937", margin:"10px 16px"}} />
              <button onClick={logout} style={linha}>
                <span style={ico}>{"\u23FB"}</span>
                <span style={{...txt, color:"#ef4444"}}>Sair</span>
              </button>
              <p style={{color:"#4b5563", fontSize:10, textAlign:"center", margin:"16px 0 0 0"}}>{"vers\u00e3o " + APP_VERSION}</p>
            </div>
          </div>
        )
      })()}

      <div style={{display:"flex", alignItems:"center", gap:10, margin:"0 0 12px 0"}}>
        <span style={{color:"#6b7280", fontSize:11, letterSpacing:1.2, textTransform:"uppercase", whiteSpace:"nowrap"}}>{nomeDaAba}</span>
        <div style={{flex:1, height:1, background:"#1f2937"}} />
      </div>

      {tab === "portfolio" && (
        <div>
          <div style={{display:"flex", justifyContent:"flex-end", marginBottom:4}}>
            <button
              onClick={() => { const _v = !ocultarValores; setOcultarValores(_v); localStorage.setItem("ocultar_valores", _v ? "1" : "0") }}
              title={ocultarValores ? "Mostrar valores" : "Ocultar valores"}
              style={{background:"none", border:"none", cursor:"pointer", fontSize:16, padding:4}}>
              {ocultarValores ? "\uD83D\uDE48" : "\uD83D\uDC41\uFE0F"}
            </button>
          </div>
          <div style={s.row}>
            <div style={{...s.card, flex:1}}>
              <p style={s.label}>Investido</p>
              <p style={s.bigNum}>{mask("$" + totalInvested.toFixed(2))}</p>
            </div>
            <div style={{...s.card, flex:1}}>
              <p style={s.label}>Valor Atual</p>
              <p style={s.bigNum}>{mask("$" + totalValue.toFixed(2))}</p>
            </div>
          </div>
          <div style={s.row}>
            <div style={{...s.card, flex:1}}>
              <p style={s.label}>P&L Total</p>
              <p style={{...s.bigNum, color: totalPnl>=0?"#22c55e":"#ef4444"}}>{mask((totalPnl>=0?"+":"") + "$" + totalPnl.toFixed(2))}<br/><span style={{fontSize:12}}>{totalPnlPct.toFixed(2)}%</span></p>
            </div>
            <div style={{...s.card, flex:1}}>
              <p style={s.label}>{marketStatus.status === "open" ? "Hoje" : "Últ. pregão"}</p>
              <p style={{...s.bigNum, color: totalDailyPnl>=0?"#22c55e":"#ef4444"}}>{mask((totalDailyPnl>=0?"+":"") + "$" + totalDailyPnl.toFixed(2))}<br/><span style={{fontSize:12}}>{(totalValue - totalDailyPnl) > 0 ? (totalDailyPnl/(totalValue - totalDailyPnl)*100).toFixed(2) : "0"}%</span></p>
            </div>
          </div>

          {totalPnl < 0 && (
            <div style={{...s.card, backgroundColor:"rgba(239,68,68,0.05)", border:"1px solid rgba(239,68,68,0.2)"}}>
              <p style={{color:"#9ca3af", fontSize:11, margin:"0 0 4px 0"}}>📍 Breakeven do Portfólio</p>
              <p style={{color:"#ef4444", fontSize:13, fontWeight:700, margin:0}}>
                Precisa de <span style={{color:"#f59e0b"}}>+{totalInvested > 0 ? ((totalInvested - totalValue) / totalValue * 100).toFixed(2) : "0"}%</span> para recuperar o investido
              </p>
              <p style={{color:"#6b7280", fontSize:10, marginTop:4}}>
                {mask("Faltam $" + Math.abs(totalPnl).toFixed(2) + " · Investido $" + totalInvested.toFixed(2) + " · Atual $" + totalValue.toFixed(2))}
              </p>
            </div>
          )}

          {(() => {
            const _r = resultadoRealizado(transactions)
            if (Math.abs(_r.total) < 0.01) return null
            const _tot = _r.total + totalPnl
            const _cor = v => v >= 0 ? "#22c55e" : "#ef4444"
            const _fmt = v => mask((v >= 0 ? "+" : "") + "$" + v.toFixed(2))
            return (
              <div style={s.card}>
                <p style={s.cardTitle}>🧾 Resultado realizado</p>
                <p style={{color:"#9ca3af", fontSize:11, lineHeight:1.5, margin:"0 0 10px 0"}}>
                  O P&L acima mede só as cotas que você tem hoje. O que já foi vendido, com lucro ou com prejuízo, saiu da conta e não aparece lá. Aqui aparece. Custo médio a cada venda, a mesma convenção da corretora.
                </p>
                <div style={{display:"flex", gap:8}}>
                  <div style={{flex:1}}>
                    <p style={{color:"#6b7280", fontSize:10, margin:0}}>Já realizado</p>
                    <p style={{color:_cor(_r.total), fontSize:15, fontWeight:700, margin:"2px 0 0 0"}}>{_fmt(_r.total)}</p>
                  </div>
                  <div style={{flex:1}}>
                    <p style={{color:"#6b7280", fontSize:10, margin:0}}>Em carteira</p>
                    <p style={{color:_cor(totalPnl), fontSize:15, fontWeight:700, margin:"2px 0 0 0"}}>{_fmt(totalPnl)}</p>
                  </div>
                  <div style={{flex:1}}>
                    <p style={{color:"#6b7280", fontSize:10, margin:0}}>Total</p>
                    <p style={{color:_cor(_tot), fontSize:15, fontWeight:700, margin:"2px 0 0 0"}}>{_fmt(_tot)}</p>
                  </div>
                </div>
                <p style={{color:"#6b7280", fontSize:10, marginTop:8, lineHeight:1.5}}>
                  Sai dos preços gravados em cada transação. As 1.547 operações das duas corretoras foram conferidas uma a uma contra os extratos, de novembro de 2022 a outubro de 2026. Não inclui corretagem: a Avenue cobrou $172,50 que não estão descontados aqui.
                </p>
              </div>
            )
          })()}

          {barData.length > 0 && (
            <div style={s.card}>
              <p style={s.cardTitle}>📊 Distribuição</p>
              <ResponsiveContainer width="100%" height={180}>
                <BarChart data={barData} margin={{top:4, right:4, left:-20, bottom:20}}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                  <XAxis dataKey="name" stroke="#888" fontSize={7} interval={0} angle={-35} textAnchor="end" />
                  <YAxis stroke="#888" fontSize={8} />
                  <Tooltip contentStyle={{backgroundColor:"#1a1a2e", border:"none", color:"#fff"}} />
                  <Bar dataKey="valor" fill="#6366f1" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}

          <div style={s.card}>
            <p style={s.cardTitle}>📋 Posições</p>
            {etfEnriched.length === 0 ? <p style={s.empty}>Adicione posições na aba ➕</p> : etfEnriched.map(p => (
              <div key={p.id} style={{...s.posRow, cursor:"pointer"}} onClick={() => { if(selectedPosition===p.symbol){setSelectedPosition(null);setPositionEntries([])} else {setSelectedPosition(p.symbol);loadPositionEntries(p.symbol, p.asset_type)} }}>
                <div style={{flex:1}}>
                  <div style={s.posSymbol}>{p.symbol} <span style={{fontSize:10, color:"#6366f1"}}>{selectedPosition===p.symbol?"▲":"▼"}</span></div>
                  <div style={s.posDetail}>{p.quantity} cotas @ ${p.avg_price} • {p.purchase_date}</div>
                  <div style={s.posDetail}>Atual: ${p.currentPrice?.toFixed(4)} • ${p.value.toFixed(2)}</div>
                  <div style={{display:"flex", gap:6, marginTop:4}}>
                    <span style={{...s.badge, backgroundColor: p.pnl>=0?"#16a34a33":"#dc262633", color: p.pnl>=0?"#22c55e":"#ef4444"}}>{p.pnlPct.toFixed(2)}% | {p.pnl>=0?"+":"-"}${Math.abs(p.pnl).toFixed(2)}</span>
                    <span style={{...s.badge, backgroundColor: p.dailyChange>=0?"#16a34a33":"#dc262633", color: p.dailyChange>=0?"#22c55e":"#ef4444"}}>{p.isCrypto ? "24h" : marketStatus.status === "open" ? "Hoje" : "Últ. pregão"}: {p.dailyChange>=0?"+":""}{p.dailyChange.toFixed(2)}%</span>
                    {p.preMarketChange && p.preMarketChange !== 0 ? <span style={{...s.badge, backgroundColor:"rgba(251,191,36,0.15)", color:"#fbbf24"}}>PM: {p.preMarketChange>=0?"+":""}{p.preMarketChange.toFixed(2)}%</span> : p.postMarketChange && p.postMarketChange !== 0 ? <span style={{...s.badge, backgroundColor:"rgba(99,102,241,0.15)", color:"#a78bfa"}}>AH: {p.postMarketChange>=0?"+":""}{p.postMarketChange.toFixed(2)}%</span> : null}{p.currentPrice < p.avg_price ? <span style={{...s.badge, backgroundColor:"rgba(251,191,36,0.1)", color:"#fbbf24"}}>📉 +{((p.avg_price - p.currentPrice) / p.currentPrice * 100).toFixed(1)}% para empatar</span> : null}
                  </div>
                  {selectedPosition===p.symbol && (
                    <div style={{marginTop:8, borderTop:"1px solid rgba(99,102,241,0.2)", paddingTop:8}}>
                      {loadingEntries ? <p style={{color:"#888", fontSize:11}}>Carregando aportes...</p> :
                      positionEntries.length === 0 ? <p style={{color:"#888", fontSize:11}}>Nenhum aporte registrado</p> :
                      positionEntries.map((e,i) => (
                        <div key={e.id} style={{display:"flex", justifyContent:"space-between", fontSize:11, color:"#94a3b8", marginBottom:4, fontFamily:"monospace"}}>
                          <span>📅 {e.purchase_date} — {e.quantity} cotas @ ${parseFloat(e.price).toFixed(2)}</span>
                          <span style={{color:"#6366f1"}}>{e.exchange || "—"}</span>
                        </div>
                      ))}
                    </div>
                  )}
                {delArm === p.id && <p style={{color:"#fca5a5", fontSize:11, margin:"6px 0 0 0", lineHeight:1.4}}>{"Tocar de novo vende " + p.quantity + " cotas a $" + (p.currentPrice || p.avg_price || 0).toFixed(2) + " e apaga a posição."}</p>}
                </div>
                <button onClick={(ev) => {ev.stopPropagation(); openEditModal(p.symbol, p.asset_type)}} style={{...s.delBtn, backgroundColor:"#1f2937", color:"#6366f1", marginRight:4}}>✏️</button>
                <button onClick={(ev) => {ev.stopPropagation(); if (delArm === p.id) { setDelArm(null); deletePosition(p.id) } else { setDelArm(p.id); setTimeout(() => setDelArm(c => c === p.id ? null : c), 4000) }}} style={delArm === p.id ? {...s.delBtn, background:"#7f1d1d", borderRadius:6} : s.delBtn}>🗑️</button>
              </div>
            ))}
          </div>

          {etfEnriched.length > 0 && Object.keys(prices).length > 0 && (
            <div style={{...s.card, marginBottom:16}}>
              <p style={s.cardTitle}>📅 Performance Semanal</p>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                  <thead>
                    <tr style={{borderBottom:"1px solid rgba(255,255,255,0.1)"}}>
                      {["ETF","Preço","Valor","P/L Semana","P/L $ Semana","P/L Total","P/L $Total"].map(h => (
                        <th key={h} style={{textAlign:"right",padding:"4px 8px",color:"#64748b",fontWeight:600}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {etfEnriched.map((p,i) => {
                      const purchaseDateStr = p.purchase_date || ""
                      const todayDate = new Date()
                      const dayOfWeek = todayDate.getDay() || 7
                      const lastMonday = new Date(todayDate)
                      lastMonday.setDate(todayDate.getDate() - dayOfWeek - 6)
                      const lastMondayStr = lastMonday.toISOString().slice(0,10)
                      const boughtThisWeek = purchaseDateStr >= lastMondayStr
                      const weekPct = boughtThisWeek && p.avg_price > 0 && p.currentPrice > 0
                        ? ((p.currentPrice - p.avg_price) / p.avg_price * 100)
                        : (prices[p.symbol]?.weekly_change_pct ?? null)
                      const weekPnl = weekPct !== null ? (p.value||0) * (weekPct/100) : null
                      return (
                        <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
                          <td style={{padding:"6px 8px",color:"#e2e8f0",fontWeight:700}}>{p.symbol}</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:"#94a3b8"}}>${(p.currentPrice||0).toFixed(2)}</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:"#94a3b8"}}>${(p.value||0).toFixed(2)}</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:weekPct>=0?"#22c55e":"#ef4444"}}>{weekPct!==null?`${weekPct>=0?"+":""}${weekPct.toFixed(2)}%`:"—"}</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:weekPnl>=0?"#22c55e":"#ef4444"}}>{weekPnl!==null?`${weekPnl>=0?"+":"-"}$${Math.abs(weekPnl).toFixed(2)}`:"—"}</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:(p.pnlPct||0)>=0?"#22c55e":"#ef4444"}}>{(p.pnlPct||0)>=0?"+":""}{(p.pnlPct||0).toFixed(2)}%</td><td style={{padding:"6px 8px",textAlign:"right",color:(p.pnl||0)>=0?"#22c55e":"#ef4444"}}>{(p.pnl||0)>=0?"+":"-"}${Math.abs(p.pnl||0).toFixed(2)}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                  <tfoot>
                    <tr style={{borderTop:"1px solid rgba(255,255,255,0.2)"}}>
                      <td colSpan={2} style={{padding:"6px 8px",color:"#e2e8f0",fontWeight:700}}>Total</td>
                      <td style={{padding:"6px 8px",textAlign:"right",color:"#e2e8f0",fontWeight:700}}>${etfEnriched.reduce((s,p)=>s+(p.value||0),0).toFixed(2)}</td>
                      <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700,color:etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)>=0?"#22c55e":"#ef4444"}}>
                        {(etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)>=0?"+":"")}
                        {(etfEnriched.reduce((s,p)=>{return s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100},0)/Math.max(etfEnriched.reduce((s,p)=>s+(p.value||0),0)-etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0),1)*100).toFixed(2)}%
                      </td>
                      <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700,color:etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)>=0?"#22c55e":"#ef4444"}}>
                        {etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)>=0?"+":"-"}$
                        {Math.abs(etfEnriched.reduce((s,p)=>s+(prices[p.symbol]?.weekly_change_pct??0)*(p.value||0)/100,0)).toFixed(2)}
                      </td>
                      <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700,color:etfEnriched.reduce((s,p)=>s+(p.pnl||0),0)>=0?"#22c55e":"#ef4444"}}>
                        {etfEnriched.reduce((s,p)=>s+(p.pnl||0),0)>=0?"+":""}{(etfEnriched.reduce((s,p)=>s+(p.pnl||0),0)/Math.max(etfEnriched.reduce((s,p)=>s+(p.invested||0),0),1)*100).toFixed(2)}%
                      </td>
                      <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700,color:etfEnriched.reduce((s,p)=>s+(p.pnl||0),0)>=0?"#22c55e":"#ef4444"}}>
                        {etfEnriched.reduce((s,p)=>s+(p.pnl||0),0)>=0?"+":"-"}${Math.abs(etfEnriched.reduce((s,p)=>s+(p.pnl||0),0)).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}

          <div style={s.card}>
            <p style={s.cardTitle}>🤖 Análise Claude</p>
            <button onClick={analyzePortfolio} style={{...s.addBtn, marginBottom: analysis?12:0}} disabled={analyzing}>
              {analyzing ? "⏳ Analisando..." : isPremium ? "✨ Analisar com Claude" : analysisCount >= 1 ? "⭐ Premium — Análises Ilimitadas" : "✨ Analisar com Claude (1 grátis/dia)"}
            </button>
            {analysis && <p style={{color:"#e5e7eb", fontSize:13, lineHeight:1.6, margin:0}}>{translatedAnalysis || analysis}</p>}
            {analysis && (
              <div style={{marginTop:8}}>
                {!translatedAnalysis ? (
                  <button
                    onClick={() => translateAnalysis(analysis, setTranslatedAnalysis, setTranslatingAnalysis)}
                    disabled={translatingAnalysis}
                    style={{...s.addBtn, fontSize:12, padding:"6px 12px", marginBottom:0, background:"#1f2937"}}
                  >
                    {translatingAnalysis ? "⏳ Translating..." : "🌐 Translate to English"}
                  </button>
                ) : (
                  <button
                    onClick={() => setTranslatedAnalysis("")}
                    style={{...s.addBtn, fontSize:12, padding:"6px 12px", marginBottom:0, background:"#1f2937"}}
                  >
                    🔄 Show Original
                  </button>
                )}
              </div>
            )}
          </div>
          <p style={s.powered}>AI analysis powered by Anthropic Claude.</p>
          <p style={{color:"#9ca3af", fontSize:11, textAlign:"center", marginBottom:2, fontWeight:600, letterSpacing:"0.5px"}}>© 2026 Signal Forge. All rights reserved.</p><p style={{color:"#6b7280", fontSize:9, textAlign:"center", marginBottom:4, lineHeight:1.4, padding:"0 16px"}}>ClawETF™, CLAW™, CLAW AI™, CLAW Optimizer™, CLAW Advanced Analytics™, ClawETF Premium Score™, CLAW DCA Intelligence™, CLAW DCA Efficiency Score™, CLAW Diversification Engine™, CLAW Confluence Score™ e CLAW Exhaustion Score™ são marcas e tecnologias proprietárias da Signal Forge.</p>
          <p style={{color:"#6b7280", fontSize:9, textAlign:"center", marginBottom:0, paddingBottom:"env(safe-area-inset-bottom, 24px)", lineHeight:1.4, padding:"0 16px 32px 16px"}}>⚠️ Este aplicativo destina-se exclusivamente a fins informativos e educacionais. Não constitui recomendação de investimento, oferta ou solicitação de compra ou venda de ativos financeiros. Consulte um profissional habilitado antes de tomar qualquer decisão de investimento.</p>
        </div>
      )}

      {tab === "grafico" && (
        <div>
          <div style={s.card}>
            <p style={s.cardTitle}>📈 Meu Portfólio</p>
            <div style={{display:"flex", gap:4, flexWrap:"wrap", marginBottom:12}}>
              {PERIODS.map(p => (
                <button key={p.value} onClick={() => setChartPeriod(p.value)}
                  style={{padding:"5px 10px", backgroundColor: chartPeriod===p.value?"#6366f1":"#1f2937", border:"none", color: chartPeriod===p.value?"#fff":"#9ca3af", borderRadius:6, cursor:"pointer", fontSize:11}}>
                  {p.label}
                </button>
              ))}
              <button onClick={() => setChartMoeda(chartMoeda === "USD" ? "BRL" : "USD")}
                style={{padding:"5px 10px", backgroundColor:"#1f2937", border:"1px solid #374151", color:"#9ca3af", borderRadius:6, cursor:"pointer", fontSize:11, marginLeft:"auto"}}>
                {chartMoeda === "USD" ? "US$" : "R$"}
              </button>
            </div>
            {loadingChart ? <p style={{color:"#888", textAlign:"center"}}>Carregando...</p> : (() => {
              // converte cada ponto pela cotacao da propria data: usar a taxa
              // de hoje para todo o historico daria um retorno em reais errado
              const cd = chartMoeda === "BRL"
                ? chartData.map(d => ({...d, v: d.brl ? d.v * d.brl : d.v, i: (d.i != null && d.brl) ? d.i * d.brl : d.i}))
                : chartData
              const cifrao = chartMoeda === "BRL" ? "R$" : "$"
              const first = cd[0]?.v || 0
              const last = cd[cd.length-1]?.v || 0
              // retorno ponderado no tempo: desconta o aporte de cada dia antes
              // de medir a variacao. sem isso, comprar um ativo virava "valorizacao"
              // O fluxo de caixa de uma venda e o PROVENTO, nao o custo baixado. Como 'i'
              // e o custo, num dia de venda o delta de i vale -custo, e a diferenca para
              // -provento e exatamente o lucro realizado. Usar o delta de i como fluxo
              // fazia TODA venda lucrativa entrar como retorno negativo: no MAX o TWR
              // dizia -11,54% numa conta que ganhou $10,5 mil em 2024, e o ganho em dolar
              // dizia +$63,08 num periodo de +$7.365 realizados. Fluxo certo = delta de i
              // menos delta do realizado, e isso corrige de uma vez os quatro numeros:
              // dolar, TWR, Dietz e a linha do eixo direito. Em reais nao soma, porque o
              // realizado esta em dolar e converter cada venda pela cotacao da data dela
              // nao esta implementado: ali mantem o delta de i.
              const _realAcum = (() => {
                if (chartMoeda === "BRL") return null
                const pd = (resultadoRealizado(transactions) || {}).porData
                if (!pd || !pd.length || !cd[0] || !cd[0].iso) return null
                return cd.map(d => {
                  const dia = String(d.iso || "").slice(0, 10)
                  let a = 0
                  for (const x of pd) { if (x.d <= dia) a = x.acc; else break }
                  return a
                })
              })()
              const _fluxo = (k) => {
                const di = (cd[k].i || 0) - (cd[k-1].i || 0)
                if (!_realAcum) return di
                return di - (_realAcum[k] - _realAcum[k-1])
              }
              const twr = (() => {
                if (cd.length < 2 || cd.some(d => d.i === undefined)) return null
                let acc = 1
                for (let k = 1; k < cd.length; k++) {
                  const vAnt = cd[k-1].v, vAtual = cd[k].v
                  const aporte = _fluxo(k)
                  if (vAnt <= 0) continue
                  acc *= (vAtual - aporte) / vAnt
                }
                return (acc - 1) * 100
              })()
              // encadear retorno diario divide pelo valor da vespera.
              // quando a carteira foi a caixa e voltou dezenas de vezes,
              // como de 2022 a 2024, a divisao e por quase zero e o
              // encadeado nao mede nada: dava -54,46% em vermelho ao
              // lado de +$3.370,88 de ganho conferido contra os extratos.
              const _twrOk = (() => {
                if (twr === null || cd.length < 2) return false
                const m = cd.reduce((a, d) => a + (d.v || 0), 0) / cd.length
                if (m <= 0) return false
                return !cd.slice(0, -1).some(d => (d.v || 0) < 0.05 * m)
              })()
              // taxa interna de retorno, anualizada. sobrevive aos vales
              // porque nao encadeia: desconta cada fluxo pelo tempo que
              // ficou aplicado. mede o rendimento ENQUANTO o dinheiro
              // esteve na carteira, nao o do saldo parado em caixa.
              const tir = (() => {
                if (cd.length < 2 || cd.some(d => d.i === undefined)) return null
                const t0 = new Date(cd[0].iso).getTime()
                if (!t0) return null
                const anos = (x) => (new Date(x).getTime() - t0) / 31536000000
                const f = [[0, -(cd[0].v || 0)]]
                for (let k = 1; k < cd.length; k++) {
                  const c = _fluxo(k)
                  if (Math.abs(c) > 0.004) f.push([anos(cd[k].iso), -c])
                }
                const fim = anos(cd[cd.length - 1].iso)
                if (!(fim > 0.08)) return null
                f.push([fim, cd[cd.length - 1].v || 0])
                const vpl = (r) => f.reduce((a, x) => a + x[1] / Math.pow(1 + r, x[0]), 0)
                if (!(vpl(-0.9499) > 0 && vpl(9) < 0)) return null
                let lo = -0.9499, hi = 9
                for (let i = 0; i < 100; i++) {
                  const m = (lo + hi) / 2
                  if (vpl(m) > 0) lo = m; else hi = m
                }
                return lo * 100
              })()
              // ganho do periodo: variacao diaria menos o fluxo de caixa daquele dia
              const ganho = (() => {
                if (cd.length < 2 || cd.some(d => d.i === undefined)) return null
                let g = 0
                for (let k = 1; k < cd.length; k++) {
                  g += cd[k].v - cd[k-1].v - _fluxo(k)
                }
                return g
              })()
              const _mwrCalc = (() => {
                if (cd.length < 2 || cd.some(d => d.i === undefined)) return null
                const n = cd.length - 1
                const vIni = cd[0].v, vFim = cd[n].v
                let aportes = 0, ponderado = 0
                for (let k = 1; k <= n; k++) {
                  const c = _fluxo(k)
                  aportes += c
                  ponderado += c * ((n - k) / n)   // fracao do periodo que o aporte rendeu
                }
                const base = vIni + ponderado
                // O Dietz modificado supoe que a base representa o capital medio do periodo.
                // Com 32 meses e uma retirada de $22 mil no meio, os aportes ponderados quase
                // cancelam e a base caiu para $744 numa carteira que passou de $24 mil: a taxa
                // saiu 997,60%. O metodo foi feito para UM periodo com fluxo moderado. Quando a
                // base deixa de representar capital, o certo e dizer que nao e mensuravel, como
                // o resto do app faz com 'sem dados' em vez de imprimir um numero qualquer.
                const _mediaV = cd.reduce((a, d) => a + (d.v || 0), 0) / cd.length
                if (base <= 0) return null
                // o dolar NAO sai por proporcao: escalar por vIni/base inventava
                // uma quantia menor que a perda real ($706 contra $913). O dinheiro
                // ganho ou perdido e um so — o que muda entre TWR e Dietz e a
                // TAXA, nao o valor. Os dois cartoes mostram o mesmo dolar.
                return { pct: (vFim - vIni - aportes) / base * 100,
                         usd: (vFim - vIni - aportes), mensuravel: base >= 0.2 * _mediaV }
              })()
              const mwr = _mwrCalc ? _mwrCalc.pct : null
              const mwrUsd = _mwrCalc ? _mwrCalc.usd : null
              const _mwrOk = !!(_mwrCalc && _mwrCalc.mensuravel)
              const chg = chartPeriod === "1d" && totalValue > 0 ? (totalDailyPnl / (totalValue - totalDailyPnl) * 100) : (twr !== null ? twr : (first > 0 ? ((last - first) / first * 100) : 0))
              // retorno acumulado ponto a ponto, para a linha do eixo direito
              const serie = (() => {
                if (cd.length < 2 || cd.some(d => d.i === undefined)) return cd
                let acc = 1
                return cd.map((d, k) => {
                  if (k === 0) return {...d, ret: 0}
                  const vAnt = cd[k-1].v
                  const aporte = _fluxo(k)
                  if (vAnt > 0) acc *= (d.v - aporte) / vAnt
                  return {...d, ret: Math.round((acc - 1) * 1000) / 10}
                })
              })()
              const _enc = chartPeriod === "1d" || _twrOk
              const _pctVal = _enc ? chg : tir
              const _pctTxt = _enc ? ((chg >= 0 ? "+" : "") + chg.toFixed(2) + "%")
                : (tir !== null ? ((tir >= 0 ? "+" : "") + tir.toFixed(2) + "% ao ano") : null)
              const chgColor = (_pctVal === null || _pctVal === undefined ? chg : _pctVal) >= 0 ? "#22c55e" : "#ef4444"
              return (
                <div>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}>
                    <span style={{fontSize:20, fontWeight:"bold", color:"#fff"}}>{cifrao}{last.toFixed(2)}</span>
                    {(()=>{const u = chartPeriod === "1d" ? totalDailyPnl : (ganho !== null ? ganho : last-first); return <span style={{fontSize:14, fontWeight:"bold"}}><span style={{color: u>=0?"#22c55e":"#ef4444"}}>{u>=0?"+":"-"}{cifrao}{Math.abs(u).toFixed(2)}</span> {_pctTxt && <span style={{color:chgColor}}>({_pctTxt})</span>}</span>})()}
                  </div>
                  {mwr !== null && chartPeriod !== "1d" && <div style={{fontSize:11, color:"#6b7280", marginBottom:8, lineHeight:1.4}}>
                    Retorno do capital investido: <span style={{color: _mwrOk ? (mwr>=0?"#22c55e":"#ef4444") : "#8b93a1", fontWeight:700}}>{_mwrOk ? ((mwrUsd !== null ? (mwrUsd>=0?"+":"-") + "$" + Math.abs(mwrUsd).toFixed(2) + " " : "") + "(" + (mwr>=0?"+":"") + mwr.toFixed(2) + "%)") : "n\u00e3o mensur\u00e1vel nesta janela"}</span>
                    <div style={{fontSize:9, color:"#4b5563"}}>{_twrOk ? "O percentual que acompanha o total da carteira é o retorno do período, como um fundo mede. " : "O percentual que acompanha o total da carteira é a taxa interna de retorno anualizada: quanto o dinheiro rendeu ao ano enquanto esteve aplicado. O retorno encadeado não aparece porque a carteira foi a caixa e voltou várias vezes no período, e dividir o ganho de cada dia por um valor quase zero não mede nada. "}{_mwrOk ? "O retorno do capital investido pondera quando cada aporte entrou e quanto tempo ficou trabalhando. Sem aporte novo na janela os dois coincidem; com aporte recente, eles divergem." : "O retorno do capital investido n\u00e3o aparece nesta janela: ele divide o ganho pelo capital m\u00e9dio do per\u00edodo, e aqui as entradas e sa\u00eddas grandes quase se cancelam, deixando um denominador que n\u00e3o representa o dinheiro que ficou trabalhando. Em janelas mais curtas ele volta."}</div>
                  </div>}
                  <ChartLine data={serie} color={chgColor} formatter={(v) => ["$"+v.toFixed(2)]} />
                </div>
              )
            })()}
          </div>
          {Object.keys(sparks).length > 0 && (
            <div style={s.card}>
              <p style={s.cardTitle}>📊 Seus ativos · 1 mês</p>
              <p style={{color:"#4b5563", fontSize:9, margin:"0 0 10px 0", lineHeight:1.5}}>A linha desenha os últimos 30 dias. O preço e o percentual à direita são de hoje.</p>
              {etfEnriched.filter(x => sparks[x.symbol]).sort((a,b) => (b.dailyChange||0) - (a.dailyChange||0)).map((x, k) => {
                const v = sparks[x.symbol]
                const lo = Math.min(...v), hi = Math.max(...v), fx = (hi - lo) || 1
                const W = 90, H = 26
                const pts = v.map((y, n) => (n / (v.length - 1) * W).toFixed(1) + "," + (H - (y - lo) / fx * H).toFixed(1)).join(" ")
                const dc = x.dailyChange || 0
                const cor = dc > 0 ? "#22c55e" : dc < 0 ? "#ef4444" : "#6b7280"
                return (
                  <div key={k} style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"7px 0", borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                    <span style={{color:"#e2e8f0", fontSize:12, fontWeight:600, minWidth:52}}>{x.symbol}</span>
                    <svg width={W} height={H}><polyline points={pts} fill="none" stroke={cor} strokeWidth="1.5" strokeLinejoin="round"/></svg>
                    <div style={{textAlign:"right", minWidth:74}}>
                      <p style={{color:"#e2e8f0", fontSize:11, margin:0}}>${(x.currentPrice||0).toFixed(2)}</p>
                      <p style={{color:cor, fontSize:10, margin:0}}>{dc > 0 ? "+" : ""}{dc.toFixed(2)}%</p>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          {!isPremium2 ? ( 
            <div style={{...s.card, textAlign:"center", padding:20, background:"linear-gradient(135deg, #0f172a, #0c2537)", border:"1px solid #1e3a5f"}}>
              <div style={{fontSize:32, marginBottom:6}}>📉</div>
              <p style={{color:"#7dd3fc", fontSize:15, fontWeight:"bold", margin:"0 0 6px 0"}}>Evolução das métricas</p>
              <p style={{color:"#bae6fd", fontSize:12, margin:"0 0 14px 0", lineHeight:1.5}}>
                Veja como o Sharpe e o drawdown da sua carteira andaram ao longo das semanas — não só o valor de hoje.
              </p>
              <button onClick={() => setTab("premium2")} style={{...s.addBtn, background:"linear-gradient(135deg,#0284c7,#0ea5e9)", fontSize:13}}>
                💎 Incluído no Premium 2
              </button>
            </div>
          ) : historico.length >= 2 ? (() => {
            const fmt = (d) => _umDia
              ? new Date(d).toLocaleTimeString("pt-BR", {hour:"2-digit", minute:"2-digit"})
              : new Date(d).toLocaleDateString("pt-BR", {day:"2-digit", month:"2-digit"})
            // agrupa por dia (ultimo do dia). Se tudo for do mesmo dia,
            // mostra ponto a ponto com a hora, para o card nao sumir
            const _base = historico.filter(h => h.sharpe != null)
            const _dias = [...new Set(_base.map(h => h.criado_em.slice(0,10)))]
            const _pd = {}
            _base.forEach(h => { _pd[h.criado_em.slice(0,10)] = h })
            const serie = _dias.length >= 2 ? _dias.sort().map(k => _pd[k]) : _base
            const _umDia = _dias.length < 2
            // o eixo automatico ampliava uma variacao de 0.01 ate virar diagonal:
            // faixa minima para variacao irrisoria parecer o que e
            const _faixa = (vals, min) => {
              const v = vals.filter(x => !Number.isNaN(x))
              if (!v.length) return ["auto", "auto"]
              const lo = Math.min(...v), hi = Math.max(...v)
              const meio = (lo + hi) / 2, metade = Math.max((hi - lo) / 2, min / 2)
              return [Math.round((meio - metade) * 100) / 100, Math.round((meio + metade) * 100) / 100]
            }
            const _fSh = _faixa(serie.map(h => parseFloat(h.sharpe)), 0.3)
            const _fDd = _faixa(serie.map(h => parseFloat(h.max_drawdown)), 3)
            if (serie.length < 2) return null
            return (
              <div style={s.card}>
                <p style={s.cardTitle}>📉 Evolução das métricas</p>
                <p style={{color:"#4b5563", fontSize:9, margin:"0 0 8px 0", lineHeight:1.5}}>
                  Como o risco da carteira andou ao longo do tempo, não o valor. Toque na linha para ver os valores de cada data. Cada ponto usa a carteira daquele dia: quando você vende ou troca de ativo, a linha dá um degrau — e esse degrau é a sua decisão, não o mercado.
                </p>
                <p style={{color:"#9ca3af", fontSize:10, margin:"0 0 2px 0"}}>Sharpe <span style={{color:"#4b5563", fontSize:9}}>— retorno por unidade de risco; subir é melhor</span></p>
                <ResponsiveContainer width="100%" height={110}>
                  <LineChart data={serie.map(h => ({t: fmt(h.criado_em), v: parseFloat(h.sharpe)}))} margin={{top:4,right:6,left:0,bottom:0}}>
                    <XAxis dataKey="t" stroke="#333" fontSize={9} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false} interval="preserveStartEnd"/>
                    <YAxis stroke="#333" fontSize={9} domain={_fSh} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false}/>
                    <Tooltip contentStyle={{backgroundColor:"#0a0a0f", border:"1px solid #1f2937", borderRadius:8, fontSize:11}}/>
                    <Line type="monotone" dataKey="v" stroke="#6366f1" strokeWidth={2} dot={false}/>
                  </LineChart>
                </ResponsiveContainer>
                <p style={{color:"#9ca3af", fontSize:10, margin:"10px 0 2px 0"}}>Max Drawdown <span style={{color:"#4b5563", fontSize:9}}>— maior queda do pico ao fundo; subir (menos negativo) é melhor</span></p>
                <ResponsiveContainer width="100%" height={110}>
                  <LineChart data={serie.map(h => ({t: fmt(h.criado_em), v: parseFloat(h.max_drawdown)}))} margin={{top:4,right:6,left:0,bottom:0}}>
                    <XAxis dataKey="t" stroke="#333" fontSize={9} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false} interval="preserveStartEnd"/>
                    <YAxis stroke="#333" fontSize={9} domain={_fDd} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false}/>
                    <Tooltip contentStyle={{backgroundColor:"#0a0a0f", border:"1px solid #1f2937", borderRadius:8, fontSize:11}}/>
                    <Line type="monotone" dataKey="v" stroke="#ef4444" strokeWidth={2} dot={false}/>
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )
          })() : null}
        </div>
      )}

      {tab === "adicionar" && (
        <div style={s.card}>
          <p style={s.cardTitle}>➕ Adicionar Posição</p>
                <p style={{color:"#6b7280", fontSize:10, margin:"0 0 10px 0", lineHeight:1.5}}>Só para ativo que você ainda NÃO tem. A data digitada aqui é a que vale para o gráfico. Já tem esse ativo? Use o lápis na posição.</p>
          <div style={{display:"flex", gap:4, marginBottom:12}}>
            <button onClick={() => {setPosType("etf"); setSymbol("")}}
              style={{flex:1, padding:"8px", border:"none", borderRadius:6, cursor:"pointer",
                backgroundColor: posType==="etf" ? "#6366f1" : "#1f2937",
                color: posType==="etf" ? "#fff" : "#9ca3af", fontSize:12, fontWeight:"bold"}}>
              📊 ETF
            </button>
            <button onClick={() => {setPosType("crypto"); setSymbol("")}}
              style={{flex:1, padding:"8px", border:"none", borderRadius:6, cursor:"pointer",
                backgroundColor: posType==="crypto" ? "#f59e0b" : "#1f2937",
                color: posType==="crypto" ? "#fff" : "#9ca3af", fontSize:12, fontWeight:"bold"}}>
              ₿ Crypto Spot
            </button>
          </div>
          {posType === "etf" ? (
            <div>
              <select value={""} onChange={e => { if(e.target.value) { openEditModal(e.target.value, "etf") } }} style={{...s.input, marginBottom:6}}>
                <option value="">Já tenho — ajustar no ✏️...</option>
                {etfEnriched.map(x => x.symbol).map(e => <option key={e} value={e}>{e}{prices[e] ? " — $"+prices[e].price : ""}</option>)}
              </select>
              <div style={{fontSize:11, color:"#64748b", textAlign:"center", marginBottom:6}}>— ou —</div>
              <input value={txtSym} onChange={e => { const _v = e.target.value.toUpperCase(); setTxtSym(_v); setSymbol(_v) }} placeholder="Digite o ticker (ex: DRI, AAPL, VOO...)" style={{...s.input, marginBottom:0}} />
            </div>
          ) : (
            <select value={symbol} onChange={e => setSymbol(e.target.value)} style={s.input}>
              <option value="">Selecione a Crypto</option>
              {Object.entries(cryptoPrices).sort((a,b)=>(a[1].rank||99)-(b[1].rank||99)).map(([sym,data]) => (
                <option key={sym} value={sym}>{sym} — {data.name} — ${data.price >= 1 ? data.price.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2}) : data.price.toFixed(6)}</option>
              ))}
            </select>
          )}
          <input placeholder="Quantidade" value={qty} onChange={e => setQty(e.target.value)} style={s.input} type="text" inputMode="decimal" />
          <input placeholder="Preço de compra (USD)" value={avgPrice} onChange={e => setAvgPrice(e.target.value)} style={s.input} type="text" inputMode="decimal" />
          <label style={{color:"#9ca3af", fontSize:11, marginBottom:2, display:"block"}}>📅 Data do aporte</label>
          <input value={date} onChange={e => setDate(e.target.value)} style={s.input} type="date" />
          {posType === "etf" && (
            <select value={exchange} onChange={e => setExchange(e.target.value)} style={{...s.input, color: exchange ? "#fff" : "#9ca3af"}}>
              <option value="">Exchange (opcional)</option>
              <option value="Avenue">Avenue</option>
              <option value="Nomad">Nomad</option>
              <option value="Outro">Outro</option>
            </select>
          )}
          <button onClick={addPosition} style={s.addBtn}>Adicionar Posição</button>
        </div>
      )}


      {tab === "spot" && (
        <div>
          {(() => {
            const spotPositions = enriched.filter(p => p.isCrypto)
            const spotInvested = spotPositions.reduce((s,p) => s+p.invested, 0)
            const spotValue = spotPositions.reduce((s,p) => s+p.value, 0)
            const spotPnl = spotValue - spotInvested
            const spotPnlPct = spotInvested > 0 ? (spotPnl/spotInvested*100) : 0
            const spotDailyPnl = spotPositions.reduce((s,p) => s+p.dailyPnl, 0)
            const spotBarData = spotPositions.map(p => ({ name: p.symbol, valor: parseFloat(p.value.toFixed(2)) }))

            return (
              <>
                <div style={{display:"flex", justifyContent:"flex-end", marginBottom:4}}>
                  <button
                    onClick={() => { const _v = !ocultarValores; setOcultarValores(_v); localStorage.setItem("ocultar_valores", _v ? "1" : "0") }}
                    title={ocultarValores ? "Mostrar valores" : "Ocultar valores"}
                    style={{background:"none", border:"none", cursor:"pointer", fontSize:16, padding:4}}>
                    {ocultarValores ? "\uD83D\uDE48" : "\uD83D\uDC41\uFE0F"}
                  </button>
                </div>
                <div style={s.row}>
                  <div style={{...s.card, flex:1}}>
                    <p style={s.label}>Investido</p>
                    <p style={s.bigNum}>{mask("$" + spotInvested.toFixed(2))}</p>
                  </div>
                  <div style={{...s.card, flex:1}}>
                    <p style={s.label}>Valor Atual</p>
                    <p style={s.bigNum}>{mask("$" + spotValue.toFixed(2))}</p>
                  </div>
                </div>
                <div style={s.row}>
                  <div style={{...s.card, flex:1}}>
                    <p style={s.label}>P&L Total</p>
                    <p style={{...s.bigNum, color: spotPnl>=0?"#22c55e":"#ef4444"}}>{mask((spotPnl>=0?"+":"") + "$" + spotPnl.toFixed(2))}<br/><span style={{fontSize:12}}>{spotPnlPct.toFixed(2)}%</span></p>
                  </div>
                  <div style={{...s.card, flex:1}}>
                    <p style={s.label}>24h</p>
                    <p style={{...s.bigNum, color: spotDailyPnl>=0?"#22c55e":"#ef4444"}}>{mask((spotDailyPnl>=0?"+":"") + "$" + spotDailyPnl.toFixed(2))}</p>
                  </div>
                </div>

                {spotBarData.length > 0 && (
                  <div style={s.card}>
                    <p style={s.cardTitle}>🪙 Distribuição Crypto</p>
                    <ResponsiveContainer width="100%" height={160}>
                      <BarChart data={spotBarData} margin={{top:4,right:4,left:-20,bottom:20}}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                        <XAxis dataKey="name" stroke="#f59e0b" fontSize={8} interval={0} angle={-35} textAnchor="end" />
                        <YAxis stroke="#f59e0b" fontSize={8} />
                        <Tooltip contentStyle={{backgroundColor:"#1a1a2e", border:"none", color:"#fff"}} />
                        <Bar dataKey="valor" fill="#f59e0b" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )}

                <div style={s.card}>
                  <p style={s.cardTitle}>🪙 Crypto Spot</p>
                  {spotPositions.length === 0 ? (
                    <p style={s.empty}>Adicione posições na aba ➕ (Crypto Spot)</p>
                  ) : spotPositions.map(p => (
                    <div key={p.id} style={{...s.posRow, cursor:"pointer"}} onClick={() => { if(selectedPosition===p.symbol){setSelectedPosition(null);setPositionEntries([])} else {setSelectedPosition(p.symbol);loadPositionEntries(p.symbol, p.asset_type)} }}>
                      <div style={{flex:1}}>
                        <div style={s.posSymbol}>{p.symbol} <span style={{fontSize:10, color:"#f59e0b"}}>spot</span> <span style={{fontSize:10, color:"#6366f1"}}>{selectedPosition===p.symbol?"▲":"▼"}</span></div>
                        <div style={s.posDetail}>{p.quantity} @ ${p.avg_price} • {p.purchase_date}</div>
                        <div style={s.posDetail}>Atual: ${p.currentPrice?.toFixed(2)} • ${p.value.toFixed(2)}</div>
                        <div style={{display:"flex", gap:6, marginTop:4}}>
                          <span style={{...s.badge, backgroundColor: p.pnl>=0?"#16a34a33":"#dc262633", color: p.pnl>=0?"#22c55e":"#ef4444"}}>{p.pnlPct.toFixed(2)}% | {p.pnl>=0?"+":"-"}${Math.abs(p.pnl).toFixed(2)}</span>
                          <span style={{...s.badge, backgroundColor: p.dailyChange>=0?"#16a34a33":"#dc262633", color: p.dailyChange>=0?"#22c55e":"#ef4444"}}>{p.isCrypto ? "24h" : marketStatus.status === "open" ? "Hoje" : "Últ. pregão"}: {p.dailyChange>=0?"+":""}{p.dailyChange.toFixed(2)}%</span>
                    {p.preMarketChange && p.preMarketChange !== 0 ? <span style={{...s.badge, backgroundColor:"rgba(251,191,36,0.15)", color:"#fbbf24"}}>PM: {p.preMarketChange>=0?"+":""}{p.preMarketChange.toFixed(2)}%</span> : p.postMarketChange && p.postMarketChange !== 0 ? <span style={{...s.badge, backgroundColor:"rgba(99,102,241,0.15)", color:"#a78bfa"}}>AH: {p.postMarketChange>=0?"+":""}{p.postMarketChange.toFixed(2)}%</span> : null}{p.currentPrice < p.avg_price ? <span style={{...s.badge, backgroundColor:"rgba(251,191,36,0.1)", color:"#fbbf24"}}>📉 +{((p.avg_price - p.currentPrice) / p.currentPrice * 100).toFixed(1)}% para empatar</span> : null}
                        </div>
                        {selectedPosition===p.symbol && (
                          <div style={{marginTop:8, borderTop:"1px solid rgba(255,165,0,0.2)", paddingTop:8}}>
                            {loadingEntries ? <p style={{color:"#888", fontSize:11}}>Carregando...</p> :
                            positionEntries.length === 0 ? <p style={{color:"#888", fontSize:11}}>Nenhum aporte registrado</p> :
                            positionEntries.map((e,i) => (
                              <div key={e.id} style={{display:"flex", justifyContent:"space-between", fontSize:11, color:"#94a3b8", marginBottom:4, fontFamily:"monospace"}}>
                                <span>📅 {e.purchase_date} — {e.quantity} @ ${parseFloat(e.price).toFixed(2)}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      {delArm === p.id && <p style={{color:"#fca5a5", fontSize:11, margin:"6px 0 0 0", lineHeight:1.4}}>{"Tocar de novo vende " + p.quantity + " cotas a $" + (p.currentPrice || p.avg_price || 0).toFixed(2) + " e apaga a posição."}</p>}
                      </div>
                      <button onClick={(ev) => {ev.stopPropagation(); openEditModal(p.symbol, p.asset_type)}} style={{...s.delBtn, backgroundColor:"#1f2937", color:"#6366f1", marginRight:4}}>✏️</button>
                <button onClick={(ev) => {ev.stopPropagation(); if (delArm === p.id) { setDelArm(null); deletePosition(p.id) } else { setDelArm(p.id); setTimeout(() => setDelArm(c => c === p.id ? null : c), 4000) }}} style={delArm === p.id ? {...s.delBtn, background:"#7f1d1d", borderRadius:6} : s.delBtn}>🗑️</button>
                    </div>
                  ))}
                </div>

                <div style={s.card}>
                  <p style={s.cardTitle}>🤖 Análise Claude</p>
                  {spotPositions.length === 0 && <p style={s.empty}>Adicione posições de cripto à vista acima para analisar</p>}
                  <button onClick={async () => {
                    if (spotPositions.length === 0) return
                    setAnalyzingSpot(true)
                    const summary = spotPositions.map(p => p.symbol+": "+p.quantity+" @ $"+p.avg_price+" DCA (comprado em "+(p.purchase_date||"data nao informada")+"), atual $"+p.currentPrice?.toFixed(2)+", P&L "+p.pnlPct.toFixed(2)+"%").join(", ")
                    try {
                      const res = await fetch(API_URL + "/claude", {
                        method:"POST",
                        headers:{"Content-Type":"application/json", ...hdrAuth()},
                        body: JSON.stringify({
                          model:CLAUDE_MODEL,
                          max_tokens:1000,
                          messages:[{role:"user", content:"Analise este portfolio de crypto spot em portugues. Direto, no maximo 200 palavras. Leia os numeros: preco medio, preco atual, P&L, quanto falta para voltar ao preco medio, concentracao. NAO cite regras de imposto. NAO prescreva operacoes (nada de vender X%, stop ou realizar lucro) — descreva a situacao e deixe a decisao com o usuario. Se um preco medio parecer implausivel para o ativo, diga. Termine com uma linha: esta aba mostra apenas preco e resultado; Sharpe, Monte Carlo, correlacao, contribuicao de risco e simulacao de aporte ficam na aba 💎 do ClawETF, que analisa ETFs de cripto e acoes na mesma carteira.\n\n"+summary}]
                        })
                      })
                      const data = await res.json()
                      setSpotAnalysis(data.content?.[0]?.text || "Erro na análise")
                    } catch(e) { setSpotAnalysis("Erro na análise") }
                    setAnalyzingSpot(false)
                  }} style={{...s.addBtn, marginBottom: spotAnalysis?12:0, opacity: spotPositions.length === 0 ? 0.5 : 1}} disabled={analyzingSpot || spotPositions.length === 0}>
                    {analyzingSpot ? "⏳ Analisando..." : "✨ Analisar com Claude (1 grátis/dia)"}
                  </button>
                  {spotAnalysis && <p style={{color:"#e5e7eb", fontSize:13, lineHeight:1.6, margin:0}}>{spotAnalysis}</p>}
                </div>
              </>
            )
          })()}
        </div>
      )}

      {tab === "mercado" && (
        <div>
          <div style={s.card}>
            <p style={s.cardTitle}>📺 Live TV</p>
            <p style={{color:"#9ca3af", fontSize:11, marginBottom:12}}>Toque para assistir ao vivo com som no YouTube</p>
            <div style={{display:"flex", gap:8}}>
              {[
                {name:"Bloomberg",url:"https://www.youtube.com/channel/UCIALMKvObZNtJ6AmdCLP7Lg/live",color:"#f59e0b"},
                {name:"Yahoo Finance",url:"https://www.youtube.com/channel/UCEAZeUIeJs0IjQiqTCdVSIg/live",color:"#7c3aed"},
                {name:"Euronews",url:"https://www.youtube.com/@euronews/live",color:"#ef4444"}
              ].map(c => (
                <a key={c.name} href={c.url} target="_blank" rel="noopener noreferrer"
                  style={{flex:1, textDecoration:"none", backgroundColor:"#1f2937", border:"1px solid "+c.color+"44",
                    borderRadius:8, padding:"12px 6px", display:"flex", flexDirection:"column", alignItems:"center", gap:4}}>
                  <span style={{color:"#ef4444", fontSize:10, fontWeight:"bold", letterSpacing:1}}>🔴 AO VIVO</span>
                  <span style={{color:"#fff", fontSize:12, fontWeight:"bold"}}>{c.name}</span>
                  <span style={{color:c.color, fontSize:11}}>▶ Assistir</span>
                </a>
              ))}
            </div>
          </div>
          <div style={s.card}>
            <p style={s.cardTitle}>🌐 Mercado ao Vivo</p>
            {[...ETF_LIST, ...positions.map(p=>p.symbol).filter(s=>!ETF_LIST.includes(s))].map(ticker => {
              const p = prices[ticker]
              if (!p) return null
              return (
                <button key={ticker} onClick={() => { setMarketChartTicker(ticker); setMarketChartName(ticker); setMarketChartPeriod("1mo") }}
                  style={{...s.marketRow, width:"100%", background:"transparent", border:"none", borderBottom:"1px solid rgba(255,255,255,0.04)", cursor:"pointer", textAlign:"left"}}>
                  <span style={s.marketTicker}>{ticker}</span>
                  <span style={s.marketPrice}>${p.price}</span>
                  <span style={{...s.badge, backgroundColor: p.change_pct>=0?"#16a34a33":"#dc262633", color: p.change_pct>=0?"#22c55e":"#ef4444"}}>
                    {p.change_pct>=0?"+":""}{Number(p.change_pct).toFixed(2)}%
                  </span>
                </button>
              )
            })}
          </div>
          {marketChartTicker && (
            <div style={s.card}>
              <p style={s.cardTitle}>📈 {marketChartName}</p>
              <div style={{display:"flex", gap:4, flexWrap:"wrap", marginBottom:12}}>
                {INDEX_PERIODS.map(p => (
                  <button key={p.value} onClick={() => setMarketChartPeriod(p.value)}
                    style={{padding:"5px 10px", backgroundColor: marketChartPeriod===p.value?"#6366f1":"#1f2937", border:"none", color: marketChartPeriod===p.value?"#fff":"#9ca3af", borderRadius:6, cursor:"pointer", fontSize:11}}>
                    {p.label}
                  </button>
                ))}
              </div>
              {loadingMarketChart ? <p style={{color:"#888", textAlign:"center"}}>Carregando...</p> : !marketChartData?.length ? <p style={{color:"#888", textAlign:"center"}}>Sem dados</p> : (() => {
                const first = marketChartData[0]?.v || 0
                const last = marketChartData[marketChartData.length-1]?.v || 0
                const chg = first !== 0 ? ((last - first) / first * 100) : 0
                const chgColor = chg >= 0 ? "#22c55e" : "#ef4444"
                return (
                  <div>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}>
                      <span style={{fontSize:20, fontWeight:"bold", color:"#fff"}}>${last.toFixed(2)}</span>
                      <span style={{fontSize:14, fontWeight:"bold", color:chgColor}}>{chg>=0?"+":""}{chg.toFixed(2)}%</span>
                    </div>
                    <ChartLine data={marketChartData} color={chgColor} formatter={(v) => ["$"+v.toFixed(2)]} />
                  </div>
                )
              })()}
            </div>
          )}
          {newsCarteira.length > 0 && (
            <div style={s.card}>
              <p style={s.cardTitle}>📌 Seus ativos</p>
              {newsCarteira.map((a, i) => (
                <a key={i} href={a.url} target="_blank" rel="noreferrer" style={{display:"block", padding:"10px 0", borderBottom:"1px solid rgba(255,255,255,0.04)", textDecoration:"none"}}>
                  <p style={{color:"#e2e8f0", fontSize:12, margin:0, lineHeight:1.4}}>{a.title}</p>
                  <p style={{color:"#6b7280", fontSize:10, margin:"3px 0 0 0"}}>{a.source}</p>
                </a>
              ))}
            </div>
          )}
          {(
            <div style={s.card}>
              <p style={s.cardTitle}>🏛️ Macro — alimenta o pilar da ⚡</p>
              {newsMacro.length === 0 && <p style={{color:"#6b7280", fontSize:11, margin:0}}>Sem notícias macro agora.</p>}
              {newsMacro.map((a, i) => (
                <a key={i} href={a.url} target="_blank" rel="noreferrer" style={{display:"block", padding:"10px 0", borderBottom:"1px solid rgba(255,255,255,0.04)", textDecoration:"none"}}>
                  <p style={{color:"#e2e8f0", fontSize:12, margin:0, lineHeight:1.4}}>{a.title}</p>
                  <p style={{color:"#6b7280", fontSize:10, margin:"3px 0 0 0"}}>{a.source}</p>
                </a>
              ))}
            </div>
          )}
          <div style={s.card}>
            <p style={s.cardTitle}>📰 Notícias</p>
            {loadingNews && <p style={{color:"#888", textAlign:"center", fontSize:13}}>Carregando...</p>}
            {!loadingNews && news.length === 0 && <p style={{color:"#475569", textAlign:"center", fontSize:13, fontStyle:"italic"}}>Nenhuma notícia disponível.</p>}
            {news.map((article, i) => (
              <div key={i} style={{padding:"10px 0", borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                <a href={article.url || article.link} target="_blank" rel="noopener noreferrer"
                  style={{color:"#a5b4fc", fontSize:13, fontWeight:"bold", textDecoration:"none", display:"block", marginBottom:4, lineHeight:1.4}}>
                  {article.title}
                </a>
                <div style={{display:"flex", gap:10, flexWrap:"wrap"}}>
                  {(article.source || article.source_name) && (
                    <span style={{color:"#6b7280", fontSize:11}}>{article.source || article.source_name}</span>
                  )}
                  {(article.published_at || article.publishedAt || article.date) && (
                    <span style={{color:"#475569", fontSize:11}}>
                      {new Date(article.published_at || article.publishedAt || article.date).toLocaleDateString()}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === "vs" && (
        <div>
          <div style={{...s.card, background:"linear-gradient(135deg, #0f172a, #1e1b4b)", textAlign:"center", padding:20}}>
            <p style={{color:"#a5b4fc", fontSize:11, textTransform:"uppercase", letterSpacing:2, margin:"0 0 4px 0"}}>Comparativo</p>
            <h2 style={{color:"#fff", fontSize:20, fontWeight:"bold", margin:"0 0 4px 0"}}>ClawETF vs Bloomberg</h2>
            <p style={{color:"#6366f1", fontSize:12, margin:0, fontStyle:"italic"}}>"As métricas de risco que importam, por 1% do preço"</p>
          </div>

          <div style={s.card}>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%", borderCollapse:"collapse", fontSize:12}}>
                <thead>
                  <tr>
                    <th style={{padding:"8px 6px", color:"#6b7280", textAlign:"left", fontSize:11}}>Recurso</th>
                    <th style={{padding:"8px 6px", color:"#ef4444", textAlign:"center", fontSize:11}}>Bloomberg</th>
                    <th style={{padding:"8px 6px", color:"#22c55e", textAlign:"center", fontSize:11}}>ClawETF</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["💰 Preço mensal", "$2.500", "$19,99"],
                    ["📊 Sharpe Ratio", "✅", "✅"],
                    ["⚠️ VaR 95% e 99%", "✅", "✅"],
                    ["🎲 Monte Carlo", "✅", "✅"],
                    ["📉 Max Drawdown", "✅", "✅"],
                    ["📈 Beta vs S&P500", "✅", "✅"],
                    ["💬 WhatsApp/Telegram", "❌", "✅"],
                    ["🇧🇷 Português BR", "❌", "✅"],
                    ["🎯 ETFs Cripto e Ações US", "✅", "✅"],
                    ["🧠 Análise em linguagem simples", "❌", "✅"],
                  ].map(([feature, bloomberg, claw], i) => (
                    <tr key={i} style={{borderBottom:"1px solid #1f2937"}}>
                      <td style={{padding:"10px 6px", color:"#e2e8f0", fontSize:12}}>{feature}</td>
                      <td style={{padding:"10px 6px", textAlign:"center", color: bloomberg==="✅"?"#22c55e":bloomberg==="❌"?"#ef4444":"#f59e0b", fontWeight:"bold"}}>{bloomberg}</td>
                      <td style={{padding:"10px 6px", textAlign:"center", color: claw==="✅"?"#22c55e":claw==="❌"?"#ef4444":"#f59e0b", fontWeight:"bold"}}>{claw}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div style={{...s.card, background:"linear-gradient(135deg, #0f172a, #1a0a2e)", textAlign:"center"}}>
            <p style={{color:"#c084fc", fontSize:13, fontWeight:"bold", margin:"0 0 8px 0"}}>Bloomberg cobra $30.000/ano</p>
            <p style={{color:"#e2e8f0", fontSize:24, fontWeight:"bold", margin:"0 0 4px 0"}}>ClawETF: $239,88/ano</p>
            <p style={{color:"#6b7280", fontSize:11, margin:"0 0 16px 0"}}>As mesmas métricas de risco, a preço de varejo</p>
            <button onClick={() => setTab("premium2")} style={{...s.addBtn, background:"linear-gradient(135deg, #7c3aed, #0891b2)"}}>
              {isPremium2 ? "💎 Abrir a aba Premium 2" : "🚀 Assinar Premium Agora"}
            </button>
          </div>
        </div>
      )}

      {tab === "indices" && (
        <div>
          <div style={s.card}>
            <p style={s.cardTitle}>🏛️ Índices Mundiais</p>
            {INDEX_SIMPLE_KEYS.map(key => {
              const apiKey = INDEX_SIMPLE_API_KEYS[key]
              const data = (indices && indices[apiKey]) ? indices[apiKey] : {}
              return (
                <button
                  key={key}
                  onClick={() => { setIndexChartTicker(INDEX_SIMPLE_TICKERS[key]); setIndexChartName(INDEX_SIMPLE_NAMES[key]); setIndexChartCurrency(INDEX_SIMPLE_CURRENCIES[key]) }}
                  style={{...s.marketRow, width:"100%", background:"transparent", border:"none", borderBottom:"1px solid rgba(255,255,255,0.04)", cursor:"pointer", textAlign:"left"}}
                >
                  <span style={s.marketTicker}>{INDEX_SIMPLE_NAMES[key]}</span>
                  <span style={s.marketPrice}>{data.price?.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) ?? "--"}</span>
                  <span style={{...s.badge, backgroundColor: (data.change_pct ?? 0)>=0?"#16a34a33":"#dc262633", color: (data.change_pct ?? 0)>=0?"#22c55e":"#ef4444"}}>
                    {data.change_pct === undefined ? "--" : `${data.change_pct>=0?"+":""}${Number(data.change_pct).toFixed(2)}%`}
                  </span>
                </button>
              )
            })}
          </div>
          <div style={{...s.card, marginTop:12}}>
            <p style={s.cardTitle}>🔮 Futuros EUA</p>
            <p style={{color:"#9ca3af", fontSize:11, marginBottom:8}}>Contratos futuros — sentimento pré-mercado</p>
            {FUTURES_KEYS.map(key => {
              const apiKey = FUTURES_API_KEYS[key]
              const data = (indices && indices[apiKey]) ? indices[apiKey] : {}
              return (
                <button
                  key={key}
                  onClick={() => { setIndexChartTicker(FUTURES_TICKERS[key]); setIndexChartName(FUTURES_NAMES[key]); setIndexChartCurrency(FUTURES_CURRENCIES[key]) }}
                  style={{...s.marketRow, width:"100%", background:"transparent", border:"none", borderBottom:"1px solid rgba(255,255,255,0.04)", cursor:"pointer", textAlign:"left"}}
                >
                  <span style={s.marketTicker}>{FUTURES_NAMES[key]}</span>
                  <span style={s.marketPrice}>{data.price?.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) ?? "--"}</span>
                  <span style={{...s.badge, backgroundColor: (data.change_pct ?? 0)>=0?"#16a34a33":"#dc262633", color: (data.change_pct ?? 0)>=0?"#22c55e":"#ef4444"}}>
                    {data.change_pct === undefined ? "--" : `${data.change_pct>=0?"+":""}${Number(data.change_pct).toFixed(2)}%`}
                  </span>
                </button>
              )
            })}
          </div>
          {indexChartTicker && (
            <div style={s.card}>
              <p style={s.cardTitle}>📈 {indexChartName} ({indexChartTicker})</p>
              <div style={{display:"flex", gap:4, flexWrap:"wrap", marginBottom:12}}>
                {INDEX_PERIODS.map(p => (
                  <button key={p.value} onClick={() => setIndexChartPeriod(p.value)}
                    style={{padding:"5px 10px", backgroundColor: indexChartPeriod===p.value?"#6366f1":"#1f2937", border:"none", color: indexChartPeriod===p.value?"#fff":"#9ca3af", borderRadius:6, cursor:"pointer", fontSize:11}}>
                    {p.label}
                  </button>
                ))}
              </div>
              {loadingIndexChart ? <p style={{color:"#888", textAlign:"center"}}>Carregando...</p> : (() => {
                const first = indexChartData[0]?.v || 0
                const last = indexChartData[indexChartData.length-1]?.v || 0
                const chg = first !== 0 ? ((last - first) / first * 100) : 0
                const chgColor = chg >= 0 ? "#22c55e" : "#ef4444"
                return (
                  <div>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}>
                      <span style={{fontSize:20, fontWeight:"bold", color:"#fff"}}>{indexChartCurrency}{last.toFixed(2)}</span>
                      <span style={{fontSize:14, fontWeight:"bold", color:chgColor}}>{chg>=0?"+":""}{indexChartCurrency}{Math.abs(last-first).toFixed(2)} ({chg>=0?"+":""}{chg.toFixed(2)}%)</span>
                    </div>
                    <ChartLine data={indexChartData} color={chgColor} formatter={(v) => [indexChartCurrency + v.toFixed(2)]} />
                  </div>
                )
              })()}
            </div>
          )}
        </div>
      )}


      {tab === "crypto" && (
        <div>
          {fgData && (
            <div style={s.card}>
              <p style={s.cardTitle}>😰 Medo e Ganância — mercado cripto</p>
              {(() => {
                const _v = Math.max(0, Math.min(100, fgData.valor || 0))
                const _pt = (x, r) => { const a = (180 - x * 1.8) * Math.PI / 180; return [100 + r * Math.cos(a), 100 - r * Math.sin(a)] }
                const _arco = (a, b, cor) => { const p1 = _pt(a, 80); const p2 = _pt(b, 80); return <path key={a} d={"M " + p1[0].toFixed(1) + " " + p1[1].toFixed(1) + " A 80 80 0 0 1 " + p2[0].toFixed(1) + " " + p2[1].toFixed(1)} fill="none" stroke={cor} strokeWidth="14" /> }
                const _ag = _pt(_v, 60)
                const _faixa = _v <= 24 ? "Medo extremo" : _v <= 44 ? "Medo" : _v <= 55 ? "Neutro" : _v <= 75 ? "Ganância" : "Ganância extrema"
                const _cor = _v <= 24 ? "#ef4444" : _v <= 44 ? "#f97316" : _v <= 55 ? "#eab308" : _v <= 75 ? "#84cc16" : "#22c55e"
                const _d = (fgData.valor_ontem === null || fgData.valor_ontem === undefined) ? null : _v - fgData.valor_ontem
                return (
                  <div style={{textAlign:"center"}}>
                    <svg viewBox="0 0 200 112" style={{width:"100%", maxWidth:250}}>
                      {_arco(0, 25, "#ef4444")}{_arco(25, 45, "#f97316")}{_arco(45, 55, "#eab308")}{_arco(55, 75, "#84cc16")}{_arco(75, 100, "#22c55e")}
                      <line x1="100" y1="100" x2={_ag[0].toFixed(1)} y2={_ag[1].toFixed(1)} stroke="#e5e7eb" strokeWidth="3" strokeLinecap="round" />
                      <circle cx="100" cy="100" r="5" fill="#e5e7eb" />
                    </svg>
                    <p style={{color:_cor, fontSize:30, fontWeight:"bold", margin:0, lineHeight:1}}>{_v}</p>
                    <p style={{color:_cor, fontSize:13, margin:"3px 0 0 0"}}>{_faixa}</p>
                    {_d !== null && <p style={{color:"#6b7280", fontSize:11, margin:"6px 0 0 0"}}>{"Ontem " + fgData.valor_ontem + " · " + (_d >= 0 ? "+" : "") + _d}</p>}
                    <p style={{color:"#4b5563", fontSize:10, lineHeight:1.5, margin:"12px 0 0 0", textAlign:"left"}}>
                      Mede o humor do mercado cripto, de 0 a 100, a partir de volatilidade, volume, redes sociais e domínio do bitcoin. Não é o índice da CNN, que é de ações. É termômetro, não previsão: não entra em score nenhum e não é um dos quesitos medidos pelo app. Fonte: alternative.me.
                    </p>
                  </div>
                )
              })()}
            </div>
          )}
          <div style={s.card}>
            <p style={s.cardTitle}>₿ Top Cryptos — Mercado Spot</p>
            <p style={{color:"#9ca3af", fontSize:11, marginBottom:12}}>Preços via CoinGecko. Atualizado a cada 5 min.</p>
            {loadingCrypto ? (
              <p style={{color:"#888", textAlign:"center"}}>Carregando...</p>
            ) : Object.keys(cryptoPrices).length === 0 ? (
              <p style={{color:"#888", textAlign:"center"}}>Nenhum dado disponível</p>
            ) : (
              <>{(() => {
                const STABLECOINS = new Set(['USDT','USDC','BUSD','DAI','TUSD','USDS','USDE','USDB','FDUSD','USD1','PYUSD','FRAX','LUSD','CUSD','GUSD','SUSD','USDP','USDD','CRVUSD','MKUSD'])
                const BLOCKED = new Set(['FIGR_HELOC','RAIN','LEO','WBT','CC','LAB','M','GRAM','WBTC','WETH','WEETH','CBBTC','BBTC','TBTC','RETH','STETH','WSTETH','CBETH','EZETH','RSETH','SUSDE','SBTC','LBTC','FBTC2','OKB','CRO','HT','GT','MX','KCS','BGB','BMX','NOT','DOGS','CATI','HMSTR','USYC','USDG','BUIDL','USDY','XAUT','PAXG','USTB','EUTBL','JTRSY','JAAA','HTX','RLUSD','USDF','BFUSD','GHO','EURSAFO','YLDS','USD0','USDTB','STABLE','SKY','ADI','NIGHT','ASTER','NEXO','VVV','JST','BDX','XDC','FLR','PUMP','U','BCAP','DEXE','币安人生','BINANCELIFE'])
                return Object.entries(cryptoPrices)
                  .filter(([sym]) => !STABLECOINS.has(sym) && !BLOCKED.has(sym))
                  .filter(([sym, d]) => d && d.price !== undefined)
                  .sort((a,b) => (a[1].rank||99) - (b[1].rank||99))
                  .map(([symbol, data], idx) => (
                  <button key={symbol} onClick={() => { setCryptoChartTicker(symbol+"-USD"); setCryptoChartName(symbol); setCryptoChartPeriod("1mo") }}
                    style={{...s.marketRow, width:"100%", background:"transparent", border:"none", borderBottom:"1px solid rgba(255,255,255,0.04)", cursor:"pointer", textAlign:"left"}}>
                    <div style={{display:"flex", alignItems:"center", gap:8, flex:1}}>
                      <span style={{fontSize:11, color:"#6366f1", fontWeight:"bold", minWidth:24}}>#{idx+1}</span>
                      <div>
                        <span style={{...s.marketTicker, display:"block"}}>{symbol}</span>
                        <span style={{fontSize:10, color:"#9ca3af"}}>{data.name}</span>
                      </div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <span style={{...s.marketPrice, display:"block"}}>
                        ${data.price >= 1 ? data.price.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2}) : data.price.toFixed(6)}
                      </span>
                      <span style={{...s.badge, backgroundColor: data.change_24h >= 0 ? "#16a34a33" : "#dc262633", color: data.change_24h >= 0 ? "#22c55e" : "#ef4444"}}>
                        {data.change_24h >= 0 ? "+" : ""}{Number(data.change_24h).toFixed(2)}%
                      </span>
                    </div>
                  </button>
                ))
            })()}</>
            )}
            <button
              onClick={() => { setCryptoPrices({}); setLoadingCrypto(true); fetch('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false&price_change_percentage=24h&x_cg_demo_api_key=' + CG_KEY).then(r=>r.json()).then(d=>{ const result={}; d.forEach(c=>{const sym=c.symbol.toUpperCase(); result[sym]={price:c.current_price,change_24h:c.price_change_percentage_24h,name:c.name,rank:c.market_cap_rank}}); setCryptoPrices(result); setLoadingCrypto(false)}).catch(()=>setLoadingCrypto(false)) }}
              style={{...s.btn, marginTop:8, width:"100%"}}
            >
              🔄 Atualizar
            </button>
          {cryptoChartTicker && (
            <div style={s.card}>
              <p style={s.cardTitle}>📈 {cryptoChartName}</p>
              <div style={{display:"flex", gap:4, flexWrap:"wrap", marginBottom:12}}>
                {INDEX_PERIODS.map(p => (
                  <button key={p.value} onClick={() => setCryptoChartPeriod(p.value)}
                    style={{padding:"5px 10px", backgroundColor: cryptoChartPeriod===p.value?"#6366f1":"#1f2937", border:"none", color: cryptoChartPeriod===p.value?"#fff":"#9ca3af", borderRadius:6, cursor:"pointer", fontSize:11}}>
                    {p.label}
                  </button>
                ))}
              </div>
              {loadingCryptoChart ? <p style={{color:"#888", textAlign:"center"}}>Carregando...</p> : !cryptoChartData?.length ? <p style={{color:"#888", textAlign:"center"}}>Sem dados</p> : (() => {
                const first = cryptoChartData[0]?.v || 0
                const last = cryptoChartData[cryptoChartData.length-1]?.v || 0
                const chg = first !== 0 ? ((last - first) / first * 100) : 0
                const chgColor = chg >= 0 ? "#22c55e" : "#ef4444"
                return (
                  <div>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}>
                      <span style={{fontSize:20, fontWeight:"bold", color:"#fff"}}>${last.toFixed(2)}</span>
                      <span style={{fontSize:14, fontWeight:"bold", color:chgColor}}>{chg>=0?"+":""}{chg.toFixed(2)}%</span>
                    </div>
                    <ChartLine data={cryptoChartData} color={chgColor} formatter={(v) => ["$"+v.toFixed(2)]} />
                  </div>
                )
              })()}
            </div>
          )}
          {["bitcoin", "ethereum"].map(a => {
            const ins = insights[a]
            if (!ins) return null
            // A hora vem em dois formatos conforme a fonte: pego so HH:MM de
            // qualquer um dos dois e, nao dando, nao mostro hora nenhuma.
            const hhmm = (v) => {
              const m = String(v || "").match(/(\d{1,2}):(\d{2})/)
              return m ? (("0" + m[1]).slice(-2) + "h" + m[2]) : ""
            }
            return (
              <div key={a} style={s.card}>
                <p style={s.cardTitle}>💠 Insights · {a === "bitcoin" ? "Bitcoin" : "Ethereum"}</p>
                {ins.estado !== "ok" ? (
                  <p style={{color:"#6b7280", fontSize:12, margin:0}}>sem manchete nova nas últimas horas</p>
                ) : (
                  <div>
                    <p style={{color:"#9ca3af", fontSize:11, margin:"0 0 10px 0"}}>{ins.manchetes} manchetes lidas</p>
                    <p style={{color:"#e5e7eb", fontSize:13, lineHeight:1.5, margin:"0 0 14px 0"}}>{ins.tldr}</p>
                    <p style={{color:"#6b7280", fontSize:10, letterSpacing:1, margin:"0 0 8px 0"}}>O QUE ESTÁ PESANDO</p>
                    {(ins.fatores || []).map((f, i) => (
                      <div key={i} style={{marginBottom:10}}>
                        <p style={{fontSize:11, fontWeight:700, margin:"0 0 2px 0", color: f.direcao === "alta" ? "#22c55e" : "#ef4444"}}>{f.direcao === "alta" ? "▲" : "▼"} {f.direcao} · {f.peso}</p>
                        <p style={{color:"#d1d5db", fontSize:12, lineHeight:1.45, margin:0}}>{f.texto}</p>
                        <p style={{color:"#4b5563", fontSize:10, margin:"2px 0 0 0"}}>{f.fonte}{hhmm(f.hora) ? " · " + hhmm(f.hora) : ""}</p>
                      </div>
                    ))}
                    {(ins.riscos || []).length > 0 && (
                      <div>
                        <p style={{color:"#6b7280", fontSize:10, letterSpacing:1, margin:"12px 0 6px 0"}}>RISCO</p>
                        {ins.riscos.map((r, i) => (
                          <p key={i} style={{color:"#d1d5db", fontSize:12, lineHeight:1.45, margin:"0 0 4px 0"}}>• {r}</p>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <p style={{color:"#4b5563", fontSize:10, lineHeight:1.5, margin:"12px 0 0 0", borderTop:"1px solid #1f2937", paddingTop:8}}>Nada aqui vem de medição do ClawETF. É leitura de notícia, não é sinal.</p>
              </div>
            )
          })}
          </div>
        </div>
      )}

      {tab === "premium" && <TabPremium
        InfoTip={InfoTip}
        applyPromoCode={applyPromoCode}
        etfEnriched={etfEnriched}
        fetchTechnical={fetchTechnical}
        handleSubscribe={handleSubscribe}
        isPremium={isPremium}
        loadingTech={loadingTech}
        manageSubscription={manageSubscription}
        promoCode={promoCode}
        promoError={promoError}
        s={s}
        setPromoCode={setPromoCode}
        setTechTicker={setTechTicker}
        setTechnical={setTechnical}
        setTxtTech={setTxtTech}
        techTicker={techTicker}
        technical={technical}
        txtTech={txtTech}
      />}

      {tab === "premium" && isPremium && (
            <>
              <div style={s.card}>
                <p style={s.cardTitle}>🧭 Resumo técnico por tempo gráfico{mtData && mtData.ticker ? " — " + mtData.ticker : ""}</p>
                <p style={{color:"#9ca3af", fontSize:12, marginBottom:10, lineHeight:1.5}}>
                  Doze indicadores e doze médias móveis em cinco prazos, dos quais onze indicadores votam: o ATR não vota, porque só diz se a amplitude das barras subiu ou caiu. Quando falta barra para calcular algo, ele aparece como sem dados e sai da contagem — sem dados não é neutro. O Confluence acima lê quatro sinais de tendência no diário; este bloco conta vinte e três votos em cinco prazos. Os dois podem discordar sem que nenhum esteja errado.
                </p>
                <button disabled={mtLoading || !techTicker} onClick={async () => {
                  setMtLoading(true); setMtData(null)
                  try {
                    const res = await fetch(API_URL + "/technical-multi/" + techTicker, { headers: hdrAuth() })
                    const d = await res.json()
                    setMtData(d); setMtPrazo("diario")
                    registrarMultiTf(techTicker, d)
                  } catch(e) { setMtData({error:"falhou"}) }
                  setMtLoading(false)
                }} style={{padding:"9px 16px", borderRadius:8, border:"none", backgroundColor:"#a855f7", color:"#fff", fontSize:13, width:"100%", marginBottom:10}}>
                  {mtLoading ? "⏳ Calculando os cinco prazos..." : "🧭 Calcular os cinco prazos de " + (techTicker || "...")}
                </button>
                
                {mtLoading && <p style={{color:"#6b7280", fontSize:12}}>Calculando os cinco prazos...</p>}
                {mtData && mtData.error && <p style={{color:"#ef4444", fontSize:12}}>Não foi possível calcular agora.</p>}
                {mtData && mtData.prazos && (() => {
                  const nomes = {"30min":"30 min", "1h":"1 hora", "diario":"Dia", "semanal":"Semana", "mensal":"Mês"}
                  const cor = v => v === "compra forte" ? "#22c55e" : v === "compra" ? "#86efac" : v === "venda forte" ? "#ef4444" : v === "venda" ? "#fca5a5" : v === "neutro" ? "#f59e0b" : "#6b7280"
                  const seta = v => v && v.indexOf("compra") === 0 ? "↗" : v && v.indexOf("venda") === 0 ? "↘" : "➔"
                  const dec = {"ATR(14)":4, "CCI(14)":4, "Highs/Lows(14)":4, "BullBear(13)":4}
                  const fmt = it => (it.valor === null || it.valor === undefined) ? "sem dados" : it.valor.toFixed(dec[it.codigo] || 3)
                  // o ADX mostra a forca da tendencia, mas quem vota e a direcao: DI+ contra DI-.
                  const fmtDI = it => (it.di_mais == null || it.di_menos == null) ? "" : " · DI+ " + it.di_mais.toFixed(1) + " · DI− " + it.di_menos.toFixed(1)
                  const corAcao = a => a === "compra" ? "#22c55e" : a === "venda" ? "#ef4444" : a === "neutro" ? "#f59e0b" : "#6b7280"
                  const rotAcao = a => a === "compra" ? "Compra" : a === "venda" ? "Venda" : a === "neutro" ? "Neutro" : "sem dados"
                  const pz = mtData.prazos[mtPrazo]
                  return (
                    <div>
                      <div style={{display:"flex", gap:4, overflowX:"auto", marginBottom:12, paddingBottom:4}}>
                        {Object.keys(nomes).map(k => {
                          const pr = mtData.prazos[k]
                          const v = (pr && pr.resumo) ? pr.resumo.geral.veredito : null
                          return (
                            <button key={k} onClick={() => setMtPrazo(k)} style={{flexShrink:0, padding:"6px 10px", borderRadius:8, border: mtPrazo === k ? "1px solid " + cor(v) : "1px solid #374151", background: mtPrazo === k ? "rgba(168,85,247,0.12)" : "transparent", color:"#e5e7eb", fontSize:11, textAlign:"left"}}>
                              <div style={{fontWeight:700}}>{nomes[k]}</div>
                              <div style={{color:cor(v), fontSize:10}}>{v ? v + " " + seta(v) : "sem dados"}</div>
                            </button>
                          )
                        })}
                      </div>
                      {(!pz || pz.erro) ? (
                        <p style={{color:"#6b7280", fontSize:12}}>{(pz && pz.erro) ? "Este prazo tem " + (pz.barras || 0) + " barras, pouco para calcular." : "sem dados"}</p>
                      ) : (
                        <div>
                          <p style={{color:"#6b7280", fontSize:10, marginBottom:8}}>{pz.barras} barras · última {pz.ultima_barra} · fechamento ${pz.fechamento}</p>
                          {["indicadores", "medias", "geral"].map(b => {
                            const r = pz.resumo[b]
                            const rot = b === "indicadores" ? "Indicadores" : b === "medias" ? "Médias móveis" : "Resumo geral"
                            return (
                              <div key={b} style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"1px solid #1f2937"}}>
                                <span style={{color:"#9ca3af", fontSize:12}}>{rot}</span>
                                <span style={{textAlign:"right"}}>
                                  <span style={{color:cor(r.veredito), fontWeight:700, fontSize:12}}>{r.veredito} {seta(r.veredito)}</span>
                                  <span style={{color:"#4b5563", fontSize:10, marginLeft:6}}>{r.compra}C · {r.venda}V · {r.neutro}N · {r.votos}/{r.casas}</span>
                                </span>
                              </div>
                            )
                          })}
                          <p style={{color:"#a855f7", fontSize:11, fontWeight:700, margin:"12px 0 4px"}}>Indicadores</p>
                          {pz.indicadores.map(it => (
                            <div key={it.codigo} style={{display:"flex", justifyContent:"space-between", padding:"3px 0", fontSize:12}}>
                              <span style={{color:"#9ca3af"}}>{it.codigo}</span>
                              <span>
                                <span style={{color:"#e5e7eb"}}>{fmt(it)}{fmtDI(it)}</span>
                                <span style={{color: it.vota === false ? "#6b7280" : corAcao(it.acao), marginLeft:8, fontSize:11}}>{it.vota === false ? (it.nota || "") : rotAcao(it.acao)}</span>
                              </span>
                            </div>
                          ))}
                          <p style={{color:"#a855f7", fontSize:11, fontWeight:700, margin:"12px 0 4px"}}>Médias móveis</p>
                          {pz.medias.map(m => (
                            <div key={m.periodo} style={{display:"flex", justifyContent:"space-between", padding:"3px 0", fontSize:12}}>
                              <span style={{color:"#9ca3af"}}>MA{m.periodo}</span>
                              <span style={{textAlign:"right"}}>
                                <span style={{color:"#e5e7eb"}}>{m.sma === null ? "sem dados" : m.sma}</span>
                                <span style={{color:corAcao(m.acao_sma), fontSize:10, marginLeft:4}}>{m.acao_sma ? rotAcao(m.acao_sma) : ""}</span>
                                {m.ema !== null && <span style={{color:"#4b5563", margin:"0 5px"}}>|</span>}
                                {m.ema !== null && <span style={{color:"#e5e7eb"}}>{m.ema}</span>}
                                {m.acao_ema && <span style={{color:corAcao(m.acao_ema), fontSize:10, marginLeft:4}}>{rotAcao(m.acao_ema)}</span>}
                              </span>
                            </div>
                          ))}
                          {pz.pivos && (
                            <div>
                              <p style={{color:"#a855f7", fontSize:11, fontWeight:700, margin:"12px 0 4px"}}>Pontos de pivô</p>
                              <div style={{display:"flex", fontSize:10, color:"#6b7280", paddingBottom:4, borderBottom:"1px solid #1f2937"}}>
                                <span style={{flex:1}}>Nível</span>
                                <span style={{flex:1, textAlign:"right"}}>Clássico</span>
                                <span style={{flex:1, textAlign:"right"}}>Fibonacci</span>
                              </div>
                              {["r3", "r2", "r1", "pp", "s1", "s2", "s3"].map(k => (
                                <div key={k} style={{display:"flex", fontSize:12, padding:"3px 0"}}>
                                  <span style={{flex:1, color: k === "pp" ? "#a855f7" : "#9ca3af", fontWeight: k === "pp" ? 700 : 400}}>{k === "pp" ? "Pivô" : k.toUpperCase()}</span>
                                  <span style={{flex:1, textAlign:"right", color:"#e5e7eb"}}>{pz.pivos.classico[k]}</span>
                                  <span style={{flex:1, textAlign:"right", color:"#e5e7eb"}}>{pz.pivos.fibonacci[k]}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )
                })()}
              </div>
              <div style={s.card}>
                <p style={s.cardTitle}>🔎 Integridade da base{intData && intData.ticker ? " — " + intData.ticker : ""}</p>
                <p style={{color:"#9ca3af", fontSize:12, marginBottom:10, lineHeight:1.5}}>
                  Compara os preços negociados em duas fontes independentes — os pregões diários numa, as barras de 30 minutos na outra. Confere fechamento, volume e, no diário, o calendário. As duas séries são lidas sem ajuste de dividendo, para a comparação medir o que foi negociado e não o ajuste que cada provedor aplica. Não entra em score nenhum: responde, antes de qualquer conta, se o número pode ser confiado.
                </p>
                <button disabled={intLoading || !techTicker} onClick={async () => {
                  setIntLoading(true); setIntData(null)
                  try {
                    const res = await fetch(API_URL + "/integridade/" + techTicker, { headers: hdrAuth() })
                    setIntData(await res.json())
                  } catch(e) { setIntData({erro: "a conferência não respondeu"}) }
                  setIntLoading(false)
                }} style={{padding:"9px 16px", borderRadius:8, border:"none", backgroundColor:"#0ea5e9", color:"#fff", fontSize:13, width:"100%", marginBottom:10}}>
                  {intLoading ? "⏳ Conferindo cem pregões..." : "🔎 Conferir a base de " + (techTicker || "...")}
                </button>
                {intData && intData.erro && (
                  <p style={{color:"#f59e0b", fontSize:12, lineHeight:1.5}}>{intData.erro}{intData.detalhe ? " — " + intData.detalhe : ""}</p>
                )}
                {intData && !intData.erro && (() => {
                  const ok = intData.status === "ok"
                  const faltas = [...(intData.so_no_app || []), ...(intData.so_na_outra || [])]
                  const lin = (rot, val, obs) => (
                    <div style={{display:"flex", justifyContent:"space-between", padding:"5px 0", borderTop:"1px solid #1f2937", fontSize:12}}>
                      <span style={{color:"#9ca3af"}}>{rot}</span>
                      <span style={{color:"#e5e7eb", textAlign:"right"}}>{val}{obs ? <span style={{color:"#4b5563", fontSize:10}}> · {obs}</span> : null}</span>
                    </div>
                  )
                  return (
                    <div>
                      <div style={{color: ok ? "#22c55e" : "#f59e0b", fontSize:13, fontWeight:700, marginBottom:4}}>
                        {ok ? "✅ Dentro da tolerância" : "⚠️ Divergência acima da tolerância"}
                      </div>
                      <div style={{color:"#0ea5e9", fontSize:11, fontWeight:700, marginTop:4}}>Barras diárias</div>
                      {lin("Pregões comparados", intData.pregoes, intData.de + " a " + intData.ate)}
                      {lin("Datas em só uma fonte", faltas.length === 0 ? "nenhuma" : faltas.length, faltas.length === 0 ? "calendário idêntico" : faltas.slice(0, 4).join(", "))}
                      {lin("Fechamento, maior diferença", "$" + Number(intData.preco_dif_maxima).toFixed(4), "tolerância $" + Number(intData.tolerancia_preco).toFixed(2))}
                      {lin("Volume, maior diferença", intData.volume_dif_maxima_pct === null ? "sem dados" : Number(intData.volume_dif_maxima_pct).toFixed(2) + "%", (intData.volume_dif_mediana_pct === null || intData.volume_dif_mediana_pct === undefined ? "" : "mediana " + Number(intData.volume_dif_mediana_pct).toFixed(2) + "% · ") + "tolerância " + intData.tolerancia_volume_pct + "%")}
                      {(() => {
                        const i = intData.intradiario
                        if (!i) return null
                        if (i.erro) return (
                          <p style={{color:"#6b7280", fontSize:11, marginTop:10, lineHeight:1.5}}>Barras de 30 minutos: {i.erro}{i.detalhe ? " — " + i.detalhe : ""}</p>
                        )
                        const iok = i.status === "ok"
                        return (
                          <div style={{marginTop:10}}>
                            <div style={{display:"flex", justifyContent:"space-between", alignItems:"baseline"}}>
                              <span style={{color:"#0ea5e9", fontSize:11, fontWeight:700}}>Barras de 30 minutos</span>
                              <span style={{color: iok ? "#22c55e" : "#f59e0b", fontSize:11, fontWeight:700}}>{iok ? "✅ dentro da tolerância" : "⚠️ divergente"}</span>
                            </div>
                            {lin("Barras comparadas", i.barras, String(i.de).slice(0, 10) + " a " + String(i.ate).slice(0, 10))}
                            {lin("Fechamento, maior diferença", "$" + Number(i.preco_dif_maxima).toFixed(4), "tolerância $" + Number(i.tolerancia_preco).toFixed(2))}
                            {lin("Volume, maior diferença", i.volume_dif_maxima_pct === null ? "sem dados" : Number(i.volume_dif_maxima_pct).toFixed(2) + "%", (i.volume_dif_mediana_pct === null || i.volume_dif_mediana_pct === undefined ? "" : "mediana " + Number(i.volume_dif_mediana_pct).toFixed(2) + "% · ") + "tolerância " + i.tolerancia_volume_pct + "%")}
                            {i.volume_fora ? lin("Barras fora da tolerância", i.volume_fora + " de " + i.barras, "pior em " + String((i.piores_volume && i.piores_volume[0] && i.piores_volume[0].quando) || "—").slice(0, 16) + " · limite " + i.volume_fora_limite) : null}
                          </div>
                        )
                      })()}
                      {intData.conferido_ts ? lin("Conferido em", new Date(intData.conferido_ts * 1000).toLocaleString("pt-BR"), "") : null}
                      <p style={{color:"#4b5563", fontSize:10, marginTop:8, lineHeight:1.5}}>
                        A sessão em curso{intData.sessao_em_curso_fora ? " (" + intData.sessao_em_curso_fora + ")" : ""} fica fora das duas contas: as duas fontes ainda estão formando a barra de hoje, e divergência ali não diz nada sobre integridade. O volume diverge mais que o preço porque cada provedor consolida praças diferentes — por isso a tolerância dele é mais larga. O resultado vale por uma semana: barra errada no histórico não nasce de hora em hora.
                      </p>
                    </div>
                  )
                })()}
              </div>
              {medStub("mtf", acertosMtf, "🎯 Acertos do resumo por tempo gráfico")}
              {acertosMtf && medAbre("mtf", acertosMtf) && (
                <div style={s.card}>
                  <p style={s.cardTitle}>🎯 Acertos do resumo por tempo gráfico</p>
                  {acertosMtf.total === 0 ? (
                    <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
                      Cada vez que você consulta um ativo no bloco acima, o app anota o saldo de votos de cada prazo — positivo quando os indicadores apontam alta, negativo quando apontam baixa — junto com o preço daquele momento, uma vez por dia para cada ativo. Trinta dias depois ele confere: das vezes em que um prazo apontou alta, em quantas o preço subiu; das que apontou baixa, em quantas caiu. Essa taxa é comparada com a linha de base, que é a proporção de vezes em que o preço subiu, sem olhar prazo nenhum. Um prazo só está dizendo algo se acertar mais que essa linha. Ainda não há registros com 30 dias.
                    </p>
                  ) : (
                    <div>
                      {acertosMtf.total < 20 && (
                        <p style={{color:"#f59e0b", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                          ⚠️ Base pequena ({acertosMtf.total}): estes números ainda não separam acerto de sorte.
                        </p>
                      )}
                      <p style={{color:"#9ca3af", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                        Linha de base: em {acertosMtf.subiu} das {acertosMtf.comparadas} análises medidas o preço subiu nos 30 dias seguintes, ou {(acertosMtf.comparadas ? acertosMtf.subiu / acertosMtf.comparadas * 100 : 0).toFixed(0)}%. Cada prazo abaixo precisa superar esse número para estar dizendo algo.
                      </p>
                      {[["mtf_30min","30 min"], ["mtf_1h","1 hora"], ["mtf_dia","Dia"], ["mtf_semana","Semana"], ["mtf_mes","Mês"]].map(([k, rot]) => {
                        const d = acertosMtf.por[k]
                        const n = d.alta + d.baixa
                        const taxa = n ? (d.altaOk + d.baixaOk) / n * 100 : null
                        const _v = vereditoContraBase(d.alta, d.altaOk, d.baixa, d.baixaOk, acertosMtf.subiu, acertosMtf.comparadas, rot)
                        return (
                          <div key={k} style={{padding:"8px 0", borderTop:"1px solid #1f2937"}}>
                            <div style={{display:"flex", justifyContent:"space-between", alignItems:"baseline"}}>
                              <span style={{color:"#e5e7eb", fontSize:12, fontWeight:700}}>{rot}</span>
                              <span style={{fontSize:12, color:"#e5e7eb"}}>{taxa === null ? "sem registros" : taxa.toFixed(0) + "% de acerto"}</span>
                            </div>
                            <div style={{color:"#4b5563", fontSize:10, marginTop:2}}>
                              {d.alta} apostas em alta ({d.altaOk} certas) · {d.baixa} em baixa ({d.baixaOk} certas)
                            </div>
                            <div style={{color:_v.cor, fontSize:11, marginTop:3}}>{_v.curto}</div>
                          </div>
                        )
                      })}
                      {(() => {
                        const _vd = vereditoContraBase(acertosMtf.por.mtf_dia.alta, acertosMtf.por.mtf_dia.altaOk, acertosMtf.por.mtf_dia.baixa, acertosMtf.por.mtf_dia.baixaOk, acertosMtf.subiu, acertosMtf.comparadas, "o resumo técnico no diário")
                        return <p style={{color:_vd.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_vd.txt}</p>
                      })()}
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          {tab === "premium" && isPremium && medStub("conf", acertos, "🎯 Acertos da análise")}
          {tab === "premium" && isPremium && acertos && medAbre("conf", acertos) && (
        <div style={s.card}>
          <p style={s.cardTitle}>🎯 Acertos da análise</p>
          {acertos.total === 0 ? (
            <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
              Cada análise desta aba fica guardada. Daqui a 30 dias o app compara o
              preço de então com o de hoje: quantas vezes o Confluence acertou a direção,
              quantas subiram sem olhar o Confluence (a linha de base, para saber se ele
              acrescenta algo), e se os retornos com exaustão alta se separam dos com
              exaustão baixa.
              Ainda não há análises com 30 dias feitas com a régua atual. As
              anteriores a 10/10/2026 existem, mas saíram de uma régua que
              mudou nesse dia — a zona altista do Confluence era conjunto
              vazio e nunca disparou — e por isso não entram nesta conta.
              Não dá para recalculá-las nem para saber quais foram afetadas:
              os níveis de Fibonacci que o sinal lia nunca foram gravados.
            </p>
          ) : (
            <div>
              {acertos.total < 20 && (
                <p style={{color:"#f59e0b", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                  ⚠️ Base pequena ({acertos.total}): estes números ainda não separam acerto
                  de sorte. São registro em formação, não medida de desempenho.
                </p>
              )}
              <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                Confluence disse ALTA: {acertos.altaOk} de {acertos.altaTot} subiram em 30 dias{acertos.altaTot > 0 && acertos.comparadas > 0 ? " — " + (acertos.altaOk / acertos.altaTot * 100).toFixed(1) + "%, contra os " + (acertos.comparadas > 0 ? acertos.subiu / acertos.comparadas * 100 : 0).toFixed(1) + "% que a chance daria" : ""}
              </p>
              <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                Confluence disse BAIXA: {acertos.baixaOk} de {acertos.baixaTot} caíram em 30 dias{acertos.baixaTot > 0 && acertos.comparadas > 0 ? " — " + (acertos.baixaOk / acertos.baixaTot * 100).toFixed(1) + "%, contra os " + (100 - (acertos.comparadas > 0 ? acertos.subiu / acertos.comparadas * 100 : 0)).toFixed(1) + "% que a chance daria" : ""}
              </p>
              {acertos.comparadas > 0 && (
                <p style={{color:"#4b5563", fontSize:11, margin:"0 0 8px 0", lineHeight:1.5}}>
                  Linha de base: {acertos.subiu} de {acertos.comparadas} subiram em 30 dias{acertos.comparadas > 0 ? " — " + (acertos.comparadas > 0 ? acertos.subiu / acertos.comparadas * 100 : 0).toFixed(1) + "% de alta e " + (100 - (acertos.comparadas > 0 ? acertos.subiu / acertos.comparadas * 100 : 0)).toFixed(1) + "% de queda" : ""},
                  sem olhar o Confluence. Se o acerto acima não for maior que isso,
                  o indicador não está acrescentando nada.
                </p>
              )}
              {(acertos.exAltoN > 0 || acertos.exBaixoN > 0) && (
                <div style={{marginTop:10, paddingTop:10, borderTop:"1px solid #1f2937"}}>
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 6px 0"}}>
                    Exaustão 60+: retorno médio em 30 dias{" "}
                    {acertos.exAltoMed === null ? "sem dados" : acertos.exAltoMed.toFixed(1) + "%"}
                    {" "}({acertos.exAltoN}{acertos.exAltoN < 3 ? " — amostra insuficiente" : ""})
                  </p>
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 6px 0"}}>
                    Exaustão até 40: retorno médio em 30 dias{" "}
                    {acertos.exBaixoMed === null ? "sem dados" : acertos.exBaixoMed.toFixed(1) + "%"}
                    {" "}({acertos.exBaixoN}{acertos.exBaixoN < 3 ? " — amostra insuficiente" : ""})
                  </p>
                  <p style={{color:"#4b5563", fontSize:10, margin:0, lineHeight:1.5}}>
                    Se os dois números forem parecidos, a exaustão não está informando nada.
                  </p>
                </div>
              )}
              {(() => {
                const _v = vereditoContraBase(acertos.altaTot, acertos.altaOk, acertos.baixaTot, acertos.baixaOk, acertos.subiu, acertos.comparadas, "o Confluence")
                return <p style={{color:_v.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_v.txt}</p>
              })()}
              <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                Base: {acertos.total} análises com 30 dias completos{" "}{AVISO_DENOM}
              </p>
            </div>
          )}
        </div>
      )}

      {tab === "premium" && isPremium && (<>
          {medStub("amoconf", amostraVer && amostraVer.confluence,
            "🔬 Confluence no mesmo ativo")}
          {amostraVer && amostraVer.confluence && medAbre("amoconf", amostraVer.confluence) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🔬 Confluence no mesmo ativo</p>
              <p style={{color: amostraVer.confluence.cor, fontSize:12,
                margin:"0 0 8px 0", lineHeight:1.5}}>
                {amostraVer.confluence.txt}
              </p>
              <p style={{color:"#9ca3af", fontSize:11, margin:"0 0 8px 0",
                lineHeight:1.5}}>
                {"Amostra: " + amostraVer.linhas + " leituras gravadas, "
                  + amostraVer.maduras + " com 30 dias cumpridos, "
                  + amostraVer.confluence.ativos_com_contraste
                  + " ativos com contraste."}
              </p>
              <p style={{color:"#4b5563", fontSize:10, margin:"0 0 8px 0",
                lineHeight:1.5}}>
                Os outros cards comparam entre analises e entre ativos. Este
                compara ALTO contra BAIXO do MESMO ativo, e por isso nao
                confunde score com setor — a medicao de 08/10/2026 mostrou
                que tudo que parecia sinal entre ativos era rotacao setorial.
                Ele NAO resolve a sobreposicao de janelas: o aviso de
                independencia vale aqui tambem.
              </p>
              {(amostraVer.confluence.detalhe || []).map(x => (
                <div key={x.symbol} style={{display:"flex",
                  justifyContent:"space-between", fontSize:11}}>
                  <span style={{color:"#9ca3af"}}>{x.symbol}</span>
                  <span style={{color:"#9ca3af"}}>
                    {"alto " + x.med_alto + "% (" + x.n_alto + ") x baixo "
                      + x.med_baixo + "% (" + x.n_baixo + ")"}
                  </span>
                </div>
              ))}
              <p style={{color:"#4b5563", fontSize:10, margin:"8px 0 0 0",
                lineHeight:1.5}}>{amostraVer.regra}</p>
              <p style={{color:"#4b5563", fontSize:10, margin:"6px 0 0 0",
                lineHeight:1.5}}>{amostraVer.exhaustion_nota}</p>
              <div style={{height:24}} />
            </div>
          )}
          {medStub("exdir", exDir, "🔋 Exaustão separada por lado")}
          {exDir && exDir.total > 0 && medAbre("exdir", exDir) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🔋 Exaustão separada por lado</p>
              <p style={{color:"#4b5563", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                Exaustão alta diz que o movimento esticou, sem dizer para que lado. Se foi
                para cima e reverte, o ativo CAI; se foi para baixo, SOBE. O card acima soma
                os dois casos num retorno médio só, onde um anula o outro. Aqui o RSI separa:
                acima de 55 conta como para cima, abaixo de 45 como para baixo, entre as
                análises com exaustão 50+.
              </p>
              <p style={{color:"#f59e0b", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                ⚠️ Os cortes aqui (50 de exaustão, 55/45 de RSI) são mais frouxos que os
                clássicos para caber a base atual. Com mais registros valem cortes mais firmes.
              </p>
              <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                Para CIMA: retorno médio em 30 dias{" "}
                {exDir.cimaMed === null ? "sem dados" : exDir.cimaMed.toFixed(1) + "%"}
                {" "}({exDir.cimaN}{exDir.cimaN < 3 ? " — amostra insuficiente" : ""})
                {" "}— se a exaustão informa algo, este número deveria ficar ABAIXO da linha de base
              </p>
              <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                Para BAIXO: retorno médio em 30 dias{" "}
                {exDir.baixoMed === null ? "sem dados" : exDir.baixoMed.toFixed(1) + "%"}
                {" "}({exDir.baixoN}{exDir.baixoN < 3 ? " — amostra insuficiente" : ""})
                {" "}— aqui deveria ficar ACIMA da linha de base
              </p>
              <p style={{color:"#4b5563", fontSize:11, margin:"0 0 8px 0", lineHeight:1.5}}>
                Linha de base: {exDir.baseMed === null ? "sem dados" : exDir.baseMed.toFixed(1) + "%"}
                {" "}de todas as análises. A exaustão só antecipa reversão se o número de
                CIMA ficar ABAIXO dela e o de BAIXO ficar ACIMA.
              </p>
              {(() => {
                const _v = vereditoExaustao(exDir)
                return <p style={{color:_v.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_v.txt}</p>
              })()}
              <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                Base: {exDir.total} análises com 30 dias completos{" "}{AVISO_DENOM}
              </p>
            </div>
          )}
          {medStub("regime", porRegime, "🌡️ Confluence por tipo de mercado")}
          {porRegime && medAbre("regime", porRegime) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🌡️ Confluence por tipo de mercado</p>
              <p style={{color:"#4b5563", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                Quando o Confluence diz ALTA, conta como acerto se o preço estiver mais alto
                30 dias depois; quando diz BAIXA, se estiver mais baixo. Os sinais que ele
                soma leem a direção do preço, então funcionam melhor com o ativo andando
                para um lado só e pior com o preço subindo e descendo sem rumo. Este card
                mede o acerto em cada situação, classificada pelas médias móveis do ativo
                no dia: com a de 9 dias acima da de 21 e a de 21 acima da de 50, ele conta
                como EM ALTA; na ordem inversa, EM BAIXA; fora dessas duas, DE LADO.
              </p>
              {porRegime.total === 0 ? (
                <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
                  Os primeiros números aparecem 30 dias depois da sua primeira análise.
                  Análises feitas antes de setembro de 2026 não guardavam o estado do
                  ativo e ficam de fora desta conta.
                </p>
              ) : (
                <div>
                  {["alta", "baixa", "lateral"].map(k => {
                    const g = porRegime.R[k]
                    const nome = k === "alta" ? "Em alta" : k === "baixa" ? "Em baixa" : "De lado"
                    if (!g || g.tot === 0) return <p key={k} style={{color:"#4b5563", fontSize:12, margin:"0 0 8px 0"}}>{nome}: nenhuma análise ainda</p>
                    const base = g.subiu / g.tot * 100
                    return (
                      <p key={k} style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                        {nome}: Confluence acertou {g.ok} de {g.tot}
                        {" "}· linha de base {base.toFixed(0)}% subiram
                        {g.tot < 5 ? " — amostra insuficiente" : ""}
                      </p>
                    )
                  })}
                  {(() => {
                    const _v = vereditoPorRegime(porRegime)
                    return <p style={{color:_v.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_v.txt}</p>
                  })()}
                  <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                    Base: {porRegime.total} análises com regime e lado apontado e 30 dias completos{" "}{AVISO_DENOM}
                  </p>
                </div>
              )}
            </div>
          )}
          {medStub("scores", scoresRegime, "🌡️ Os três scores por tipo de mercado")}
          {scoresRegime && medAbre("scores", scoresRegime) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🌡️ Os três scores por tipo de mercado</p>
              <p style={{color:"#4b5563", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                Advanced, sobrevenda e DCA lado a lado, cada um separado pelo estado do ativo
                no dia. Compara quanto renderam os ativos que tiraram nota alta (65 ou mais no
                Advanced, 60 ou mais nos outros dois) contra os que tiraram 40 ou menos,
                dentro do mesmo tipo de mercado — e mostra se algum
                indicador se sai melhor onde os outros falham.
              </p>
              {scoresRegime.total === 0 ? (
                <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
                  Os primeiros números aparecem 30 dias depois da sua primeira análise.
                  Análises feitas antes de setembro de 2026 ficam de fora desta conta.
                </p>
              ) : (
                <div>
                  {Object.entries(scoresRegime.nomes).map(([col, nome]) => (
                    <div key={col} style={{marginBottom:10, paddingBottom:8, borderBottom:"1px solid #1f2937"}}>
                      <p style={{color:"#e2e8f0", fontSize:12, fontWeight:700, margin:"0 0 4px 0"}}>{nome}</p>
                      {["alta", "baixa", "lateral"].map(k => {
                        const g = scoresRegime.out[col][k]
                        const rot = k === "alta" ? "em alta" : k === "baixa" ? "em baixa" : "de lado"
                        const md = arr => arr.length ? (arr.reduce((x,y)=>x+y,0)/arr.length).toFixed(1) + "%" : "—"
                        if (g.a.length === 0 && g.b.length === 0) return <p key={k} style={{color:"#4b5563", fontSize:11, margin:"0 0 2px 0"}}>{rot}: sem registros</p>
                        return (
                          <p key={k} style={{color:"#9ca3af", fontSize:11, margin:"0 0 2px 0"}}>
                            {rot}: nota alta {md(g.a)} ({g.a.length}) · nota baixa {md(g.b)} ({g.b.length})
                            {(g.a.length < 5 || g.b.length < 5) ? " — insuficiente" : ""}
                          </p>
                        )
                      })}
                    </div>
                  ))}
                  {(() => {
                    const _v = vereditoScoresRegime(scoresRegime)
                    return <p style={{color:_v.cor, fontSize:11, margin:"6px 0 0 0", fontWeight:700}}>{_v.txt}</p>
                  })()}
                  <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                    Base: {scoresRegime.total} registros com regime guardado e 30 dias completos{" "}{AVISO_DENOM}
                  </p>
                </div>
              )}
            </div>
          )}
      </>)}

      {tab === "premium2" && <TabPremium2
        InfoTip={InfoTip}
        MCCone={MCCone}
        OPTIMIZER_UNIVERSE={OPTIMIZER_UNIVERSE}
        etfEnriched={etfEnriched}
        fetchPortfolioStats={fetchPortfolioStats}
        handleSubscribe2={handleSubscribe2}
        isPremium2={isPremium2}
        loadingStats={loadingStats}
        manageSubscription={manageSubscription}
        optimAlts={optimAlts}
        optimAltsLoading={optimAltsLoading}
        optimAmount={optimAmount}
        optimGoal={optimGoal}
        optimLoading={optimLoading}
        optimMode={optimMode}
        optimResult={optimResult}
        optimSellPct={optimSellPct}
        optimSellTicker={optimSellTicker}
        optimTicker={optimTicker}
        portfolioStats={portfolioStats}
        runAlternatives={runAlternatives}
        runOptimizer={runOptimizer}
        s={s}
        setMcSnapshot={setMcSnapshot}
        setOptimAlts={setOptimAlts}
        setOptimAmount={setOptimAmount}
        setOptimGoal={setOptimGoal}
        setOptimMode={setOptimMode}
        setOptimResult={setOptimResult}
        setOptimSellPct={setOptimSellPct}
        setOptimSellTicker={setOptimSellTicker}
        setOptimTicker={setOptimTicker}
        totalValue={totalValue}
      />}

      {tab === "premium2" && portfolioStats && !portfolioStats?.error && (() => {
        const maxdd = Math.abs(parseFloat(portfolioStats?.max_drawdown) || 0)
        const sharpe30 = portfolioStats?.sharpe_30d ?? null
        const sharpe90 = portfolioStats?.sharpe_90d ?? null
        const sharpe180 = portfolioStats?.sharpe_180d ?? null
        // volatilidade mede oscilacao, nao velocidade de recuperacao. O tempo real
        // depende do retorno: para voltar de -32.5% e preciso subir 48.1%
        const _rt = recoveryTime(portfolioStats?.max_drawdown)
        const _recovGanho = _rt ? _rt.ganho : 0
        const _recovMeses = _rt ? _rt.meses : (() => 0)
        const recovMonths = maxdd > 0 ? _recovMeses(0.12) : null
        const sColor = v => v >= 1 ? "#22c55e" : v >= 0 ? "#86efac" : v >= -1 ? "#f59e0b" : "#ef4444"
        return (
          <div style={{padding:"0 16px 16px"}}>
            <div style={{...s.card, marginTop:12}}>
              <p style={s.cardTitle}>📊 Rolling Sharpe Ratio</p>
              <p style={{color:"#64748b", fontSize:11, marginBottom:12}}>Evolução da eficiência ajustada ao risco</p>
              <div style={{display:"flex", gap:8}}>
                {[["30d", sharpe30], ["90d", sharpe90], ["180d", sharpe180]].map(([label, val]) => (
                  <div key={label} style={{flex:1, background:"rgba(0,0,0,0.3)", borderRadius:10, padding:12, textAlign:"center"}}>
                    <div style={{fontSize:11, color:"#64748b", marginBottom:4}}>{label}</div>
                    <div style={{fontSize:20, fontWeight:800, color: val === null ? "#64748b" : sColor(val)}}>{val === null ? "—" : val.toFixed(2)}</div>
                  </div>
                ))}
              </div>
              <div style={{fontSize:11, color:"#64748b", marginTop:8}}>
                {sharpe30 === null || sharpe180 === null ? "Historico insuficiente para comparar as janelas" : sharpe30 > sharpe180 ? "📈 Melhorando nos últimos 30 dias" : "📉 Piorando nos últimos 30 dias"}
              </div>
            </div>

            <div style={{...s.card, marginTop:12}}>
              <p style={s.cardTitle}>⏱️ Recovery Time</p>
              <p style={{color:"#64748b", fontSize:11, marginBottom:12}}>Estimativa para recuperar uma queda do tamanho da pior do último ano</p>
              {recovMonths ? (
                <div style={{display:"flex", gap:8}}>
                  <div style={{flex:1, background:"rgba(34,197,94,0.08)", border:"1px solid rgba(34,197,94,0.2)", borderRadius:10, padding:12, textAlign:"center"}}>
                    <div style={{fontSize:11, color:"#64748b", marginBottom:4}}>Otimista</div>
                    <div style={{fontSize:18, fontWeight:800, color:"#22c55e"}}>{_recovMeses(0.20)} meses</div>
                  </div>
                  <div style={{flex:1, background:"rgba(245,158,11,0.08)", border:"1px solid rgba(245,158,11,0.2)", borderRadius:10, padding:12, textAlign:"center"}}>
                    <div style={{fontSize:11, color:"#64748b", marginBottom:4}}>Base</div>
                    <div style={{fontSize:18, fontWeight:800, color:"#f59e0b"}}>{recovMonths} meses</div>
                  </div>
                  <div style={{flex:1, background:"rgba(239,68,68,0.08)", border:"1px solid rgba(239,68,68,0.2)", borderRadius:10, padding:12, textAlign:"center"}}>
                    <div style={{fontSize:11, color:"#64748b", marginBottom:4}}>Pessimista</div>
                    <div style={{fontSize:18, fontWeight:800, color:"#ef4444"}}>{_recovMeses(0.06)} meses</div>
                  </div>
                </div>
              ) : <p style={{color:"#64748b", fontSize:13}}>Dados insuficientes</p>}
              {recovMonths && <div style={{fontSize:11, color:"#64748b", marginTop:8}}>Assumindo retornos de 20%, 12% e 6% ao ano. Essa queda é a pior que estes ativos tiveram no último ano com os pesos de hoje, não o seu resultado — o seu está no resultado da tela inicial. Para recuperar uma queda de {maxdd.toFixed(1)}%, a carteira precisa subir {(_recovGanho*100).toFixed(1)}%.</div>}
            </div>
          </div>
        )
      })()}

      {tab === "premium2" && portfolioStats && !portfolioStats?.error && (
        <div style={{padding:"0 16px 16px"}}>
              <div style={s.card}>
                <p style={s.cardTitle}>📊 Análise Técnica da Carteira</p>
                <button onClick={fetchPortfolioTechnical} style={{...s.addBtn, background:"linear-gradient(135deg, #0369a1, #0891b2)", marginBottom:12}}>
                  {loadingPortfolioTech ? "⏳ Analisando..." : "🔍 Analisar Todos os ETFs da Carteira"}
                </button>
                {Object.entries(portfolioTechnical).map(([ticker, tech]) => (
                  <div key={ticker} style={{borderBottom:"1px solid #1f2937", paddingBottom:12, marginBottom:12}}>
                    <p style={{color:"#7dd3fc", fontWeight:"bold", fontSize:14, margin:"0 0 8px 0"}}>📈 {ticker} — ${tech.current_price}</p>
                    <div style={{display:"flex", gap:6, flexWrap:"wrap", marginBottom:6}}>
                      <span style={{...s.badge, backgroundColor: tech.rsi < 30 ? "#16a34a33" : tech.rsi > 70 ? "#dc262633" : "#f59e0b33", color: tech.rsi < 30 ? "#22c55e" : tech.rsi > 70 ? "#ef4444" : "#f59e0b"}}>
                        RSI: {tech.rsi} — {tech.rsi_signal === "oversold" ? "Sobrevendido" : tech.rsi_signal === "overbought" ? "Sobrecomprado" : "Neutro"}
                      </span>
                      <span style={{...s.badge, backgroundColor: tech.macd?.signal_label === "bullish" ? "#16a34a33" : "#dc262633", color: tech.macd?.signal_label === "bullish" ? "#22c55e" : "#ef4444"}}>
                        MACD: {tech.macd?.signal_label === "bullish" ? "Alta ▲" : "Baixa ▼"}
                      </span>
                      <span style={{...s.badge, backgroundColor: tech.bollinger?.signal === "oversold" ? "#16a34a33" : tech.bollinger?.signal === "overbought" ? "#dc262633" : "#f59e0b33", color: tech.bollinger?.signal === "oversold" ? "#22c55e" : tech.bollinger?.signal === "overbought" ? "#ef4444" : "#f59e0b"}}>
                        BB: {tech.bollinger?.signal === "oversold" ? "Sobrevendido" : tech.bollinger?.signal === "overbought" ? "Sobrecomprado" : "Neutro"}
                      </span>
                    </div>
                    <div style={{display:"flex", justifyContent:"space-between", fontSize:11, color:"#6b7280"}}>
                      <span>Suporte: <span style={{color:"#22c55e"}}>${tech.support_resistance?.support?.toFixed(2)}</span></span>
                      <span>Resistência: <span style={{color:"#ef4444"}}>${tech.support_resistance?.resistance?.toFixed(2)}</span></span>
                    </div>
                  </div>
                ))}
              </div>
        </div>
      )}

      {tab === "premium3" && <TabPremium3
        AVISO_DENOM={AVISO_DENOM}
        acertosDca={acertosDca}
        dcaAmount={dcaAmount}
        dcaBestTarget={dcaBestTarget}
        dcaEtf={dcaEtf}
        enriched={enriched}
        etfEnriched={etfEnriched}
        generatePremium3Analysis={generatePremium3Analysis}
        handleSubscribe3={handleSubscribe3}
        isPremium3={isPremium3}
        loadingPremium3={loadingPremium3}
        manageSubscription={manageSubscription}
        medAbre={medAbre}
        medStub={medStub}
        portfolioStats={portfolioStats}
        portfolioTechnical={portfolioTechnical}
        premium3Analysis={premium3Analysis}
        prices={prices}
        s={s}
        setDcaAmount={setDcaAmount}
        setDcaBestTarget={setDcaBestTarget}
        setDcaEtf={setDcaEtf}
        setMedAberta={setMedAberta}
        setTranslatedPremium3={setTranslatedPremium3}
        setTranslatingPremium3={setTranslatingPremium3}
        stress={stress}
        techTicker={techTicker}
        technical={technical}
        totalValue={totalValue}
        translateAnalysis={translateAnalysis}
        translatedPremium3={translatedPremium3}
        translatingPremium3={translatingPremium3}
      />}

      {tab === "premium4" && <TabPremium4
        regimeVer={regimeVer}
        sinalVer={sinalVer}
        API_URL={API_URL}
        AVISO_DENOM={AVISO_DENOM}
        CLAUDE_MODEL={CLAUDE_MODEL}
        InfoTip={InfoTip}
        acertosAv={acertosAv}
        acertosEw={acertosEw}
        advData={advData}
        advLoading={advLoading}
        advTicker={advTicker}
        alertSettings={alertSettings}
        alertsSaved={alertsSaved}
        connectionSaved={connectionSaved}
        etfEnriched={etfEnriched}
        etfFlows={etfFlows}
        ewCart={ewCart}
        ewCartLoading={ewCartLoading}
        ewData={ewData}
        ewLoading={ewLoading}
        ewPrazo={ewPrazo}
        ewTicker={ewTicker}
        handleSubscribe4={handleSubscribe4}
        isPremium4={isPremium4}
        lastReport={lastReport}
        macroFonte={macroFonte}
        manageSubscription={manageSubscription}
        medAberta={medAberta}
        medAbre={medAbre}
        medStub={medStub}
        news={news}
        newsSentiment={newsSentiment}
        portfolioStats={portfolioStats}
        portfolioTechnical={portfolioTechnical}
        positions={positions}
        prices={prices}
        regimeDe={regimeDe}
        registrarAvancado={registrarAvancado}
        registrarEw={registrarEw}
        s={s}
        saveAlertSettings={saveAlertSettings}
        savingAlerts={savingAlerts}
        setAdvData={setAdvData}
        setAdvLoading={setAdvLoading}
        setAdvTicker={setAdvTicker}
        setAlertSettings={setAlertSettings}
        rodarCarteiraEw={rodarCarteiraEw}
        setEwCart={setEwCart}
        setEwCartLoading={setEwCartLoading}
        setEwData={setEwData}
        setEwLoading={setEwLoading}
        setEwPrazo={setEwPrazo}
        setEwTicker={setEwTicker}
        setLastReport={setLastReport}
        setLastSmartAlert={setLastSmartAlert}
        setMedAberta={setMedAberta}
        setTab={setTab}
        setTranslatedWhatif={setTranslatedWhatif}
        setTranslatingWhatif={setTranslatingWhatif}
        setWhatifBuy={setWhatifBuy}
        setWhatifPct={setWhatifPct}
        setWhatifResult={setWhatifResult}
        setWhatifSell={setWhatifSell}
        telegramId={telegramId}
        totalInvested={totalInvested}
        totalValue={totalValue}
        translateAnalysis={translateAnalysis}
        translatedWhatif={translatedWhatif}
        translatingWhatif={translatingWhatif}
        user={user}
        whatifBuy={whatifBuy}
        whatifPct={whatifPct}
        whatifResult={whatifResult}
        whatifSell={whatifSell}
      />}

      {tab === "premium5" && isPremium5 && (
        <div style={{textAlign:"right", marginBottom:8}}>
          <button onClick={manageSubscription} style={{...s.addBtn, backgroundColor:"#1f2937", fontSize:13}}>⚙️ Gerenciar Assinatura</button>
        </div>
      )}
      {tab === "premium5" && (
        <div>
          {!isPremium5 ? (
            <div style={{...s.card, textAlign:"center", padding:24, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(168,85,247,0.3)"}}>
              <div style={{fontSize:48, marginBottom:8}}>🧬</div>
              <p style={{color:"#a855f7", fontSize:18, fontWeight:"bold", marginBottom:8}}>CLAW DCA Intelligence™</p>
              <p style={{color:"#9ca3af", fontSize:13, marginBottom:16, lineHeight:1.5}}>Simule o impacto de um aporte no Sharpe, VaR, Drawdown e Monte Carlo do portfólio antes de investir.</p>
              {["🎯 Monte Carlo pós-aporte","📊 Sharpe, Sortino, VaR e Drawdown antes/depois","🛡️ Risk Contribution por posição","🏆 Custo de oportunidade — melhor alternativa","🧬 CLAW DCA Intelligence™ Score 0-100","🎯 Ranking por objetivo — retorno, concentração, defesa, preço médio ou sobrevenda","🏁 Resumo das medições do app — com o veredito de cada uma","🔗 Correlação do ativo com a sua carteira — se cai junto, não serve de proteção, e a tela diz isso","💡 Ranking completo do aporte — cada ativo com o ΔSharpe e o ΔProb+ que entrega, não só o primeiro colocado","⚠️ Diz quando nenhum ativo melhora — em vez de inventar uma recomendação para preencher a tela"].map((f,i) => (
                <div key={i} style={{display:"flex", alignItems:"center", gap:8, marginBottom:8, textAlign:"left"}}>
                  <span style={{color:"#a855f7"}}>✓</span>
                  <span style={{color:"#f0f9ff", fontSize:13}}>{f}</span>
                </div>
              ))}
              <p style={{color:"#9ca3af", fontSize:11, lineHeight:1.5, margin:"0 0 4px 0", textAlign:"left"}}>Cada score desta aba é registrado e conferido trinta dias depois — e o resultado fica no app, inclusive quando é ruim.</p>
              <div style={{margin:"20px 0 16px"}}>
                <span style={{color:"#a855f7", fontSize:28, fontWeight:"bold"}}>$59,99</span>
                <span style={{color:"#d8b4fe", fontSize:14}}>/mês</span>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={() => handleSubscribe5("USD")} style={{...s.addBtn, flex:1, background:"linear-gradient(135deg, #7c3aed, #a855f7)", fontSize:13}}>💳 $59,99/mês</button>
                <button onClick={() => handleSubscribe5("BRL")} style={{...s.addBtn, flex:1, background:"linear-gradient(135deg, #059669, #7c3aed)", fontSize:13}}>💳 R$299,00/mês</button>
              </div>
            </div>
          ) : (
            <div>
              <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(168,85,247,0.3)"}}>
                <p style={{...s.cardTitle, color:"#a855f7"}}>🧬 CLAW DCA Intelligence™</p>
                <p style={{color:"#9ca3af", fontSize:12, marginBottom:12}}>Onde seu próximo aporte trabalha melhor?</p>
                <div style={{marginBottom:12}}>
                  <label style={{color:"#9ca3af", fontSize:12}}>Valor do aporte (USD)</label>
                  <input type="text" inputMode="decimal" placeholder="Ex: 500" value={p5Amount} onChange={e => setP5Amount(e.target.value)} style={{...s.input, marginTop:4}}/>
                </div>
                <div style={{marginBottom:12}}>
                  <label style={{color:"#9ca3af", fontSize:12}}>Ativo destino</label>
                  <select value={p5Ticker} onChange={e => { setP5Ticker(e.target.value); setP5Result(null); setP5BestAlt(null) }} style={{...s.input, marginTop:4}}>
                    <option value="">Da minha carteira...</option>
                    {etfEnriched.map(p => <option key={p.symbol} value={p.symbol}>{p.symbol} — ${p.currentPrice?.toFixed(2)}</option>)}
                  </select>
                </div>
                <button disabled={p5Loading || !p5Amount || !p5Ticker} style={{...s.addBtn, background:"linear-gradient(135deg, #7c3aed, #a855f7)", width:"100%", opacity: p5Loading ? 0.6 : 1}} onClick={async () => {
                  if (!portfolioStats || portfolioStats?.error) { alert("Execute primeiro a análise do Premium 2!"); return }
                  setP5Loading(true); setP5Result(null); setP5BestAlt(null)
                  const amount = numBR(p5Amount)
                  const simulate = async (ticker, amt) => {
                    const p = etfEnriched.find(x => x.symbol === ticker)
                    if (!p || !p.currentPrice) return null
                    const nq = amt / p.currentPrice
                    const modPos = etfEnriched.map(x => x.symbol === ticker
                      ? {symbol: x.symbol, current_price: x.currentPrice, quantity: (x.quantity||0)+nq, avg_price: ((x.quantity||0)*x.avg_price+amt)/((x.quantity||0)+nq)}
                      : {symbol: x.symbol, current_price: x.currentPrice, quantity: x.quantity, avg_price: x.avg_price}
                    )
                    const res = await fetch(API_URL + "/portfolio-stats2", {method:"POST", headers:{"Content-Type":"application/json", ...hdrAuth()}, body: JSON.stringify({positions: modPos})})
                    return await res.json()
                  }
                  const after = await simulate(p5Ticker, amount)
                  if (!after || after.error) { setP5Loading(false); return }
                  const pos = etfEnriched.find(p => p.symbol === p5Ticker)
                  const tv = etfEnriched.reduce((s,p)=>s+(p.value||0),0)
                  const posValue = (pos.quantity||0) * pos.currentPrice
                  const riskBefore = tv > 0 ? posValue/tv*100 : 0
                  const tvAfter = tv + amount
                  const riskAfter = tvAfter > 0 ? (posValue+amount)/tvAfter*100 : 0
                  // Fresh baseline calculation
                  const basePayload = {positions: [...new Map(etfEnriched.map(p => [p.symbol, p])).values()].map(p => ({symbol: p.symbol, quantity: p.quantity, avg_price: p.avg_price, current_price: p.currentPrice || p.avg_price})), period: "1y"}
                  const baseRes = await fetch(API_URL + "/portfolio-stats2", {method:"POST", headers:{"Content-Type":"application/json", ...hdrAuth()}, body: JSON.stringify(basePayload)})
                  const baseData = await baseRes.json()
                  const shBefore = parseFloat(baseData.sharpe_ratio)||0
                  const shAfter = parseFloat(after.sharpe_ratio)||0
                  const sorBefore = parseFloat(portfolioStats?.sortino_ratio)||0
                  const sorAfter = parseFloat(after.sortino_ratio)||0
                  const varBefore = parseFloat(baseData.var_95)||0
                  const varAfter = parseFloat(after.var_95)||0
                  const mddBefore = parseFloat(baseData.max_drawdown)||0
                  const mddAfter = parseFloat(after.max_drawdown)||0
                  const mcBefore = parseFloat(portfolioStats?.monte_carlo?.prob_positive||0)||0
                  const mcAfter = after.monte_carlo && after.monte_carlo.prob_positive !== undefined ? parseFloat(after.monte_carlo.prob_positive) : mcBefore
                  let score = 50
                  const _shD = shAfter - shBefore
                  const _sorD = sorAfter - sorBefore
                  const _mcD = mcAfter - mcBefore
                  score += Math.round(_shD * 120)
                  score += Math.round(_sorD * 50)
                  score += Math.round(_mcD * 3)
                  if (varAfter > varBefore + 0.1) score += 6; else if (varAfter < varBefore - 0.1) score -= 6
                  if (mddAfter > mddBefore + 0.1) score += 5; else if (mddAfter < mddBefore - 0.1) score -= 5
                  score = Math.max(0, Math.min(100, Math.round(score)))
                  const alts = []
                  for (const p of etfEnriched) {
                    if (p.symbol === p5Ticker) continue
                    const altResult = await simulate(p.symbol, amount)
                    if (altResult && !altResult.error) {
                      const ash = parseFloat(altResult.sharpe_ratio)||0
                      const asor = parseFloat(altResult.sortino_ratio)||0
                      const amc = parseFloat(altResult.monte_carlo?.prob_positive)||0
                      const avar = parseFloat(altResult.var_95)||0
                      const amdd = parseFloat(altResult.max_drawdown)||0
                      let altScore = 50
                      const shDelta = ash - shBefore
                      const sorDelta = asor - sorBefore
                      const mcDelta = amc - mcBefore
                      // multiplicadores divididos por 4: davam 90/100 para um aporte que
                      // mal move a carteira, fora de escala com o ranking por objetivo
                      altScore += Math.round(shDelta * 120)
                      altScore += Math.round(sorDelta * 50)
                      altScore += Math.round(mcDelta * 3)
                      // o VaR e NEGATIVO: piorar e ficar mais negativo. Esta linha premiava a
                      // piora com +5 e punia a melhora com -3, ao contrario da linha do
                      // drawdown logo abaixo e da formula do ativo selecionado.
                      if (avar > varBefore + 0.1) altScore += 6; else if (avar < varBefore - 0.1) altScore -= 6
                      if (amdd > mddBefore + 0.1) altScore += 5; else if (amdd < mddBefore - 0.1) altScore -= 5
                      altScore = Math.max(0, Math.min(100, Math.round(altScore)))
                      alts.push({symbol: p.symbol, score: altScore, sharpe: ash, sortino: asor, mc: amc})
                    }
                  }
                  // O ativo escolhido precisa entrar na MESMA normalizacao dos
                  // concorrentes. Antes ele era pontuado por outra formula (base 50)
                  // e entrava no ranking com nota inflada mesmo piorando tudo.
                  const currentSim = {symbol: p5Ticker, score, sharpe: shAfter, sortino: sorAfter, mc: mcAfter}
                  const todos = [...alts, currentSim]
                  setP5Result({score: currentSim.score, ticker: p5Ticker, riskBefore, riskAfter, shBefore, shAfter, sorBefore, sorAfter, varBefore, varAfter, mddBefore, mddAfter, mcBefore, mcAfter})
                  const allAlts = [...todos].sort((a,b)=>b.score-a.score)
                  setP5BestAlt({...alts[0], all: allAlts})
                  setP5Loading(false)
                }}>
                  {p5Loading ? "⏳ Simulando..." : "🧬 Simular Aporte"}
                </button>
              </div>
              {p5Result && (() => {
                const r = p5Result
                const scoreColor = r.score >= 80 ? "#22c55e" : r.score >= 50 ? "#f59e0b" : r.score >= 30 ? "#f97316" : "#ef4444"
                const _dS = (r.sharpe ?? 0) - (r.shBefore ?? 0)
                const _dP = (r.mcAfter ?? 0) - (r.mcBefore ?? 0)
                // o score vem de normalizacao entre candidatos: o primeiro
                // sempre tira nota alta, mesmo piorando tudo. O veredito
                // tem de vir do sinal do delta, como no ranking
                const scoreLabel = (_dS > 0.01 && _dP > 0.05) ? "Melhora as métricas"
                  : (_dS < -0.01 && _dP < -0.05) ? "Piora as métricas" : "Impacto pequeno"
                const scoreEmoji = r.score >= 80 ? "🟢" : r.score >= 50 ? "🟡" : r.score >= 30 ? "🟠" : "🔴"
                return (
                  <div>
                    <div style={{...s.card, textAlign:"center"}}>
                      <p style={{color:"#a855f7", fontSize:12, marginBottom:4}}>🧬 CLAW DCA Intelligence™ Score</p>
                      {/* a frase diz o que aconteceu; o score depende da normalizacao
                          entre candidatos, entao vai menor */}
                      <div style={{color:scoreColor, fontSize:22, fontWeight:"bold", lineHeight:1.3}}>{scoreEmoji} {scoreLabel}</div>
                      <div style={{color:"#6b7280", fontSize:12, marginTop:4}}>Score: {r.score}/100</div>
                    </div>
                    <div style={s.card}>
                      <p style={s.cardTitle}>📊 Métricas Essenciais</p>
                      <p style={{color:"#4b5563", fontSize:9, margin:"0 0 8px 0", lineHeight:1.5}}>O veredito acima usa apenas Sharpe e Prob+. As outras aparecem como contexto e podem ir na direção oposta.</p>
                      {[
                        {label:"Sharpe", before: r.shBefore.toFixed(2), after: r.shAfter.toFixed(2), better: r.shAfter > r.shBefore},
                        {label:"Sortino", before: r.sorBefore.toFixed(2), after: r.sorAfter.toFixed(2), better: r.sorAfter > r.sorBefore},
                        {label:"Prob+ Monte Carlo", before: r.mcBefore.toFixed(1)+"%", after: r.mcAfter.toFixed(1)+"%", better: r.mcAfter > r.mcBefore},
                        {label:"VaR 95%", before: r.varBefore+"%", after: r.varAfter+"%", better: parseFloat(r.varAfter) > parseFloat(r.varBefore)},
                        {label:"Max Drawdown", before: r.mddBefore+"%", after: r.mddAfter+"%", better: parseFloat(r.mddAfter) > parseFloat(r.mddBefore)},
                      ].map((m,i) => (
                        <div key={i} style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, padding:"6px 0", borderBottom:"1px solid #1e293b"}}>
                          <span style={{color:"#9ca3af", fontSize:12}}>{m.label}</span>
                          <span style={{fontSize:12}}>
                            <span style={{color:"#6b7280"}}>{m.before}</span>
                            <span style={{color:"#4b5563"}}> → </span>
                            <span style={{color: m.before === m.after ? "#6b7280" : m.better ? "#22c55e" : "#ef4444", fontWeight:"bold"}}>{m.after}{m.before === m.after ? "" : (m.better ? " ▲" : " ▼")}</span>
                          </span>
                        </div>
                      ))}
                    </div>
                    <div style={s.card}>
                      <p style={s.cardTitle}>🛡️ Impacto Estrutural</p>
                      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0"}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Risk Contribution ({p5Ticker})</span>
                        <span style={{fontSize:12}}>
                          <span style={{color:"#6b7280"}}>{r.riskBefore.toFixed(1)}%</span>
                          <span style={{color:"#4b5563"}}> → </span>
                          <span style={{color: r.riskAfter > r.riskBefore + 2 ? "#ef4444" : "#22c55e", fontWeight:"bold"}}>{r.riskAfter.toFixed(1)}% {r.riskAfter > r.riskBefore + 2 ? "⚠️" : "✅"}</span>
                        </span>
                      </div>
                    </div>
                    {p5Result?.ticker && portfolioStats?.correlation && (() => {
                      const corr = portfolioStats?.correlation
                      const ticker = p5Result.ticker
                      const others = Object.keys(corr).filter(s => s !== ticker)
                      const naMatriz = corr[ticker] !== undefined
                      // ativos excluidos do calculo somem da matriz: sem isso eles
                      // simplesmente nao aparecem na lista, sem explicacao
                      const foraDaMatriz = etfEnriched.map(x => x.symbol).filter(sym => sym !== ticker && corr[sym] === undefined)
                      const pairs = others.map(s => ({symbol: s, corr: corr[ticker]?.[s] ?? null})).sort((a,b) => Math.abs(b.corr ?? 0) - Math.abs(a.corr ?? 0))
                      const comDado = pairs.filter(p => p.corr !== null)
                      const avgCorr = comDado.length ? comDado.reduce((s,p) => s + Math.abs(p.corr), 0) / comDado.length : null
                      return (
                        <div style={s.card}>
                          <p style={s.cardTitle}>🔗 Correlação com sua carteira</p>
                          <p style={{color: avgCorr < 0.2 ? "#22c55e" : avgCorr < 0.35 ? "#f59e0b" : "#ef4444", fontSize:12, marginBottom:8, fontWeight:700}}>{p5Ticker} x carteira: {avgCorr === null ? "sem dados" : avgCorr.toFixed(2) + " (" + (avgCorr < 0.2 ? "muito baixa" : avgCorr < 0.35 ? "baixa" : "elevada") + ")"}</p>
                          <p style={{color:"#6b7280", fontSize:10, margin:"0 0 8px 0", lineHeight:1.5}}>Perto de 0, o ativo se move independente do resto e ajuda a diversificar. Perto de 1, cai junto — não adianta como proteção.</p>
                          {!naMatriz && <p style={{color:"#f59e0b", fontSize:10, margin:"0 0 6px 0", lineHeight:1.5}}>{p5Ticker} foi excluído do cálculo por histórico insuficiente, então não há correlação medida com os demais ativos.</p>}
                          {foraDaMatriz.length > 0 && <p style={{color:"#6b7280", fontSize:10, margin:"6px 0 0 0", lineHeight:1.5}}>Fora da comparação por histórico insuficiente: {foraDaMatriz.join(", ")}</p>}
                          {pairs.map((p,i) => (
                            <div key={i} style={{display:"flex", justifyContent:"space-between", padding:"4px 0", borderBottom:"1px solid #1f2937", fontSize:12}}>
                              <span style={{color:"#9ca3af"}}>{ticker} × {p.symbol}</span>
                              <span style={{color: p.corr === null ? "#6b7280" : Math.abs(p.corr) > 0.5 ? "#ef4444" : Math.abs(p.corr) > 0.3 ? "#f59e0b" : "#22c55e", fontWeight:700}}>{p.corr === null ? "sem dados" : p.corr.toFixed(2) + " " + (Math.abs(p.corr) > 0.5 ? "🔴 Alta" : Math.abs(p.corr) > 0.3 ? "🟠 Moderada" : Math.abs(p.corr) > 0.15 ? "🟡 Baixa" : "🟢 Muito baixa")}</span>
                            </div>
                          ))}
                        </div>
                      )
                    })()}
                    {p5BestAlt && (() => {
                      const sorted = [...p5BestAlt.all].sort((a,b)=>b.score-a.score)
                      const winner = sorted[0]
                      return (
                      <div style={{...s.card, border:"1px solid rgba(34,197,94,0.3)"}}>
                        <div style={{backgroundColor:"#052e16", borderRadius:8, padding:"10px 12px", marginBottom:12, border:"1px solid rgba(34,197,94,0.4)"}}>
                          <p style={{color: (() => { const _bb = p5Result?.shBefore ?? null; return (_bb === null || sorted.some(a => (a.sharpe - _bb) > 0.01)) ? "#22c55e" : "#94a3b8" })(), fontWeight:"bold", fontSize:13, margin:"0 0 4px 0"}}>
                            {(() => {
                              // so anuncia "melhor aporte" se algum ativo de fato melhorar:
                              // a normalizacao min-max sempre coroa o primeiro, mesmo que todos piorem
                              const _b = p5Result?.shBefore ?? null
                              if (_b === null) {
                                const tied = sorted.filter(a => a.score === winner.score)
                                return tied.length > 1 ? "Melhores aportes hoje: " + tied.map(a => a.symbol).join(" e ") : "Melhor aporte hoje: " + winner.symbol
                              }
                              const _mb = p5Result?.mcBefore ?? null
                              const _up = sorted.filter(a => (a.sharpe - _b) > 0.01 && (_mb === null || (a.mc - _mb) > 0.05))
                              if (_up.length === 0) return "Nenhum ativo melhora Sharpe e Prob+ hoje"
                              if (_up.length > 1) return "Melhoram Sharpe e Prob+: " + _up.map(a => a.symbol).join(", ")
                              return "Único que melhora Sharpe e Prob+: " + _up[0].symbol
                            })()}
                          </p>
                          <div style={{fontSize:11, color:"#6b7280"}}>
                            {winner.sharpe > (p5Result?.shBefore||0) ? "↑ Sharpe +" + (winner.sharpe - (p5Result?.shBefore||0)).toFixed(2) : "→ Sharpe neutro"}
                            {" · "}
                            {winner.mc > (p5Result?.mcBefore||0) ? "↑ Prob+ +" + (winner.mc - (p5Result?.mcBefore||0)).toFixed(1) + "%" : "→ Prob+ neutro"}
                          </div>
                        </div>
                        <p style={s.cardTitle}>💡 Ranking Completo para ${p5Amount}</p>
                        {[...p5BestAlt.all].sort((a,b)=>b.score-a.score).map((alt,i) => {
                          const isSelected = alt.symbol === p5Ticker
                          // posicao pela PONTUACAO, nao pelo indice do array.
                          // um aporte pequeno nao distingue ativos com Sharpe igual
                          // na 2a casa — nesses casos o empate e a resposta honesta.
                          // faixa pelo SINAL do delta, nao pela posicao: a normalizacao
                          // min-max sempre da nota alta ao primeiro, mesmo que ele piore a carteira
                          // exige os DOIS eixos na mesma direcao: melhorar Sharpe e piorar
                          // Prob+ nao e melhora, e troca de um risco por outro
                          const _dSh = alt.sharpe - (p5Result?.shBefore ?? alt.sharpe)
                          const _dMc = alt.mc - (p5Result?.mcBefore ?? alt.mc)
                          const medal = (_dSh > 0.01 && _dMc > 0.05) ? "▲" : (_dSh < -0.01 && _dMc < -0.05) ? "▼" : "—"
                          return (
                            <div key={alt.symbol} style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 8px", marginBottom:4, borderRadius:6, backgroundColor: isSelected?"#1e1b4b":"#0f172a", border: isSelected?"1px solid #7c3aed":"1px solid transparent"}}>
                              <div style={{display:"flex", alignItems:"center", gap:6}}>
                                <span style={{fontSize:12, minWidth:20}}>{medal}</span>
                                <span style={{color: isSelected?"#a855f7":"#e2e8f0", fontWeight: isSelected?"bold":"normal", fontSize:13}}>{alt.symbol} {isSelected?"← você":"" }</span>
                              </div>
                              <div style={{textAlign:"right"}}>
                                {/* o delta e a CAUSA da posicao; o score e consequencia
                                    da normalizacao entre os candidatos, entao vai menor */}
                                <span style={{color: _dSh > 0.01 ? "#22c55e" : _dSh < -0.01 ? "#ef4444" : "#9ca3af", fontWeight:"bold", fontSize:13}}>ΔSharpe {_dSh>=0?"+":""}{_dSh.toFixed(2)}</span>
                                <span style={{color: _dMc > 0.05 ? "#22c55e" : _dMc < -0.05 ? "#ef4444" : "#9ca3af", fontWeight:"bold", fontSize:13, marginLeft:6}}>{" · "}ΔProb+ {_dMc>=0?"+":""}{_dMc.toFixed(1)}pp</span>
                                <div style={{fontSize:9, color:"#4b5563"}}>score {alt.score}/100 · Sharpe {alt.sharpe.toFixed(2)} · Prob+ {alt.mc.toFixed(1)}%</div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      )
                    })()}
                  </div>
                )
              })()}
            </div>
          )}
        </div>
      )}
      {tab === "premium5" && isPremium5 && (
        <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(168,85,247,0.2)"}}>
          <p style={{color:"#a855f7", fontSize:13, fontWeight:700, marginBottom:4}}>🎯 Qual seu objetivo com o aporte?</p>
          <p style={{color:"#9ca3af", fontSize:11, marginBottom:8}}>O ranking muda dependendo da sua estratégia.</p>
          {Object.keys(portfolioTechnical).length === 0 && <p style={{color:"#f59e0b", fontSize:11, marginBottom:12}}>⚠️ Execute "Analisar Todos" na aba 💎 para RSI real de cada ativo.</p>}
          <div style={{display:"flex", flexDirection:"column", gap:8, marginBottom:12}}>
            {[
              {id:"return", label:"🎯 Maximizar retorno", desc:"Sharpe + Prob+ Monte Carlo"},
              {id:"concentration", label:"⚖️ Reduzir concentração", desc:"HHI + beta + volatilidade"},
              {id:"defensive", label:"🛡️ Qualidade defensiva", desc:"VaR + volatilidade + beta"},
              {id:"dca", label:"💵 Melhorar preço médio", desc:"DCA Efficiency + RSI"},
              {id:"oversold", label:"📈 Aproveitar sobrevenda", desc:"RSI oversold + MACD"},
            ].map(g => (
              <button key={g.id} onClick={() => { setP5Goal(g.id); setP5GoalResult(null) }} style={{...s.addBtn, background: p5Goal===g.id ? "linear-gradient(135deg, #7c3aed, #a855f7)" : "#1f2937", textAlign:"left", padding:"10px 14px"}}>
                <div style={{fontSize:13, fontWeight:700}}>{g.label}</div>
                <div style={{fontSize:11, color: p5Goal===g.id ? "#e9d5ff" : "#6b7280", marginTop:2}}>{g.desc}</div>
              </button>
            ))}
          </div>
          {p5Goal && (
            <button disabled={p5GoalLoading} onClick={async () => {
              setP5GoalLoading(true); setP5GoalResult(null)
              const amount = numBR(p5Amount) || 500
              const tv = etfEnriched.reduce((s,p)=>s+(p.value||0),0)
              // Fetch RSI for each asset sequentially
              const rsiData = {}
              if (p5Goal === "dca" || p5Goal === "oversold") {
                for (const ep of etfEnriched) {
                  try {
                    const r = await fetch(API_URL + "/technical/" + ep.symbol, { headers: hdrAuth() })
                    const d = await r.json()
                    if (d && d.rsi) rsiData[ep.symbol] = {rsi: parseFloat(d.rsi), macd: d.macd?.signal_label || null}
                  } catch(e) {}
                }
              }
              // nao existe else: o rsiData so e lido pelo
              // rankingLocal logo abaixo, dentro da MESMA
              // condicao dca/oversold. O else que existia
              // aqui montava um rsiData SEM macd que ninguem
              // lia: os outros objetivos passam pela simulacao
              // completa e nao consultam este objeto.
              // Achado na varredura de 10/10/2026.
              const shBefore = parseFloat(portfolioStats?.sharpe_ratio)||0
              const varBefore = parseFloat(portfolioStats?.var_95)||0
              const mddBefore = parseFloat(portfolioStats?.max_drawdown)||0
              const mcBefore = parseFloat(portfolioStats?.monte_carlo?.prob_positive)||0
              const hhiBefore = parseFloat(portfolioStats?.hhi)||0.5
              const sorBefore = parseFloat(portfolioStats?.sortino_ratio)||0
              const results = []
              // For dca/oversold goals, calculate without portfolio-stats2 fetch
              if (p5Goal === "dca" || p5Goal === "oversold") {
                setP5GoalResult(rankingLocal(etfEnriched, rsiData, p5Goal, portfolioStats))
                setP5GoalLoading(false)
                return
              }
              for (const p of etfEnriched) {
                if (!p.currentPrice || p.currentPrice <= 0) continue
                const nq = amount / p.currentPrice
                const modPos = etfEnriched.map(x => x.symbol === p.symbol
                  ? {symbol:x.symbol, current_price:x.currentPrice, quantity:(x.quantity||0)+nq, avg_price:((x.quantity||0)*x.avg_price+amount)/((x.quantity||0)+nq)}
                  : {symbol:x.symbol, current_price:x.currentPrice, quantity:x.quantity, avg_price:x.avg_price}
                )
                let sh = shBefore, vr = varBefore, mdd = mddBefore, mc = mcBefore, hhi = hhiBefore, sor = sorBefore
                try {
                  const res = await fetch(API_URL + "/portfolio-stats2", {method:"POST", headers:{"Content-Type":"application/json", ...hdrAuth()}, body:JSON.stringify({positions:modPos})})
                  const after = await res.json()
                  if (after && !after.error) {
                    sh = parseFloat(after.sharpe_ratio)||shBefore
                    vr = parseFloat(after.var_95)||varBefore
                    mdd = parseFloat(after.max_drawdown)||mddBefore
                    mc = parseFloat(after.monte_carlo?.prob_positive)||mcBefore
                    hhi = parseFloat(after.hhi)||hhiBefore
                    sor = parseFloat(after.sortino_ratio)||sorBefore
                  }
                } catch(e) {}
                const posValue = (p.quantity||0)*p.currentPrice
                const riskB = posValue/tv*100
                const hhiDelta = hhiBefore - hhi
                const vrDelta = varBefore - vr
                const mddDelta = mddBefore - mdd
                let score = 0
                const shDeltaG = sh - shBefore; const mcDeltaG = mc - mcBefore; if (p5Goal==="return") { score = 50 + Math.round(shDeltaG * 120) + Math.round((sor - sorBefore) * 50) + Math.round(mcDeltaG * 3); if (vr > varBefore + 0.1) score += 6; else if (vr < varBefore - 0.1) score -= 6; if (mdd > mddBefore + 0.1) score += 5; else if (mdd < mddBefore - 0.1) score -= 5 } else if (p5Goal==="concentration") { score = Math.round(Math.min(100, Math.max(0, 50 - riskB * 1.5 + (hhiDelta > 0 ? hhiDelta * 300 : 0)))) } else if (p5Goal==="defensive") { score = Math.round(Math.min(100, Math.max(0, 50 - riskB * 0.8 + (vrDelta > 0 ? vrDelta * 8 : 0) + (mddDelta > 0 ? mddDelta * 5 : 0)))) }
                results.push({symbol:p.symbol, score:Math.round(Math.min(100,Math.max(0,score))), sharpe:sh, shBefore:shBefore, mc, mcBefore:mcBefore, vr, varBefore, hhi, hhiBefore, rsi:"—"})
              }
              results.sort((a,b)=>b.score-a.score)
              setP5GoalResult(results)
              setP5GoalLoading(false)
            }} style={{...s.addBtn, background:"linear-gradient(135deg, #7c3aed, #a855f7)", width:"100%", opacity:p5GoalLoading?0.6:1}}>
              {p5GoalLoading ? "⏳ Calculando..." : "🎯 Gerar Ranking Personalizado"}
            </button>
          )}
          {p5GoalResult && (
            <div style={{marginTop:12}}>
              <p style={{...s.cardTitle, color:"#a855f7"}}>🏆 Ranking para seu objetivo</p>
              <p style={{color:"#4b5563", fontSize:9, margin:"0 0 6px 0"}}>{(p5Goal !== "return")
                ? "Escala de 0 a 100 de quanto o ativo serve "
                  + "ao objetivo. Zero é nenhum benefício, "
                  + "NÃO que o aporte atrapalhe: aqui não há "
                  + "comparação com não aportar."
                : "50 = nenhuma mudança. Acima disso o aporte "
                  + "ajuda no objetivo escolhido; abaixo, "
                  + "atrapalha."}</p>
              {p5Goal === "oversold" && p5GoalResult.length > 0 && !p5GoalResult.some(r => parseFloat(r.rsi) < 30) && (
                <p style={{color:"#f59e0b", fontSize:10, margin:"0 0 8px 0", lineHeight:1.5}}>Nenhum ativo está sobrevendido hoje (RSI abaixo de 30). O ranking mostra quem está mais próximo disso, não uma condição de sobrevenda real.</p>
              )}
              {p5Goal === "dca" && p5GoalResult.length > 0 && (
                <p style={{color:"#f59e0b", fontSize:10, margin:"0 0 8px 0", lineHeight:1.5}}>Este ranking ordena por quanto o preço está abaixo do seu custo — lidera onde você mais perdeu. Isso reduz o preço médio, mas costuma aumentar a concentração: compare com o Risk Contribution da aba 💎 antes de decidir.</p>
              )}
              {p5GoalResult.map((r,i) => {
                // mesma regra do ranking principal: posicao pela pontuacao,
                // com marca de empate quando os scores coincidem
                const _dS = (r.shBefore !== undefined) ? (r.sharpe - r.shBefore) : null
                const _dM = (r.mcBefore !== undefined) ? (r.mc - r.mcBefore) : null
                const _vB = (r.varBefore !== undefined) ? (r.vr - r.varBefore) : null
                const _mB = (r.shBefore !== undefined) ? (r.sharpe - r.shBefore) : null
                // no objetivo defensivo a seta tem de seguir VaR e MaxDD,
                // que sao os numeros mostrados ao lado — nao Sharpe e Prob+
                // em concentracao, melhorar e o valor CAIR (HHI e risco),
                // por isso o sinal entra invertido
                const _hB = (r.hhiBefore !== undefined) ? -(r.hhi - r.hhiBefore) : null
                const _rB = (r.shBefore !== undefined) ? -(r.sharpe - r.shBefore) : null
                const _a = (p5Goal === "defensive") ? _vB : (p5Goal === "concentration") ? _hB : _dS
                const _b = (p5Goal === "defensive") ? _mB : (p5Goal === "concentration") ? _rB : _dM
                // o HHI se move na casa dos milesimos: usar 0.01 aqui
                // zerava todas as setas
                const _lim = (p5Goal === "concentration") ? 0.001 : (p5Goal === "defensive") ? 0.005 : 0.01
                // dca e sobrevenda nao simulam a carteira: nao ha delta para
                // a seta ler, entao ela segue o proprio score
                const medal = (p5Goal === "dca" || p5Goal === "oversold")
                  ? (r.score >= 60 ? "▲" : r.score <= 40 ? "▼" : "—")
                  : (_a === null || _b === null) ? "—" : (_a > _lim && _b > _lim) ? "▲" : (_a < -_lim && _b < -_lim) ? "▼" : "—"
                return (
                  <div key={r.symbol} style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 8px", marginBottom:4, borderRadius:6, backgroundColor:"#0f172a"}}>
                    <div style={{display:"flex", alignItems:"center", gap:6}}>
                      <span style={{fontSize:12, minWidth:20}}>{medal}</span>
                      <span style={{color:"#e2e8f0", fontSize:13}}>{r.symbol}</span>
                    </div>
                    <div style={{textAlign:"right", display:"flex", flexDirection:"column-reverse", alignItems:"flex-end"}}>
                      <div style={{fontSize:11, color:"#6b7280", lineHeight:1.6}}>
                        {(() => {
                          const hi = (good, label) => <span style={{color:good?"#22c55e":"#ef4444", fontWeight:700, backgroundColor:"rgba(255,255,255,0.06)", padding:"1px 4px", borderRadius:4, marginRight:4}}>{label}</span>
                          const nm = (label) => <span style={{color:"#9ca3af", marginRight:4}}>{label}</span>
                          const dSh = r.shBefore !== undefined ? r.sharpe - r.shBefore : null
                          const dMc = r.mcBefore !== undefined ? r.mc - r.mcBefore : null
                          const dca = r.dcaImprove !== undefined ? parseFloat(r.dcaImprove) : null
                          const dVar = r.varBefore !== undefined ? r.vr - r.varBefore : null
                          const dHhi = r.hhiBefore !== undefined ? r.hhi - r.hhiBefore : null
                          const rsiVal = r.rsi !== "—" ? parseFloat(r.rsi) : null
                          return <div style={{display:"flex", flexWrap:"wrap"}}>
                            {p5Goal==="return" && dSh!==null && hi(dSh>0,`ΔSharpe ${dSh>0?"+":""}${dSh.toFixed(2)}`)}
                            {p5Goal==="return" && dMc!==null && hi(dMc>0,`ΔProb+ ${dMc>0?"+":""}${dMc.toFixed(1)}%`)}
                            {p5Goal==="concentration" && dHhi!==null && hi(dHhi<0,`ΔHHI ${dHhi>0?"+":""}${dHhi.toFixed(3)}`)}
                            {p5Goal==="concentration" && dSh!==null && nm(`ΔRisk ${dSh>0?"+":""}${dSh.toFixed(2)}`)}
                            {p5Goal==="defensive" && dVar!==null && hi(dVar>0,`ΔVAR ${dVar>0?"+":""}${dVar.toFixed(2)}%`)}
                            {p5Goal==="defensive" && dSh!==null && nm(`ΔMaxDD ${dSh>0?"+":""}${dSh.toFixed(2)}`)}
                            {(p5Goal==="dca"||p5Goal==="oversold") && rsiVal!==null && hi(rsiVal<40,`RSI ${r.rsi}`)}
                            {p5Goal==="dca" && dca!==null && hi(dca>0,`${dca.toFixed(1)}% abaixo do custo`)}
                            {p5Goal==="oversold" && r.macd && hi(r.macd.toLowerCase()==="bullish"||r.macd.toLowerCase()==="alta",`MACD ${r.macd}`)}
                          </div>
                        })()}
                      </div>
                      <span style={{color:"#4b5563", fontSize:9}}>score {r.score}/100</span>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          {medStub("ov", acertosOv, "🎯 Acertos da sobrevenda")}
          {acertosOv && medAbre("ov", acertosOv) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🎯 Acertos da sobrevenda</p>
              {acertosOv.total === 0 ? (
                <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
                  O objetivo "aproveitar sobrevenda" dá a cada ativo uma pontuação de 0 a
                  100, que cresce quanto mais baixo estiver o RSI, com um bônus se o MACD
                  estiver comprador. A ideia por trás dela é que um ativo que caiu demais costuma
                  subir de volta em seguida. O app anota essa pontuação e o preço uma vez por dia para cada
                  ativo da carteira e, 30 dias depois, compara quanto renderam os que
                  pontuaram 60 ou mais contra os que pontuaram 40 ou menos, e os dois
                  contra a média de todos os ativos anotados. Se esses três retornos
                  médios ficarem parecidos, a pontuação não está antecipando a recuperação.
                  Ainda não há registros com 30 dias.
                </p>
              ) : (
                <div>
                  {acertosOv.total < 20 && (
                    <p style={{color:"#f59e0b", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                      ⚠️ Base pequena ({acertosOv.total}): estes números ainda não separam
                      acerto de sorte. São registro em formação, não medida de desempenho.
                    </p>
                  )}
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                    Nota 60+: retorno médio em 30 dias{" "}
                    {acertosOv.altoMed === null ? "sem dados" : acertosOv.altoMed.toFixed(1) + "%"}
                    {" "}({acertosOv.altoN}{acertosOv.altoN < 3 ? " — amostra insuficiente" : ""})
                  </p>
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                    Nota até 40: retorno médio em 30 dias{" "}
                    {acertosOv.baixoMed === null ? "sem dados" : acertosOv.baixoMed.toFixed(1) + "%"}
                    {" "}({acertosOv.baixoN}{acertosOv.baixoN < 3 ? " — amostra insuficiente" : ""})
                  </p>
                  <p style={{color:"#4b5563", fontSize:11, margin:"0 0 8px 0", lineHeight:1.5}}>
                    Linha de base: {acertosOv.baseMed === null ? "sem dados" : acertosOv.baseMed.toFixed(1) + "%"}
                    {" "}sem olhar a nota. Se as faixas não se afastarem disso, a nota de
                    sobrevenda não está acrescentando nada.
                  </p>
                  {(() => {
                    const _v = vereditoSeparacao(acertosOv, "a nota de sobrevenda")
                    return <p style={{color:_v.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_v.txt}</p>
                  })()}
                  <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                    Base: {acertosOv.total} registros com 30 dias completos{" "}{AVISO_DENOM}
                  </p>
                </div>
              )}
            </div>
          )}
          {medStub("premio", premioQ, "🏦 Ágio e deságio dos fundos")}
          {premioQ && medAbre("premio", premioQ) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🏦 Ágio e deságio dos fundos</p>
              {premioQ.total === 0 ? (
                <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
                  Um ETF negocia a um preço e vale outro: o NAV, que é o valor dos ativos
                  que o fundo guarda por cota. A diferença entre os dois é o ágio, quando o
                  preço está acima, ou o deságio, quando está abaixo. A afirmação em teste
                  é que o ágio denuncia pressão compradora que a emissão de cotas não
                  absorveu, e que por isso ele antecede retorno maior. Este é o primeiro
                  número do app que NÃO sai do preço: os outros doze quesitos são todos
                  transformações da mesma série de cotações, e o NAV vem de outro lugar.
                  O app grava NAV, patrimônio e fechamento de 14 fundos todo pregão
                  desde 30/10/2026, e treze deles publicam NAV — o XRPR não publica, então
                  entra na tabela e fica fora desta medição. O ágio é medido DENTRO de cada
                  fundo, contra a média dele
                  mesmo: quem cobra taxa de administração alta negocia com deságio crônico,
                  e comparar fundos entre si mediria taxa, não pressão. Faltam{" "}
                  {premioQ.minLeituras} pregões de cada fundo para existir média e desvio
                  padrão, e mais 30 para o primeiro resultado.
                </p>
              ) : (
                <div>
                  {premioQ.total < 40 && (
                    <p style={{color:"#f59e0b", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                      ⚠️ Base pequena ({premioQ.total}): é registro em formação, não
                      medida de desempenho.
                    </p>
                  )}
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                    Com ágio: retorno médio em 30 pregões{" "}
                    {premioQ.agioMed === null ? "sem dados" : premioQ.agioMed.toFixed(2) + "%"}
                    {" "}({premioQ.agioN} leituras)
                  </p>
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                    Com deságio: retorno médio em 30 pregões{" "}
                    {premioQ.desagioMed === null ? "sem dados" : premioQ.desagioMed.toFixed(2) + "%"}
                    {" "}({premioQ.desagioN} leituras)
                  </p>
                  <p style={{color:"#4b5563", fontSize:11, margin:"0 0 8px 0", lineHeight:1.5}}>
                    Linha de base: {premioQ.baseMed === null ? "sem dados" : premioQ.baseMed.toFixed(2) + "%"}
                    {" "}sem olhar o ágio. Fundos que apontam para o mesmo lado:{" "}
                    {premioQ.concordam} de {premioQ.concordTot} — abaixo de 70% a medição
                    não vale, porque seria um fundo puxando o total.
                  </p>
                  {(() => {
                    const _v = vereditoPremio(premioQ)
                    return <p style={{color:_v.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_v.txt}</p>
                  })()}
                  <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                    Base: {premioQ.total} leituras com 30 pregões completos em{" "}
                    {premioQ.tickersN} fundos{" "}{AVISO_DENOM}
                  </p>
                </div>
              )}
              <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0", lineHeight:1.5}}>
                Limitação declarada hoje, antes do primeiro resultado: com horizonte de 30
                pregões e barra de 1 ponto percentual, um ágio que só valha para o dia
                seguinte fica invisível, porque o efeito dilui na janela. O horizonte não
                vai ser trocado depois de ver o número.
              </p>
            </div>
          )}
          {(() => {
            if (medAberta.res !== true) return (
              <button onClick={() => setMedAberta(x => ({...x, res: true}))} style={{...s.card, display:"flex", justifyContent:"space-between", alignItems:"center", width:"100%", border:"none", cursor:"pointer", textAlign:"left"}}>
                <span style={{color:"#e5e7eb", fontSize:13}}>🏁 Resumo das medições do app</span>
                <span style={{color:"#6b7280", fontSize:10}}>toque para abrir</span>
              </button>
            )
            // Nenhuma regra nova aqui: as funcoes de veredito devolvem
            // 'estado' e este card so conta. Era o motivo de mover as dez
            // regras para funcoes ANTES de escrever o resumo.
            const _cb = (o, k, nome) => {
              const d = (o && o.por && o.por[k]) ? o.por[k] : { alta: 0, altaOk: 0, baixa: 0, baixaOk: 0 }
              return vereditoContraBase(d.alta, d.altaOk, d.baixa, d.baixaOk, o ? o.subiu : 0, o ? o.comparadas : 0, nome)
            }
            const linhas = [
              { rot: "Confluence · ⭐", v: acertos ? vereditoContraBase(acertos.altaTot, acertos.altaOk, acertos.baixaTot, acertos.baixaOk, acertos.subiu, acertos.comparadas, "o Confluence") : vereditoContraBase(0, 0, 0, 0, 0, 0, "o Confluence") },
              { rot: "Confluence no mesmo ativo · ⭐", v: (amostraVer && amostraVer.confluence) ? amostraVer.confluence : { estado: "sem base", txt: "Carregando…", cor: "#6b7280" } },
              { rot: "Resumo por tempo gráfico · ⭐", v: _cb(acertosMtf, "mtf_dia", "o resumo técnico no diário") },
              { rot: "Exaustão de direção · ⭐", v: vereditoExaustao(exDir) },
              { rot: "Confluence por regime · ⭐", v: vereditoPorRegime(porRegime) },
              { rot: "Scores por regime · ⭐", v: vereditoScoresRegime(scoresRegime) },
              { rot: "Advanced Score · ⚡", v: vereditoSeparacao(acertosAv, "o Advanced Score") },
              { rot: "Oscilador 5/34 · ⚡", v: _cb(acertosEw, "ew_dia", "o veredito do diário") },
              { rot: "Nota do DCA · 🧠", v: vereditoSeparacao(acertosDca, "a nota do DCA") },
              { rot: "Nota de sobrevenda · 🧬", v: vereditoSeparacao(acertosOv, "a nota de sobrevenda") },
              { rot: "Ágio e deságio · 🧬", v: vereditoPremio(premioQ) },
          { rot: "Virada de regime · ⚡", v: regimeVer || { estado: "sem base", txt: "Carregando…", cor: "#6b7280" } },
          { rot: "CLAW Signal · ⚡", v: !sinalVer ? { estado: "sem base", txt: "Carregando…", cor: "#6b7280" } : sinalVer.estado === "acrescenta" ? { estado: "acrescenta", txt: "", cor: "#22c55e" } : sinalVer.estado === "vai ao contrario" ? { estado: "vai ao contrário", txt: "", cor: "#ef4444" } : sinalVer.estado === "sem base" ? { estado: "sem base", txt: "", cor: "#6b7280" } : { estado: "não acrescenta", txt: "", cor: "#f59e0b" } },
            ]
            const comBase = linhas.filter(x => x.v.estado !== "sem base").length
            const mais = linhas.filter(x => x.v.estado === "acrescenta").length
            const menos = linhas.filter(x => x.v.estado === "ao contrário").length
            const escore = comBase === 0 ? null : Math.round(50 + 50 * (mais - menos) / comBase)
            return (
              <div>
              <button onClick={() => setMedAberta(x => ({...x, res: false}))} style={{display:"block", width:"100%", textAlign:"right", background:"transparent", border:"none", color:"#6b7280", fontSize:10, cursor:"pointer", padding:"0 2px 4px 0"}}>▲ recolher</button>
              <div style={s.card}>
                <p style={s.cardTitle}>🏁 Resumo das medições do app</p>
                <p style={{color:"#6b7280", fontSize:11, lineHeight:1.5, margin:"0 0 10px 0"}}>
                  As {linhas.length} medições espalhadas pelas abas, num lugar só. O escore NÃO é média de taxas de acerto — acerto de direção, teste de separação e calibração não se somam. Ele conta vereditos: cada quesito com base vale mais um se acrescenta, menos um se vai ao contrário, e zero se não acrescenta. Cinquenta é medido e empatado no líquido; sem base é ainda não se sabe, e fica fora do denominador.
                </p>
                <p style={{margin:0, fontSize:15, fontWeight:700, color: escore === null ? "#6b7280" : escore > 55 ? "#22c55e" : escore < 45 ? "#ef4444" : "#f59e0b"}}>
                  {escore === null ? "⚪ Sem base ainda" : escore > 55 ? "🟢 Acrescentando" : escore < 45 ? "🔴 Ao contrário" : "🟡 Empatado no líquido"}
                </p>
                <p style={{margin:"2px 0 0 0", fontSize:22, fontWeight:800, color:"#e5e7eb"}}>
                  {escore === null ? "Score: —" : "Score: " + escore + "/100"}
                </p>
                <p style={{color:"#6b7280", fontSize:11, margin:"2px 0 10px 0"}}>
                  {comBase === 0
                    ? "Nenhum quesito chegou à base mínima ainda."
                    : comBase + " de " + linhas.length + " quesitos com base · " + mais + " acrescentam, " + menos + " vão ao contrário, " + (comBase - mais - menos) + " não acrescentam"}
                </p>
                {comBase > 0 && comBase < 4 && (
                  <p style={{color:"#4b5563", fontSize:10, margin:"0 0 10px 0", lineHeight:1.5}}>
                    Com {comBase} {comBase === 1 ? "quesito" : "quesitos"} com base, o escore só pode assumir {2 * comBase + 1} valores distintos — não leia precisão que não existe. Ele ganha resolução conforme os outros chegarem aos 30 dias.
                  </p>
                )}
                <p style={{color:"#4b5563", fontSize:10, lineHeight:1.5, margin:"0 0 10px 0"}}>
                  Vale para o escore inteiro: os registros das {linhas.length} medições são diários e as janelas de resultado se sobrepõem, então os denominadores contam mais observações do que existe informação independente. O portão de dois desvios padrão que separa acrescenta de não acrescenta supõe independência — logo ele abre antes do que deveria.
                </p>
                <button disabled={resumoLoading} onClick={async () => {
                  setResumoLoading(true)
                  try {
                    await Promise.all([carregarAcertos(), carregarAcertosMtf(), carregarExDir(), carregarPorRegime(), carregarScoresRegime(), carregarCalibMc(), carregarAcertosAv(), carregarAcertosEw(), carregarAcertosDca(), carregarAcertosOv()])
                  } catch (err) {}
                  setResumoLoading(false)
                }} style={{width:"100%", padding:"10px", borderRadius:8, border:"1px solid #374151", background:"transparent", color:"#e5e7eb", fontSize:12, fontWeight:600, cursor:"pointer", marginBottom:10, opacity:resumoLoading ? 0.5 : 1}}>
                  {resumoLoading ? "⏳ Carregando as " + linhas.length + " medições..." : "🔄 Carregar as " + linhas.length + " medições"}
                </button>
                {linhas.map(x => (
                  <div key={x.rot} style={{display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, borderTop:"1px solid #1f2937", padding:"5px 0"}}>
                    <span style={{color:"#9ca3af", fontSize:11}}>{x.rot}</span>
                    <span style={{color:x.v.cor, fontSize:11, fontWeight:600, textAlign:"right"}}>{x.v.estado}</span>
                  </div>
                ))}
                <p style={{color:"#4b5563", fontSize:10, lineHeight:1.5, margin:"10px 0 0 0"}}>
                  Cada linha vem da mesma função que escreve o veredito dentro do card de origem, então as duas nunca podem discordar.
                </p>
              </div>
              </div>
            )
          })()}
        </div>
      )}


      {tab === "openclaw" && (
        <div>
          <div style={{...s.card, textAlign:"center", padding:24, background:"linear-gradient(135deg, #0f172a, #1e1b4b)", border:"1px solid #6366f133"}}>
            <div style={{marginBottom:8, lineHeight:0}}><svg viewBox="0 0 100 100" width="64" height="64" fill="none" stroke="currentColor" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round"><path d="M72 24 A34 34 0 1 0 72 76"/><path d="M72 76 Q58 66 62 50"/></svg></div>
            <h2 style={{color:"#a5b4fc", fontSize:22, fontWeight:"bold", margin:"0 0 4px 0"}}>OpenClaw</h2>
            <p style={{color:"#6366f1", fontSize:11, margin:"0 0 12px 0", fontStyle:"italic", letterSpacing:2}}>AI AGENT PLATFORM</p>
            <p style={{color:"#cbd5e1", fontSize:13, lineHeight:1.6, marginBottom:16}}>Seu agente OpenClaw já está conectado ao ClawETF: pergunte pela carteira no WhatsApp e ele responde com posições e P&L atualizados. As análises automáticas diárias continuam chegando pelo Telegram configurado abaixo.</p>
            <a href="https://t.me/clawetf" target="_blank" rel="noreferrer"
              style={{display:"block", background:"linear-gradient(135deg, #0088cc, #29b6f6)", color:"#fff", padding:"12px 24px", borderRadius:12, textAlign:"center", textDecoration:"none", fontWeight:"bold", fontSize:14, marginBottom:8}}>
              📢 Seguir Canal @clawetf no Telegram
            </a>
            <a href="https://openclaw.ai" target="_blank" rel="noreferrer"
              style={{display:"block", background:"linear-gradient(135deg, #6366f1, #8b5cf6)", color:"#fff", padding:"12px 24px", borderRadius:12, textAlign:"center", textDecoration:"none", fontWeight:"bold", fontSize:14, marginBottom:4}}>
              🔗 Instalar OpenClaw
            </a>
          </div>

          <div style={s.card}>
            <p style={s.cardTitle}>⚡ Como conectar</p>
            <div style={{padding:"12px 0", borderBottom:"1px solid #1f2937"}}>
              <div style={{display:"flex", gap:12, alignItems:"center", marginBottom:8}}>
                <div style={{width:32, height:32, borderRadius:"50%", backgroundColor:"#6366f1", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:14, fontWeight:"bold"}}>1</div>
                <p style={{color:"#e5e7eb", fontSize:13, fontWeight:"bold", margin:0}}>📱 Configure seu canal</p>
              </div>
              <div style={{display:"flex", gap:8, marginLeft:44}}>
                <a href="https://t.me/BotFather" target="_blank" rel="noreferrer" style={{flex:1, backgroundColor:"#6366f122", color:"#a5b4fc", fontSize:12, padding:"8px", borderRadius:8, textAlign:"center", textDecoration:"none", fontWeight:"bold"}}>
                  📲 Telegram<br/><span style={{fontSize:10, fontWeight:"normal"}}>BotFather</span>
                </a>
              </div>
            </div>
          </div>

          <div id="conectar-token" style={s.card}>
            <p style={s.cardTitle}>🔔 Canais Conectados</p>
            <p style={{color:"#9ca3af", fontSize:12, marginBottom:12, lineHeight:1.5}}>Pergunte pela carteira nos dois. O Telegram também envia as análises automáticas diárias.</p>
            {!isPremium ? (
              <div style={{backgroundColor:"#1f2937", borderRadius:10, padding:12, textAlign:"center"}}>
                <p style={{color:"#f59e0b", fontSize:12, margin:"0 0 8px 0"}}>⭐ Recurso Premium</p>
                <p style={{color:"#6b7280", fontSize:12, margin:"0 0 12px 0"}}>Assine o Premium para conectar seus canais</p>
                <button onClick={() => setTab("premium")} style={{...s.addBtn, padding:"10px 16px", fontSize:13}}>Ver Premium</button>
              </div>
            ) : (
              <div>
                <div style={{borderLeft:"3px solid #22c55e", paddingLeft:12, marginBottom:16}}>
                  <p style={{color:"#e5e7eb", fontSize:13, fontWeight:"bold", margin:"0 0 4px 0"}}>
                    📲 WhatsApp <span style={{color:"#22c55e", fontSize:11}}>● Conectado</span>
                  </p>
                </div>
                <div style={{borderLeft:"3px solid #6366f1", paddingLeft:12, marginBottom:16}}>
                  <p style={{color:"#e5e7eb", fontSize:13, fontWeight:"bold", margin:"0 0 4px 0"}}>
                    📲 Telegram {connectionSaved.telegram && <span style={{color:"#22c55e", fontSize:11}}>● Conectado</span>}
                  </p>
                  <p style={{color:"#6b7280", fontSize:11, marginBottom:8}}>Cole seu Chat ID do Telegram (mande /start para @userinfobot para descobrir)</p>
                  <input value={telegramId} onChange={e => setTelegramId(e.target.value)} placeholder="Ex: 123456789" style={{...s.input, marginBottom:8}} />
                  <button onClick={() => saveConnection("telegram", telegramId)} style={{...s.addBtn, padding:"10px 16px", fontSize:13}} disabled={savingConnection==="telegram"}>
                    {savingConnection==="telegram" ? "Salvando..." : connectionSaved.telegram ? "✅ Atualizar Telegram" : "📲 Conectar Telegram"}
                  </button>
                </div>
              </div>
            )}
          </div>

          <div style={{...s.card, background:"linear-gradient(135deg, #0f172a, #1e1b4b)", border:"1px solid #6366f133", textAlign:"center"}}>
            <p style={{color:"#4b5563", fontSize:10, margin:0}}>© 2026 Signal Forge. All rights reserved. ClawETF™, CLAW™, CLAW AI™, CLAW Optimizer™, CLAW Advanced Analytics™, ClawETF Premium Score™, CLAW DCA Intelligence™, CLAW DCA Efficiency Score™, CLAW Diversification Engine™, CLAW Confluence Score™ e CLAW Exhaustion Score™ são marcas e tecnologias proprietárias da Signal Forge.</p>
          </div>
        </div>
      )}

      {isPremium3 && (
        <>
          <button
            onTouchStart={e => {
              btnDragging.current = false
              const el = e.currentTarget
              el.style.transition = "none"
              const touch = e.touches[0]
              btnOffset.current = {x: touch.clientX - btnPos.x, y: touch.clientY - btnPos.y}
              const onMove = ev => {
                ev.preventDefault()
                btnDragging.current = true
                const t = ev.touches[0]
                setBtnPos({
                  x: Math.max(0, Math.min(window.innerWidth - 36, t.clientX - btnOffset.current.x)),
                  y: Math.max(0, Math.min(window.innerHeight - 36, t.clientY - btnOffset.current.y))
                })
              }
              const onEnd = () => {
                document.removeEventListener("touchmove", onMove)
                document.removeEventListener("touchend", onEnd)
                // Encaixe na borda, como na Binance e na KuCoin: solto no meio da
                // tela o botao cobre conteudo em qualquer rolagem seguinte, e o
                // usuario nao lembra que foi ele que o deixou ali. A altura
                // escolhida fica; so o lado volta para a margem. Toque sem arrasto
                // nao encaixa nada, so abre o chat. A margem e 12 e nao 8 porque o
                // losango e um quadrado girado: a diagonal e mais larga que o lado.
                if (!btnDragging.current) return
                el.style.transition = "left 0.18s ease-out"
                setBtnPos(p => ({...p, x: (p.x + 18) < (window.innerWidth / 2) ? 10 : window.innerWidth - 46}))
              }
              document.addEventListener("touchmove", onMove, {passive:false})
              document.addEventListener("touchend", onEnd)
            }}
            onClick={() => { if (!btnDragging.current) setChatOpen(o => !o) }}
            style={{
              position:"fixed", left: btnPos.x, top: btnPos.y, zIndex:1000,
              width:36, height:36, borderRadius:10,
              background:"linear-gradient(145deg, #FFD95A, #F0B429)",
              border:"none", cursor:"pointer", padding:0,
              transform:"rotate(45deg)",
              boxShadow:"0 3px 10px rgba(240,180,41,0.4)",
              display:"flex", alignItems:"center", justifyContent:"center",
              touchAction:"none"
            }}
            title="CLAW AI Assistant"
          >
            {/* O losango e um quadrado girado 45 graus; o rosto gira -45 para
                ficar em pe. As palpebras piscam por keyframes, nao por estado,
                para nao redesenhar a arvore a cada 4 segundos. */}
            <span style={{transform:"rotate(-45deg)", display:"flex", flexDirection:"column", alignItems:"center", gap:2}}>
              <span style={{display:"flex", gap:5}}>
                <span style={{width:3, height:6, borderRadius:1.5, background:"#3b2f00", animation:"claw-blink 4.6s infinite"}} />
                <span style={{width:3, height:6, borderRadius:1.5, background:"#3b2f00", animation:"claw-blink 4.6s infinite"}} />
              </span>
              <span style={{width:9, height:4, borderBottom:"2px solid #3b2f00", borderRadius:"0 0 9px 9px"}} />
            </span>
          </button>

          {chatOpen && (
            <div style={{
              position:"fixed", bottom:84, right:20, zIndex:1000,
              width:320, maxWidth:"calc(100vw - 40px)",
              background:"linear-gradient(160deg,#07080f,#0c0e1a)",
              border:"1px solid rgba(99,102,241,0.4)",
              borderRadius:16, boxShadow:"0 8px 32px rgba(0,0,0,0.6)",
              display:"flex", flexDirection:"column", overflow:"hidden"
            }}>
              <div style={{
                display:"flex", alignItems:"center", justifyContent:"space-between",
                padding:"10px 14px", background:"linear-gradient(135deg,#4f46e5,#0891b2)",
                borderRadius:"16px 16px 0 0"
              }}>
                <span style={{fontWeight:"bold", fontSize:13, color:"#fff", fontFamily:"'Georgia',serif"}}>💠 CLAW AI Assistant <span style={{fontSize:10, padding:"2px 7px", borderRadius:20, fontWeight:"bold", backgroundColor: mktColor + "33", color: mktColor, marginLeft:6}}>{marketStatus.label}</span></span>
                <button onClick={() => setChatOpen(false)} style={{background:"none",border:"none",cursor:"pointer",color:"#fff",fontSize:16,lineHeight:1,padding:2}}>✕</button>
              </div>

              <div style={{
                flex:1, overflowY:"auto", padding:"10px 12px",
                display:"flex", flexDirection:"column", gap:8,
                minHeight:200, maxHeight:340
              }}>
                {chatMessages.length === 0 && (
                  <p style={{color:"#475569", fontSize:12, textAlign:"center", margin:"auto 0", fontStyle:"italic"}}>
                    Ask me anything about crypto ETFs, portfolio metrics or market conditions.
                  </p>
                )}
                {chatMessages.map((m, i) => (
                  <div key={i} style={{
                    alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                    maxWidth:"85%",
                    background: m.role === "user" ? "linear-gradient(135deg,#4f46e5,#6366f1)" : "rgba(255,255,255,0.06)",
                    borderRadius: m.role === "user" ? "12px 12px 2px 12px" : "12px 12px 12px 2px",
                    padding:"8px 10px",
                    fontSize:12, color:"#e2e8f0", lineHeight:1.5,
                    whiteSpace:"pre-wrap", wordBreak:"break-word"
                  }}>
                    {m.content}
                  </div>
                ))}
                {chatLoading && (
                  <div style={{alignSelf:"flex-start", color:"#6366f1", fontSize:12, fontStyle:"italic"}}>CLAW AI is thinking…</div>
                )}
              </div>

              <div style={{display:"flex", gap:6, padding:"8px 10px", borderTop:"1px solid rgba(255,255,255,0.06)"}}>
                <input
                  value={chatInput}
                  onChange={e => setChatInput(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendChatMessage() } }}
                  placeholder="Ask CLAW AI…"
                  style={{
                    flex:1, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(99,102,241,0.3)",
                    borderRadius:8, padding:"7px 10px", color:"#e2e8f0", fontSize:12,
                    outline:"none", fontFamily:"'Georgia',serif"
                  }}
                />
                <button
                  onClick={sendChatMessage}
                  disabled={chatLoading || !chatInput.trim()}
                  style={{
                    background:"linear-gradient(135deg,#4f46e5,#0891b2)",
                    border:"none", borderRadius:8, cursor:"pointer",
                    padding:"7px 12px", color:"#fff", fontSize:12,
                    opacity: (chatLoading || !chatInput.trim()) ? 0.5 : 1
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}


/* Thu Jul 16 20:06:34 -03 2026 */
